//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AhauOpenAPI {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    accountsGet(id: number): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsGet(_response);
        });
    }

    protected processAccountsGet(response: Response): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    accountsUpdate(id: number, body: UpdateAccountInputDto): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsUpdate(_response);
        });
    }

    protected processAccountsUpdate(response: Response): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    accountsDelete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsDelete(_response);
        });
    }

    protected processAccountsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    accountsGetAll(): Promise<AccountInfoDtoIListResult> {
        let url_ = this.baseUrl + "/api/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsGetAll(_response);
        });
    }

    protected processAccountsGetAll(response: Response): Promise<AccountInfoDtoIListResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDtoIListResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDtoIListResult>(null as any);
    }

    /**
     * @return Success
     */
    accountsCreate(body: CreateAccountInputDto): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsCreate(_response);
        });
    }

    protected processAccountsCreate(response: Response): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    accountsGetState(id: number): Promise<GetAccountStateOutput> {
        let url_ = this.baseUrl + "/api/accounts/{id}/state";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsGetState(_response);
        });
    }

    protected processAccountsGetState(response: Response): Promise<GetAccountStateOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountStateOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountStateOutput>(null as any);
    }

    /**
     * @return Success
     */
    accountsGetConnection(id: number): Promise<ConnectionSettingsOutputDto> {
        let url_ = this.baseUrl + "/api/accounts/{id}/connection";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsGetConnection(_response);
        });
    }

    protected processAccountsGetConnection(response: Response): Promise<ConnectionSettingsOutputDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectionSettingsOutputDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectionSettingsOutputDto>(null as any);
    }

    /**
     * @return Success
     */
    accountsUpdateConnection(id: number, body: ConnectionSettingsInputDto): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}/connection";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsUpdateConnection(_response);
        });
    }

    protected processAccountsUpdateConnection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns data required to create a new account
     * @return Success
     */
    accountsGetAccountCreateData(): Promise<AccountCreateDataDto> {
        let url_ = this.baseUrl + "/api/accounts/createData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsGetAccountCreateData(_response);
        });
    }

    protected processAccountsGetAccountCreateData(response: Response): Promise<AccountCreateDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountCreateDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountCreateDataDto>(null as any);
    }

    /**
     * Verifies account connection settings
     * @param body (optional) Settings to verify. If empty the current settings will be verified
     * @return Success
     */
    accountsVerifyConnection(id: number, body: ConnectionSettingsInputDto | undefined): Promise<VerifyAccountConnectionOutputDto> {
        let url_ = this.baseUrl + "/api/accounts/{id}/connection/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsVerifyConnection(_response);
        });
    }

    protected processAccountsVerifyConnection(response: Response): Promise<VerifyAccountConnectionOutputDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyAccountConnectionOutputDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyAccountConnectionOutputDto>(null as any);
    }

    /**
     * @return Success
     */
    accountsVerifyUrl(body: VerifyUrlInputDto): Promise<VerifyUrlOutputDto> {
        let url_ = this.baseUrl + "/api/accounts/verifyUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsVerifyUrl(_response);
        });
    }

    protected processAccountsVerifyUrl(response: Response): Promise<VerifyUrlOutputDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyUrlOutputDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyUrlOutputDto>(null as any);
    }

    /**
     * Updates account url. Should be used only for specific reasons. For
     * @return Success
     */
    accountsUpdateUrl(id: number, body: UpdateUrlInputDto): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/accounts/{id}/updateUrl";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccountsUpdateUrl(_response);
        });
    }

    protected processAccountsUpdateUrl(response: Response): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    serviceAuthAuthorizeAccount(id: number, returnUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/serviceAuth/account/{id}/authorize?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthAuthorizeAccount(_response);
        });
    }

    protected processServiceAuthAuthorizeAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    serviceAuthAuthorizeAccount2(id: number, returnUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}/authorize?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthAuthorizeAccount2(_response);
        });
    }

    protected processServiceAuthAuthorizeAccount2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    serviceAuthVerifyAuthorize(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/serviceAuth/account/{id}/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthVerifyAuthorize(_response);
        });
    }

    protected processServiceAuthVerifyAuthorize(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    serviceAuthVerifyAuthorize2(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthVerifyAuthorize2(_response);
        });
    }

    protected processServiceAuthVerifyAuthorize2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    serviceAuthSignOutAccount(id: number, returnUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/serviceAuth/account/{id}/signOut?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthSignOutAccount(_response);
        });
    }

    protected processServiceAuthSignOutAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    serviceAuthSignOutAccount2(id: number, returnUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{id}/signOut?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceAuthSignOutAccount2(_response);
        });
    }

    protected processServiceAuthSignOutAccount2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchAction(id: string, body: ActivityDispatchActionInput): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchAction(_response);
        });
    }

    protected processActivityDispatchAction(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchPostMessage(id: string, body: PostMessageRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/postmessage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchPostMessage(_response);
        });
    }

    protected processActivityDispatchPostMessage(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchDatesAccess(id: string): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/ep/dates-access";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchDatesAccess(_response);
        });
    }

    protected processActivityDispatchDatesAccess(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchCalculateActivityDates(id: string, body: CalculateActivityDatesRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/ep/calculate-dates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchCalculateActivityDates(_response);
        });
    }

    protected processActivityDispatchCalculateActivityDates(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchSchedule(id: string): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/schedule";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchSchedule(_response);
        });
    }

    protected processActivityDispatchSchedule(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchDeleteTimeEntryPost(id: string, body: DeleteTimeEntryRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/deletetimeentry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchDeleteTimeEntryPost(_response);
        });
    }

    protected processActivityDispatchDeleteTimeEntryPost(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchPostTimeEntry(id: string, body: PostTimeEntryRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/posttimeentry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchPostTimeEntry(_response);
        });
    }

    protected processActivityDispatchPostTimeEntry(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchSetDates(id: string, body: SetDatesRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/setdates";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchSetDates(_response);
        });
    }

    protected processActivityDispatchSetDates(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchUpdateDescription(id: string, body: UpdateDescriptionRequest): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/updatedescription";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchUpdateDescription(_response);
        });
    }

    protected processActivityDispatchUpdateDescription(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @return Success
     */
    activityDispatchSetDone(id: string): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/done";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchSetDone(_response);
        });
    }

    protected processActivityDispatchSetDone(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    activityDispatchUpload(id: string, file: FileParameter | undefined): Promise<ActivityDispatchActionResult> {
        let url_ = this.baseUrl + "/api/activities/{id}/dispatch/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDispatchUpload(_response);
        });
    }

    protected processActivityDispatchUpload(response: Response): Promise<ActivityDispatchActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDispatchActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDispatchActionResult>(null as any);
    }

    /**
     * Creates an activity
     * @return Success
     */
    activityCreate(body: CreateUpdateActivityInputDto): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityCreate(_response);
        });
    }

    protected processActivityCreate(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(null as any);
    }

    /**
     * Loads the deafult values to create a new activity
     * @return Success
     */
    activityLoadCreateDefaults(body: GetNewActivityInputDto): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/activities/defaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityLoadCreateDefaults(_response);
        });
    }

    protected processActivityLoadCreateDefaults(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(null as any);
    }

    /**
     * Gets data for a new activity creation form.
     * @return Success
     */
    activityLoadCreateData(body: GetActivityEditDataRequestDto): Promise<ActivityEditDataDto> {
        let url_ = this.baseUrl + "/api/activities/createData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityLoadCreateData(_response);
        });
    }

    protected processActivityLoadCreateData(response: Response): Promise<ActivityEditDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityEditDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEditDataDto>(null as any);
    }

    /**
     * Gets data for an activity edit form.
     * @param body (optional) 
     * @return Success
     */
    activityLoadEditData(id: string, body: GetActivityEditDataRequestDto | undefined): Promise<ActivityEditDataDto> {
        let url_ = this.baseUrl + "/api/activities/{id}/editData";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityLoadEditData(_response);
        });
    }

    protected processActivityLoadEditData(response: Response): Promise<ActivityEditDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityEditDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityEditDataDto>(null as any);
    }

    /**
     * Prepares client upload (authorization headers, etc)
     * @return Success
     */
    activityPrepareUpload(id: string): Promise<PrepareAttachmentResponse> {
        let url_ = this.baseUrl + "/api/activities/{id}/prepareUpload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityPrepareUpload(_response);
        });
    }

    protected processActivityPrepareUpload(response: Response): Promise<PrepareAttachmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrepareAttachmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrepareAttachmentResponse>(null as any);
    }

    /**
     * Gets the activity info by the id
     * @return Success
     */
    activityGet(id: string): Promise<ActivityLookupItem> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityGet(_response);
        });
    }

    protected processActivityGet(response: Response): Promise<ActivityLookupItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityLookupItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem>(null as any);
    }

    /**
     * Updates activity
     * @return Success
     */
    activityUpdate(id: string, body: CreateUpdateActivityInputDto): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityUpdate(_response);
        });
    }

    protected processActivityUpdate(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(null as any);
    }

    /**
     * @return Success
     */
    activityMyActivities(accountId: number): Promise<ActivityLookupItem[]> {
        let url_ = this.baseUrl + "/api/activities/myActivities?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityMyActivities(_response);
        });
    }

    protected processActivityMyActivities(response: Response): Promise<ActivityLookupItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLookupItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    activityMyActivitiesForProject(projectId: string | undefined): Promise<ActivityLookupItem[]> {
        let url_ = this.baseUrl + "/api/activities/myProjectActivities?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityMyActivitiesForProject(_response);
        });
    }

    protected processActivityMyActivitiesForProject(response: Response): Promise<ActivityLookupItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLookupItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem[]>(null as any);
    }

    /**
     * Finds an activity using common filters
     * @return Success
     */
    activityFindBy(body: ActivityFindByInput): Promise<ActivityLookupItem> {
        let url_ = this.baseUrl + "/api/activities/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityFindBy(_response);
        });
    }

    protected processActivityFindBy(response: Response): Promise<ActivityLookupItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityLookupItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem>(null as any);
    }

    /**
     * Loads a related activity data
     * @return Success
     */
    activityGetData(id: string): Promise<ActivityData> {
        let url_ = this.baseUrl + "/api/activities/{id}/data";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityGetData(_response);
        });
    }

    protected processActivityGetData(response: Response): Promise<ActivityData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityData>(null as any);
    }

    /**
     * Get system lists for activity
     * @param projectId The project id
     * @param trackerId (optional) The tracker id
     * @return Success
     */
    listsGetLists(projectId: string, trackerId: string | undefined): Promise<ListsDto> {
        let url_ = this.baseUrl + "/api/lists/activityLists/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trackerId === null)
            throw new Error("The parameter 'trackerId' cannot be null.");
        else if (trackerId !== undefined)
            url_ += "trackerId=" + encodeURIComponent("" + trackerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListsGetLists(_response);
        });
    }

    protected processListsGetLists(response: Response): Promise<ListsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListsDto>(null as any);
    }

    /**
     * @return Success
     */
    projectsLookup(body: LookupRequestInput): Promise<ProjectLookupItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/projects/lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsLookup(_response);
        });
    }

    protected processProjectsLookup(response: Response): Promise<ProjectLookupItemPagedResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectLookupItemPagedResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectLookupItemPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    projectsLookup2(body: LookupRequestInput): Promise<ProjectLookupItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsLookup2(_response);
        });
    }

    protected processProjectsLookup2(response: Response): Promise<ProjectLookupItemPagedResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectLookupItemPagedResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectLookupItemPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    projectsGet(id: string): Promise<ProjectLookupItem> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsGet(_response);
        });
    }

    protected processProjectsGet(response: Response): Promise<ProjectLookupItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectLookupItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectLookupItem>(null as any);
    }

    /**
     * @return Success
     */
    projectsFindBy(body: ProjectFindByInput): Promise<ProjectLookupItem> {
        let url_ = this.baseUrl + "/api/projects/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProjectsFindBy(_response);
        });
    }

    protected processProjectsFindBy(response: Response): Promise<ProjectLookupItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectLookupItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectLookupItem>(null as any);
    }

    /**
     * Get list of time entry activities allowed for the project
     * @param projectId The project id
     * @return Success
     */
    timeEntryGetTimeEntryActivities(projectId: string): Promise<TimeEntryActivityDto[]> {
        let url_ = this.baseUrl + "/api/timeentries/activities/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimeEntryGetTimeEntryActivities(_response);
        });
    }

    protected processTimeEntryGetTimeEntryActivities(response: Response): Promise<TimeEntryActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeEntryActivityDto[]>(null as any);
    }

    /**
     * Accept exchange token, validate it.
    If valid and tenant exists returns infos
     * @return Success
     */
    spaAuthGetPreSignInInfo(body: AuthTokensInput): Promise<SignInInfoResult> {
        let url_ = this.baseUrl + "/api/SpaAuth/GetPreSignInInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpaAuthGetPreSignInInfo(_response);
        });
    }

    protected processSpaAuthGetPreSignInInfo(response: Response): Promise<SignInInfoResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignInInfoResult>(null as any);
    }

    /**
     * @return Success
     */
    spaAuthDeleteMe(): Promise<void> {
        let url_ = this.baseUrl + "/api/SpaAuth/DeleteMe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSpaAuthDeleteMe(_response);
        });
    }

    protected processSpaAuthDeleteMe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    demoUserRegisteredCallback(): Promise<void> {
        let url_ = this.baseUrl + "/api/demo/callback/userCreated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDemoUserRegisteredCallback(_response);
        });
    }

    protected processDemoUserRegisteredCallback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    demoCreateDemoAccount(): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/demo/createDemoAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDemoCreateDemoAccount(_response);
        });
    }

    protected processDemoCreateDemoAccount(response: Response): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    /**
     * Just throw an server error
     */
    helpAndSupportThrowAnError(): Promise<void> {
        let url_ = this.baseUrl + "/api/HelpAndSupport/ThrowAnError";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHelpAndSupportThrowAnError(_response);
        });
    }

    protected processHelpAndSupportThrowAnError(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Just throw an server error
     */
    helpAndSupportTestSelfRequest(): Promise<void> {
        let url_ = this.baseUrl + "/api/HelpAndSupport/TestSelfRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHelpAndSupportTestSelfRequest(_response);
        });
    }

    protected processHelpAndSupportTestSelfRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Just throw an validation error
     */
    helpAndSupportThrowAnValidationError(): Promise<void> {
        let url_ = this.baseUrl + "/api/HelpAndSupport/ThrowAnValidationError";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHelpAndSupportThrowAnValidationError(_response);
        });
    }

    protected processHelpAndSupportThrowAnValidationError(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    helpAndSupportCreateSupportTicket(body: CreateSupportTicketInput): Promise<void> {
        let url_ = this.baseUrl + "/api/HelpAndSupport/CreateSupportTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHelpAndSupportCreateSupportTicket(_response);
        });
    }

    protected processHelpAndSupportCreateSupportTicket(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    licensingGetLicenseInfo(): Promise<LicenseInfoDto> {
        let url_ = this.baseUrl + "/api/Licensing/GetLicenseInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicensingGetLicenseInfo(_response);
        });
    }

    protected processLicensingGetLicenseInfo(response: Response): Promise<LicenseInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    licensingActivateSerialNumber(body: string): Promise<LicenseInfoDto> {
        let url_ = this.baseUrl + "/api/Licensing/ActivateSerialNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicensingActivateSerialNumber(_response);
        });
    }

    protected processLicensingActivateSerialNumber(response: Response): Promise<LicenseInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    sessionLoad(): Promise<GetSessionOutput> {
        let url_ = this.baseUrl + "/api/Session/Load";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSessionLoad(_response);
        });
    }

    protected processSessionLoad(response: Response): Promise<GetSessionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSessionOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSessionOutput>(null as any);
    }

    /**
     * @return Success
     */
    botPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBotPost(_response);
        });
    }

    protected processBotPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets list of global checklists.
    Ordered by creation time.
     * @param refId (optional) 
     * @return Success
     */
    checklistsGetChecklists(refId: string | undefined): Promise<Checklist[]> {
        let url_ = this.baseUrl + "/api/checklists?";
        if (refId === null)
            throw new Error("The parameter 'refId' cannot be null.");
        else if (refId !== undefined)
            url_ += "refId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsGetChecklists(_response);
        });
    }

    protected processChecklistsGetChecklists(response: Response): Promise<Checklist[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Checklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Checklist[]>(null as any);
    }

    /**
     * Creates a new checklist with items.
     * @param body (optional) 
     * @return Created
     */
    checklistsPostChecklist(body: Checklist | undefined): Promise<Checklist> {
        let url_ = this.baseUrl + "/api/checklists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsPostChecklist(_response);
        });
    }

    protected processChecklistsPostChecklist(response: Response): Promise<Checklist> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Checklist.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Checklist>(null as any);
    }

    /**
     * Gets the checklist by id.
     * @return Success
     */
    checklistsGetChecklist(id: string): Promise<Checklist> {
        let url_ = this.baseUrl + "/api/checklists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsGetChecklist(_response);
        });
    }

    protected processChecklistsGetChecklist(response: Response): Promise<Checklist> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Checklist.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Checklist>(null as any);
    }

    /**
     * Updated the checklist. Items are replaced.
     * @return Success
     */
    checklistsPutChecklist(id: string, body: Checklist): Promise<Checklist> {
        let url_ = this.baseUrl + "/api/checklists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsPutChecklist(_response);
        });
    }

    protected processChecklistsPutChecklist(response: Response): Promise<Checklist> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Checklist.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Checklist>(null as any);
    }

    /**
     * Deletes the checklist with all items
     * @return No Content
     */
    checklistsDeleteChecklist(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/checklists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsDeleteChecklist(_response);
        });
    }

    protected processChecklistsDeleteChecklist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set order keys on the checklists.
     * @return Success
     */
    checklistsSetChecklistOrder(body: { [key: string]: number; }): Promise<Checklist[]> {
        let url_ = this.baseUrl + "/api/checklists/setOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistsSetChecklistOrder(_response);
        });
    }

    protected processChecklistsSetChecklistOrder(response: Response): Promise<Checklist[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Checklist.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Checklist[]>(null as any);
    }

    /**
     * Gets checklist templates list
     * @return Success
     */
    checklistTemplatesGetChecklistTemplates(): Promise<ChecklistTemplate[]> {
        let url_ = this.baseUrl + "/api/checklists/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesGetChecklistTemplates(_response);
        });
    }

    protected processChecklistTemplatesGetChecklistTemplates(response: Response): Promise<ChecklistTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistTemplate[]>(null as any);
    }

    /**
     * Creates a new template with items.
     * @return Created
     */
    checklistTemplatesPostChecklistTemplate(body: ChecklistTemplate): Promise<ChecklistTemplate> {
        let url_ = this.baseUrl + "/api/checklists/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesPostChecklistTemplate(_response);
        });
    }

    protected processChecklistTemplatesPostChecklistTemplate(response: Response): Promise<ChecklistTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ChecklistTemplate.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistTemplate>(null as any);
    }

    /**
     * Gets the template by id.
     * @return Success
     */
    checklistTemplatesGetChecklistTemplate(id: string): Promise<ChecklistTemplate> {
        let url_ = this.baseUrl + "/api/checklists/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesGetChecklistTemplate(_response);
        });
    }

    protected processChecklistTemplatesGetChecklistTemplate(response: Response): Promise<ChecklistTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChecklistTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistTemplate>(null as any);
    }

    /**
     * Updated the template. Items are replaced.
     * @return Success
     */
    checklistTemplatesPutChecklistTemplate(id: string, body: ChecklistTemplate): Promise<ChecklistTemplate> {
        let url_ = this.baseUrl + "/api/checklists/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesPutChecklistTemplate(_response);
        });
    }

    protected processChecklistTemplatesPutChecklistTemplate(response: Response): Promise<ChecklistTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChecklistTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistTemplate>(null as any);
    }

    /**
     * Deletes the templates with all items
     * @return No Content
     */
    checklistTemplatesDeleteChecklistTemplate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/checklists/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesDeleteChecklistTemplate(_response);
        });
    }

    protected processChecklistTemplatesDeleteChecklistTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set order keys on the templates.
     * @return Success
     */
    checklistTemplatesSetChecklistTemplateOrder(body: { [key: string]: number; }): Promise<ChecklistTemplate[]> {
        let url_ = this.baseUrl + "/api/checklists/templates/setOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChecklistTemplatesSetChecklistTemplateOrder(_response);
        });
    }

    protected processChecklistTemplatesSetChecklistTemplateOrder(response: Response): Promise<ChecklistTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistTemplate[]>(null as any);
    }

    /**
     * Used by Outlook365 addin to get message details
     * @return Success
     */
    office365GetMessage(body: GetMessageDto): Promise<MessageDto> {
        let url_ = this.baseUrl + "/api/office365/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOffice365GetMessage(_response);
        });
    }

    protected processOffice365GetMessage(response: Response): Promise<MessageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDto>(null as any);
    }

    /**
     * Used by Outlook365 addin to download file from Outlook service using Graph API and provided token
     * @return Success
     */
    office365GetAttachment(body: GetAttachmentDto): Promise<void> {
        let url_ = this.baseUrl + "/api/office365/attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOffice365GetAttachment(_response);
        });
    }

    protected processOffice365GetAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets favorite activities list
     * @return Success
     */
    favoritesGetFavoriteActivities(): Promise<ActivityLookupItem[]> {
        let url_ = this.baseUrl + "/api/favorites/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavoritesGetFavoriteActivities(_response);
        });
    }

    protected processFavoritesGetFavoriteActivities(response: Response): Promise<ActivityLookupItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLookupItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem[]>(null as any);
    }

    /**
     * Sets activity as favorite
     * @return Success
     */
    favoritesSetFavorite(id: string): Promise<ActivityLookupItem[]> {
        let url_ = this.baseUrl + "/api/favorites/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavoritesSetFavorite(_response);
        });
    }

    protected processFavoritesSetFavorite(response: Response): Promise<ActivityLookupItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLookupItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem[]>(null as any);
    }

    /**
     * Unsets activity as favorite
     * @return Success
     */
    favoritesUnsetFavorite(id: string): Promise<ActivityLookupItem[]> {
        let url_ = this.baseUrl + "/api/favorites/activities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavoritesUnsetFavorite(_response);
        });
    }

    protected processFavoritesUnsetFavorite(response: Response): Promise<ActivityLookupItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLookupItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLookupItem[]>(null as any);
    }

    /**
     * @return Success
     */
    linksGetItem(id: string): Promise<ItemDataDto> {
        let url_ = this.baseUrl + "/api/links/item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksGetItem(_response);
        });
    }

    protected processLinksGetItem(response: Response): Promise<ItemDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemDataDto>(null as any);
    }

    /**
     * @return Success
     */
    linksIdentifyItem(body: PaneItemIdentity): Promise<string> {
        let url_ = this.baseUrl + "/api/links/item/identify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksIdentifyItem(_response);
        });
    }

    protected processLinksIdentifyItem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return No Content
     */
    linksAddLink(fromRef: string, targetRef: string): Promise<void> {
        let url_ = this.baseUrl + "/api/links/item/{fromRef}/link?";
        if (fromRef === undefined || fromRef === null)
            throw new Error("The parameter 'fromRef' must be defined.");
        url_ = url_.replace("{fromRef}", encodeURIComponent("" + fromRef));
        if (targetRef === undefined || targetRef === null)
            throw new Error("The parameter 'targetRef' must be defined and cannot be null.");
        else
            url_ += "targetRef=" + encodeURIComponent("" + targetRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksAddLink(_response);
        });
    }

    protected processLinksAddLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    linksRemoveLink(fromRef: string, targetRef: string): Promise<void> {
        let url_ = this.baseUrl + "/api/links/item/{fromRef}/unlink?";
        if (fromRef === undefined || fromRef === null)
            throw new Error("The parameter 'fromRef' must be defined.");
        url_ = url_.replace("{fromRef}", encodeURIComponent("" + fromRef));
        if (targetRef === undefined || targetRef === null)
            throw new Error("The parameter 'targetRef' must be defined and cannot be null.");
        else
            url_ += "targetRef=" + encodeURIComponent("" + targetRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksRemoveLink(_response);
        });
    }

    protected processLinksRemoveLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    linksFindBy(keys: Keys): Promise<ItemDataDto[]> {
        let url_ = this.baseUrl + "/api/links/item/findBy?";
        if (keys === undefined || keys === null)
            throw new Error("The parameter 'keys' must be defined and cannot be null.");
        else
            url_ += "keys=" + encodeURIComponent("" + keys) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksFindBy(_response);
        });
    }

    protected processLinksFindBy(response: Response): Promise<ItemDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemDataDto[]>(null as any);
    }

    /**
     * Loads all linked items related with specified ItemRef
     * @return Success
     */
    linksLoadLinks(id: string): Promise<ItemDataDto[]> {
        let url_ = this.baseUrl + "/api/links/item/{id}/links";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksLoadLinks(_response);
        });
    }

    protected processLinksLoadLinks(response: Response): Promise<ItemDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemDataDto[]>(null as any);
    }

    /**
     * Loads a pane data using identity data.
    Indetify of creates an ItemRef using a pane identity info.
    Load a related info need to show a pane item form.
     * @return Success
     */
    linksGetPaneData(id: string): Promise<PaneData> {
        let url_ = this.baseUrl + "/pane/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksGetPaneData(_response);
        });
    }

    protected processLinksGetPaneData(response: Response): Promise<PaneData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaneData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaneData>(null as any);
    }

    /**
     * Sync and load more data for items.
     * @return Success
     */
    linksGetMoreItemData(id: string): Promise<PaneData> {
        let url_ = this.baseUrl + "/pane/data/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksGetMoreItemData(_response);
        });
    }

    protected processLinksGetMoreItemData(response: Response): Promise<PaneData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaneData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaneData>(null as any);
    }

    /**
     * Loads a pane data using identity data.
    Indetify of creates an ItemRef using a pane identity info.
    Load a related info need to show a pane item form.
     * @return Success
     */
    linksLoadPane(body: PaneItemIdentity): Promise<PaneData> {
        let url_ = this.baseUrl + "/pane";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksLoadPane(_response);
        });
    }

    protected processLinksLoadPane(response: Response): Promise<PaneData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaneData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaneData>(null as any);
    }

    /**
     * Search for the related item rewfs by the query string.
    TODO: Not used now by the requirements.
     * @return Success
     */
    linksQueryItems(q: string): Promise<ItemDataDto[]> {
        let url_ = this.baseUrl + "/pane/query?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLinksQueryItems(_response);
        });
    }

    protected processLinksQueryItems(response: Response): Promise<ItemDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemDataDto[]>(null as any);
    }

    /**
     * @return Success
     */
    lookupTypeahead(body: TypeaheadInput): Promise<TypeaheadResponse> {
        let url_ = this.baseUrl + "/api/typeahead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLookupTypeahead(_response);
        });
    }

    protected processLookupTypeahead(response: Response): Promise<TypeaheadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeaheadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypeaheadResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lookupTypeaheadByAccount(accountId: number, body: TypeaheadInput | undefined): Promise<TypeaheadResponse> {
        let url_ = this.baseUrl + "/api/typeahead/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLookupTypeaheadByAccount(_response);
        });
    }

    protected processLookupTypeaheadByAccount(response: Response): Promise<TypeaheadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeaheadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypeaheadResponse>(null as any);
    }

    /**
     * Gets activities list. Supports filters and paging
     * @return Success
     * @deprecated
     */
    lookupLookup(body: LookupRequestInput): Promise<TypeaheadResponse> {
        let url_ = this.baseUrl + "/api/lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLookupLookup(_response);
        });
    }

    protected processLookupLookup(response: Response): Promise<TypeaheadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeaheadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypeaheadResponse>(null as any);
    }

    /**
     * @return Success
     */
    membershipsGetOrganizations(): Promise<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/memberships/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsGetOrganizations(_response);
        });
    }

    protected processMembershipsGetOrganizations(response: Response): Promise<OrganizationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto[]>(null as any);
    }

    /**
     * @return Created
     */
    membershipsCreateOrganization(body: OrganizationInputDto): Promise<OrganizationDto> {
        let url_ = this.baseUrl + "/api/memberships/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsCreateOrganization(_response);
        });
    }

    protected processMembershipsCreateOrganization(response: Response): Promise<OrganizationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto>(null as any);
    }

    /**
     * @return Success
     */
    membershipsGetOrganizationDetails(organizationId: number): Promise<OrganizationDetailsDto> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsGetOrganizationDetails(_response);
        });
    }

    protected processMembershipsGetOrganizationDetails(response: Response): Promise<OrganizationDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDetailsDto>(null as any);
    }

    /**
     * @return Success
     */
    membershipsDeleteOrganization(organizationId: number): Promise<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsDeleteOrganization(_response);
        });
    }

    protected processMembershipsDeleteOrganization(response: Response): Promise<OrganizationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDto[]>(null as any);
    }

    /**
     * @return Created
     */
    membershipsCreateTeam(organizationId: number, body: TeamInputDto): Promise<TeamDto> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsCreateTeam(_response);
        });
    }

    protected processMembershipsCreateTeam(response: Response): Promise<TeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto>(null as any);
    }

    /**
     * @return Success
     */
    membershipsGetTeamsByOrganization(organizationId: number): Promise<TeamDto[]> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsGetTeamsByOrganization(_response);
        });
    }

    protected processMembershipsGetTeamsByOrganization(response: Response): Promise<TeamDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto[]>(null as any);
    }

    /**
     * @return Created
     */
    membershipsInviteToOrganization(organizationId: number, body: InviteInputDto): Promise<OrganizationInvite> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/invite";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsInviteToOrganization(_response);
        });
    }

    protected processMembershipsInviteToOrganization(response: Response): Promise<OrganizationInvite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganizationInvite.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationInvite>(null as any);
    }

    /**
     * @return Success
     */
    membershipsDeleteInviteToOrganization(token: string): Promise<OrganizationInvite> {
        let url_ = this.baseUrl + "/api/memberships/invite/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsDeleteInviteToOrganization(_response);
        });
    }

    protected processMembershipsDeleteInviteToOrganization(response: Response): Promise<OrganizationInvite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationInvite.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationInvite>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    membershipsUpdateInviteToOrganization(organizationId: number, token: string, body: InviteInputDto | undefined): Promise<OrganizationInvite> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/invite/{token}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsUpdateInviteToOrganization(_response);
        });
    }

    protected processMembershipsUpdateInviteToOrganization(response: Response): Promise<OrganizationInvite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationInvite.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationInvite>(null as any);
    }

    /**
     * @return Created
     */
    membershipsInvitesToOrganization(organizationId: number, body: InviteInputDto[]): Promise<OrganizationInvite[]> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/invites";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsInvitesToOrganization(_response);
        });
    }

    protected processMembershipsInvitesToOrganization(response: Response): Promise<OrganizationInvite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(OrganizationInvite.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationInvite[]>(null as any);
    }

    /**
     * @return Success
     */
    membershipsAcceptInviteToOrganization(token: string): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/invite/{token}/accept";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsAcceptInviteToOrganization(_response);
        });
    }

    protected processMembershipsAcceptInviteToOrganization(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    membershipsRemoveInviteToOrganization(token: string): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/invite/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsRemoveInviteToOrganization(_response);
        });
    }

    protected processMembershipsRemoveInviteToOrganization(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    membershipsGetTeams(): Promise<TeamDto[]> {
        let url_ = this.baseUrl + "/api/memberships/teams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsGetTeams(_response);
        });
    }

    protected processMembershipsGetTeams(response: Response): Promise<TeamDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    membershipsAddToTeam(organizationId: number, teamId: number, userId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams/{teamId}/members?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsAddToTeam(_response);
        });
    }

    protected processMembershipsAddToTeam(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    membershipsRemoveFromTeam(organizationId: number, teamId: number, userId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams/{teamId}/members?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsRemoveFromTeam(_response);
        });
    }

    protected processMembershipsRemoveFromTeam(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    membershipsUpdateTeam(organizationId: number, id: number, body: TeamInputDto | undefined): Promise<TeamDto> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams/{id}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsUpdateTeam(_response);
        });
    }

    protected processMembershipsUpdateTeam(response: Response): Promise<TeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto>(null as any);
    }

    /**
     * @return Success
     */
    membershipsDeleteTeam(organizationId: number, id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/teams/{id}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsDeleteTeam(_response);
        });
    }

    protected processMembershipsDeleteTeam(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    membershipsGetOrganizationMembers(organizationId: number): Promise<MemberDto[]> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/members";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsGetOrganizationMembers(_response);
        });
    }

    protected processMembershipsGetOrganizationMembers(response: Response): Promise<MemberDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    membershipsUpdateOrganizationMembers(organizationId: number, body: MemberDto | undefined): Promise<MemberDto> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/members";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsUpdateOrganizationMembers(_response);
        });
    }

    protected processMembershipsUpdateOrganizationMembers(response: Response): Promise<MemberDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    membershipsDeleteOrganizationMembers(organizationId: number, body: MemberDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/memberships/organizations/{organizationId}/members";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMembershipsDeleteOrganizationMembers(_response);
        });
    }

    protected processMembershipsDeleteOrganizationMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets manifest with host environment.
     * @return Success
     */
    settingsGetHostEnv(): Promise<HostManifest> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsGetHostEnv(_response);
        });
    }

    protected processSettingsGetHostEnv(response: Response): Promise<HostManifest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostManifest.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HostManifest>(null as any);
    }

    /**
     * Get settings for the default account
     * @return Success
     */
    settingsGetUserSettings(): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/settings/userSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsGetUserSettings(_response);
        });
    }

    protected processSettingsGetUserSettings(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }

    /**
     * Update user settings
     * @return Success
     */
    settingsUpdateUserSettings(body: UserSettings): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/settings/userSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsUpdateUserSettings(_response);
        });
    }

    protected processSettingsUpdateUserSettings(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }

    /**
     * Get settings for the default account
     * @return Success
     */
    settingsGetDefault(): Promise<AccountSettings> {
        let url_ = this.baseUrl + "/api/settings/accountSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsGetDefault(_response);
        });
    }

    protected processSettingsGetDefault(response: Response): Promise<AccountSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings>(null as any);
    }

    /**
     * Updates settings for the default account
     * @return Success
     */
    settingsUpdateDefault(body: AccountSettings): Promise<AccountSettings> {
        let url_ = this.baseUrl + "/api/settings/accountSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsUpdateDefault(_response);
        });
    }

    protected processSettingsUpdateDefault(response: Response): Promise<AccountSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings>(null as any);
    }

    /**
     * Get settings for th specified account
     * @return Success
     */
    settingsGet(accountId: number): Promise<AccountSettings> {
        let url_ = this.baseUrl + "/api/settings/accountSettings/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsGet(_response);
        });
    }

    protected processSettingsGet(response: Response): Promise<AccountSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings>(null as any);
    }

    /**
     * Updates settings for the specified account
     * @return Success
     */
    settingsUpdate(accountId: number, body: AccountSettings): Promise<AccountSettings> {
        let url_ = this.baseUrl + "/api/settings/accountSettings/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsUpdate(_response);
        });
    }

    protected processSettingsUpdate(response: Response): Promise<AccountSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings>(null as any);
    }

    /**
     * Get settings for th specified account
     * @return Success
     */
    settingsGetFormData(accountId: number): Promise<AccountSettingsFormData> {
        let url_ = this.baseUrl + "/api/settings/accountSettings/{accountId}/formData";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettingsGetFormData(_response);
        });
    }

    protected processSettingsGetFormData(response: Response): Promise<AccountSettingsFormData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSettingsFormData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettingsFormData>(null as any);
    }

    /**
     * Process account sync and wait until finished.
     * @return Success
     */
    syncDoSync(id: number): Promise<SyncStateInfo> {
        let url_ = this.baseUrl + "/api/sync/account/{id}/sync";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncDoSync(_response);
        });
    }

    protected processSyncDoSync(response: Response): Promise<SyncStateInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncStateInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncStateInfo>(null as any);
    }

    /**
     * Enqueue account sync in backgroud.
     * @param id accountId
     * @return Success
     */
    syncEnqueueSync(id: number): Promise<SyncStateInfo> {
        let url_ = this.baseUrl + "/api/sync/account/{id}/enqueue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncEnqueueSync(_response);
        });
    }

    protected processSyncEnqueueSync(response: Response): Promise<SyncStateInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncStateInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncStateInfo>(null as any);
    }

    /**
     * Query actual account sync state.
     * @param id accountId
     * @return Success
     */
    syncGetSyncState(id: number): Promise<SyncStateInfo> {
        let url_ = this.baseUrl + "/api/sync/account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncGetSyncState(_response);
        });
    }

    protected processSyncGetSyncState(response: Response): Promise<SyncStateInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncStateInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncStateInfo>(null as any);
    }

    /**
     * @return Success
     */
    syncEnqueueAll(): Promise<void> {
        let url_ = this.baseUrl + "/api/sync/all/enqueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncEnqueueAll(_response);
        });
    }

    protected processSyncEnqueueAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Query timers list.
     * @param refId (optional) Optionally filtered by refId
     * @return Success
     */
    timersGetTimers(refId: string | undefined): Promise<Timer[]> {
        let url_ = this.baseUrl + "/api/timers?";
        if (refId === null)
            throw new Error("The parameter 'refId' cannot be null.");
        else if (refId !== undefined)
            url_ += "refId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersGetTimers(_response);
        });
    }

    protected processTimersGetTimers(response: Response): Promise<Timer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Timer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer[]>(null as any);
    }

    /**
     * Get timer by id.
     * @return Success
     */
    timersGetTimer(id: string): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersGetTimer(_response);
        });
    }

    protected processTimersGetTimer(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Updates timer description, default actvitiy, etc.
     * @param body (optional) 
     * @return Success
     */
    timersPutTimer(id: string, body: Timer | undefined): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersPutTimer(_response);
        });
    }

    protected processTimersPutTimer(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Deletes the timer.
     * @return Success
     */
    timersDeleteTimer(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/timers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersDeleteTimer(_response);
        });
    }

    protected processTimersDeleteTimer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Query the active timer, if any.
     * @return Success
     */
    timersFindRunningTimer(): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/runningTimer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersFindRunningTimer(_response);
        });
    }

    protected processTimersFindRunningTimer(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Creates and start the timer for the specified ItemRef
     * @param body (optional) 
     * @return Success
     */
    timersStartTimerRef(refId: string, body: string | undefined): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/ref/{refId}/start";
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined.");
        url_ = url_.replace("{refId}", encodeURIComponent("" + refId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersStartTimerRef(_response);
        });
    }

    protected processTimersStartTimerRef(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Stops the timer for the specified ItemRef
     * @return Success
     * @deprecated
     */
    timersStopTimerRef(refId: string): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/ref/{refId}/stop";
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined.");
        url_ = url_.replace("{refId}", encodeURIComponent("" + refId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersStopTimerRef(_response);
        });
    }

    protected processTimersStopTimerRef(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Starts the timer. Stops the active timers. Creates a new timer run.
     * @return Success
     */
    timersStartTimer(id: string): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/{id}/start";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersStartTimer(_response);
        });
    }

    protected processTimersStartTimer(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Stops the existing timer by timerId
    Todo:
    set Timer endDate
    set endDate - TimerRun
    calc duration
    posted -> BadRequest
     * @return Success
     */
    timersStopTimer(id: string): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/{id}/stop";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersStopTimer(_response);
        });
    }

    protected processTimersStopTimer(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * Set manual duration for the timer
     * @param id Timer id
     * @param body Total mileseconds
     * @return Success
     */
    timersSetTimerManualDuration(id: string, body: number): Promise<Timer> {
        let url_ = this.baseUrl + "/api/timers/{id}/setDuration";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersSetTimerManualDuration(_response);
        });
    }

    protected processTimersSetTimerManualDuration(response: Response): Promise<Timer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Timer.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Timer>(null as any);
    }

    /**
     * @return Success
     */
    timersDeleteTimerRuns(id: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/timers/{id}/runs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersDeleteTimerRuns(_response);
        });
    }

    protected processTimersDeleteTimerRuns(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    timersUpdateTimerRun(id: string, body: TimerRunRequestDto | undefined): Promise<TimerRun> {
        let url_ = this.baseUrl + "/api/timers/runs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersUpdateTimerRun(_response);
        });
    }

    protected processTimersUpdateTimerRun(response: Response): Promise<TimerRun> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimerRun.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimerRun>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    timersAddTimerRun(id: string, body: TimerRunRequestDto | undefined): Promise<TimerRun> {
        let url_ = this.baseUrl + "/api/timers/{id}/run";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTimersAddTimerRun(_response);
        });
    }

    protected processTimersAddTimerRun(response: Response): Promise<TimerRun> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimerRun.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimerRun>(null as any);
    }

    /**
     * Get workspaces for the organization
     * @param organizationId Id
     * @return Success
     */
    workspacesGetWorkspaces(organizationId: number): Promise<WorkspaceDto[]> {
        let url_ = this.baseUrl + "/api/workspaces?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined and cannot be null.");
        else
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesGetWorkspaces(_response);
        });
    }

    protected processWorkspacesGetWorkspaces(response: Response): Promise<WorkspaceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto[]>(null as any);
    }

    /**
     * Get my workspaces
     * @return Success
     */
    workspacesGetMyWorkspaces(): Promise<WorkspaceDto[]> {
        let url_ = this.baseUrl + "/api/workspaces/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesGetMyWorkspaces(_response);
        });
    }

    protected processWorkspacesGetMyWorkspaces(response: Response): Promise<WorkspaceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto[]>(null as any);
    }

    /**
     * Create my workspace
     * @return Created
     */
    workspacesCreateMyWorkspace(body: MyWorkspaceInputDto): Promise<WorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspaces/my";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesCreateMyWorkspace(_response);
        });
    }

    protected processWorkspacesCreateMyWorkspace(response: Response): Promise<WorkspaceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkspaceDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto>(null as any);
    }

    /**
     * Get workspace
     * @return Success
     */
    workspacesGetWorkspace(workspaceId: string): Promise<WorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesGetWorkspace(_response);
        });
    }

    protected processWorkspacesGetWorkspace(response: Response): Promise<WorkspaceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto>(null as any);
    }

    /**
     * Update workspace
     * @param workspaceId Id
     * @param body Name, team
     * @return Success
     */
    workspacesUpdateWorkspace(workspaceId: string, body: WorkspaceInputDto): Promise<WorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesUpdateWorkspace(_response);
        });
    }

    protected processWorkspacesUpdateWorkspace(response: Response): Promise<WorkspaceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto>(null as any);
    }

    /**
     * Delete workspace
     * @param workspaceId Id
     * @return Success
     */
    workspacesDeleteWorkspace(workspaceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesDeleteWorkspace(_response);
        });
    }

    protected processWorkspacesDeleteWorkspace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create workspace
     * @param organizationId Id
     * @param body Name, team?
     * @return Created
     */
    workspacesCreateWorkspace(organizationId: number, body: WorkspaceInputDto): Promise<WorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspaces/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesCreateWorkspace(_response);
        });
    }

    protected processWorkspacesCreateWorkspace(response: Response): Promise<WorkspaceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkspaceDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceDto>(null as any);
    }

    /**
     * Add itemRef to workspace (linking)
     * @param workspaceId Workspace Id
     * @return No Content
     */
    workspacesAddItemRefToWorkspace(workspaceId: string, refId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}/item?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined and cannot be null.");
        else
            url_ += "refId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesAddItemRefToWorkspace(_response);
        });
    }

    protected processWorkspacesAddItemRefToWorkspace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete itemRef from workspace (unlinking)
     * @param workspaceId Workspace Id
     * @return No Content
     */
    workspacesRemoveItemRefToWorkspace(workspaceId: string, refId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}/item?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined and cannot be null.");
        else
            url_ += "refId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesRemoveItemRefToWorkspace(_response);
        });
    }

    protected processWorkspacesRemoveItemRefToWorkspace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get paneData for workspace (linkedPane)
     * @param workspaceId Workspace Id
     * @return Success
     */
    workspacesGetPaneForWorkspace(workspaceId: string): Promise<PaneData> {
        let url_ = this.baseUrl + "/api/workspaces/{workspaceId}/pane";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWorkspacesGetPaneForWorkspace(_response);
        });
    }

    protected processWorkspacesGetPaneForWorkspace(response: Response): Promise<PaneData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaneData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaneData>(null as any);
    }
}

export enum AccessType {
    ReadOnly = "ReadOnly",
    Mandatory = "Mandatory",
    Optional = "Optional",
    Hidden = "Hidden",
}

export class AccountCreateDataDto implements IAccountCreateDataDto {
    connectors!: ConnectorEditDataDto[];

    constructor(data?: IAccountCreateDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.connectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connectors"])) {
                this.connectors = [] as any;
                for (let item of _data["connectors"])
                    this.connectors!.push(ConnectorEditDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountCreateDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCreateDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectors)) {
            data["connectors"] = [];
            for (let item of this.connectors)
                data["connectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountCreateDataDto {
    connectors: ConnectorEditDataDto[];
}

export class AccountInfo implements IAccountInfo {
    buildVersion?: string | undefined;
    applicationRoot?: string | undefined;
    readonly applicationRootUri?: string;
    company?: string | undefined;
    maxUsersCount?: number | undefined;
    email?: string | undefined;
    serviceProvider?: ServiceProvider;
    userId!: number;
    isDefault!: boolean;
    status?: AccountInfoStatus;
    name?: string | undefined;
    extensionData?: any | undefined;
    creationTime!: Date;
    connectedAsUser?: string | undefined;
    connectedAsUserId?: string | undefined;
    serviceAccountId?: string | undefined;
    settings?: AccountSettings;
    userOptions?: AccountUserOptions;
    syncState?: SyncStateInfo;
    id!: number;

    constructor(data?: IAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildVersion = _data["buildVersion"];
            this.applicationRoot = _data["applicationRoot"];
            (<any>this).applicationRootUri = _data["applicationRootUri"];
            this.company = _data["company"];
            this.maxUsersCount = _data["maxUsersCount"];
            this.email = _data["email"];
            this.serviceProvider = _data["serviceProvider"];
            this.userId = _data["userId"];
            this.isDefault = _data["isDefault"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.extensionData = _data["extensionData"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.connectedAsUser = _data["connectedAsUser"];
            this.connectedAsUserId = _data["connectedAsUserId"];
            this.serviceAccountId = _data["serviceAccountId"];
            this.settings = _data["settings"] ? AccountSettings.fromJS(_data["settings"]) : <any>undefined;
            this.userOptions = _data["userOptions"] ? AccountUserOptions.fromJS(_data["userOptions"]) : <any>undefined;
            this.syncState = _data["syncState"] ? SyncStateInfo.fromJS(_data["syncState"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildVersion"] = this.buildVersion;
        data["applicationRoot"] = this.applicationRoot;
        data["applicationRootUri"] = this.applicationRootUri;
        data["company"] = this.company;
        data["maxUsersCount"] = this.maxUsersCount;
        data["email"] = this.email;
        data["serviceProvider"] = this.serviceProvider;
        data["userId"] = this.userId;
        data["isDefault"] = this.isDefault;
        data["status"] = this.status;
        data["name"] = this.name;
        data["extensionData"] = this.extensionData;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["connectedAsUser"] = this.connectedAsUser;
        data["connectedAsUserId"] = this.connectedAsUserId;
        data["serviceAccountId"] = this.serviceAccountId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["userOptions"] = this.userOptions ? this.userOptions.toJSON() : <any>undefined;
        data["syncState"] = this.syncState ? this.syncState.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAccountInfo {
    buildVersion?: string | undefined;
    applicationRoot?: string | undefined;
    applicationRootUri?: string;
    company?: string | undefined;
    maxUsersCount?: number | undefined;
    email?: string | undefined;
    serviceProvider?: ServiceProvider;
    userId: number;
    isDefault: boolean;
    status?: AccountInfoStatus;
    name?: string | undefined;
    extensionData?: any | undefined;
    creationTime: Date;
    connectedAsUser?: string | undefined;
    connectedAsUserId?: string | undefined;
    serviceAccountId?: string | undefined;
    settings?: AccountSettings;
    userOptions?: AccountUserOptions;
    syncState?: SyncStateInfo;
    id: number;
}

export class AccountInfoDto implements IAccountInfoDto {
    readonly id!: number;
    isDefault!: boolean;
    name?: string;
    serviceProvider?: ServiceProvider;
    isEnterpriseLicense!: boolean;
    buildVersion?: string;
    applicationRoot!: string;
    company?: string;
    email?: string;
    maxUsersCount?: number | undefined;
    connectedAsUser?: string;
    connectionFeatures?: ConnectionFeatures;
    status?: AccountInfoStatus;
    statusReason?: string;
    currentUserClientId?: string;
    settings?: AccountSettings;
    userOptions?: AccountUserOptions;
    connector?: ConnectorEditDataDto;
    extensionData?: AccountInfoExtensionData;

    constructor(data?: IAccountInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            this.serviceProvider = _data["serviceProvider"];
            this.isEnterpriseLicense = _data["isEnterpriseLicense"];
            this.buildVersion = _data["buildVersion"];
            this.applicationRoot = _data["applicationRoot"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.maxUsersCount = _data["maxUsersCount"];
            this.connectedAsUser = _data["connectedAsUser"];
            this.connectionFeatures = _data["connectionFeatures"] ? ConnectionFeatures.fromJS(_data["connectionFeatures"]) : <any>undefined;
            this.status = _data["status"];
            this.statusReason = _data["statusReason"];
            this.currentUserClientId = _data["currentUserClientId"];
            this.settings = _data["settings"] ? AccountSettings.fromJS(_data["settings"]) : <any>undefined;
            this.userOptions = _data["userOptions"] ? AccountUserOptions.fromJS(_data["userOptions"]) : <any>undefined;
            this.connector = _data["connector"] ? ConnectorEditDataDto.fromJS(_data["connector"]) : <any>undefined;
            this.extensionData = _data["extensionData"] ? AccountInfoExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["serviceProvider"] = this.serviceProvider;
        data["isEnterpriseLicense"] = this.isEnterpriseLicense;
        data["buildVersion"] = this.buildVersion;
        data["applicationRoot"] = this.applicationRoot;
        data["company"] = this.company;
        data["email"] = this.email;
        data["maxUsersCount"] = this.maxUsersCount;
        data["connectedAsUser"] = this.connectedAsUser;
        data["connectionFeatures"] = this.connectionFeatures ? this.connectionFeatures.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusReason"] = this.statusReason;
        data["currentUserClientId"] = this.currentUserClientId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["userOptions"] = this.userOptions ? this.userOptions.toJSON() : <any>undefined;
        data["connector"] = this.connector ? this.connector.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountInfoDto {
    id: number;
    isDefault: boolean;
    name?: string;
    serviceProvider?: ServiceProvider;
    isEnterpriseLicense: boolean;
    buildVersion?: string;
    applicationRoot: string;
    company?: string;
    email?: string;
    maxUsersCount?: number | undefined;
    connectedAsUser?: string;
    connectionFeatures?: ConnectionFeatures;
    status?: AccountInfoStatus;
    statusReason?: string;
    currentUserClientId?: string;
    settings?: AccountSettings;
    userOptions?: AccountUserOptions;
    connector?: ConnectorEditDataDto;
    extensionData?: AccountInfoExtensionData;
}

export class AccountInfoDtoIListResult implements IAccountInfoDtoIListResult {
    items?: AccountInfoDto[];

    constructor(data?: IAccountInfoDtoIListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AccountInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountInfoDtoIListResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoDtoIListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountInfoDtoIListResult {
    items?: AccountInfoDto[];
}

export class AccountInfoExtensionData implements IAccountInfoExtensionData {
    connectionSettings?: ConnectionSettings;
    connectionFeatures?: ConnectionFeatures;

    [key: string]: any;

    constructor(data?: IAccountInfoExtensionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.connectionSettings = _data["connectionSettings"] ? ConnectionSettings.fromJS(_data["connectionSettings"]) : <any>undefined;
            this.connectionFeatures = _data["connectionFeatures"] ? ConnectionFeatures.fromJS(_data["connectionFeatures"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountInfoExtensionData {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoExtensionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["connectionSettings"] = this.connectionSettings ? this.connectionSettings.toJSON() : <any>undefined;
        data["connectionFeatures"] = this.connectionFeatures ? this.connectionFeatures.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountInfoExtensionData {
    connectionSettings?: ConnectionSettings;
    connectionFeatures?: ConnectionFeatures;

    [key: string]: any;
}

export enum AccountInfoStatus {
    Unauthorized = "Unauthorized",
    IsFailed = "IsFailed",
    Active = "Active",
    Syncing = "Syncing",
    Deleting = "Deleting",
}

export class AccountSettings implements IAccountSettings {
    workspaceId?: string | undefined;
    defaultProjectId?: string | undefined;
    defaultTrackerId?: string | undefined;
    syncCalendar!: boolean;
    syncChecklists!: boolean;
    searchable!: boolean;

    constructor(data?: IAccountSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.syncCalendar = true;
            this.syncChecklists = true;
            this.searchable = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.defaultProjectId = _data["defaultProjectId"];
            this.defaultTrackerId = _data["defaultTrackerId"];
            this.syncCalendar = _data["syncCalendar"] !== undefined ? _data["syncCalendar"] : true;
            this.syncChecklists = _data["syncChecklists"] !== undefined ? _data["syncChecklists"] : true;
            this.searchable = _data["searchable"] !== undefined ? _data["searchable"] : true;
        }
    }

    static fromJS(data: any): AccountSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["defaultProjectId"] = this.defaultProjectId;
        data["defaultTrackerId"] = this.defaultTrackerId;
        data["syncCalendar"] = this.syncCalendar;
        data["syncChecklists"] = this.syncChecklists;
        data["searchable"] = this.searchable;
        return data;
    }
}

export interface IAccountSettings {
    workspaceId?: string | undefined;
    defaultProjectId?: string | undefined;
    defaultTrackerId?: string | undefined;
    syncCalendar: boolean;
    syncChecklists: boolean;
    searchable: boolean;
}

export class AccountSettingsFormData implements IAccountSettingsFormData {
    settings?: AccountSettings;
    workspaces?: IdNameDto[];

    constructor(data?: IAccountSettingsFormData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settings = _data["settings"] ? AccountSettings.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(IdNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountSettingsFormData {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSettingsFormData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountSettingsFormData {
    settings?: AccountSettings;
    workspaces?: IdNameDto[];
}

export class AccountUserDto implements IAccountUserDto {
    name?: string;
    login?: string | undefined;
    readonly id!: string;
    accountId!: number;
    readonly clientId!: string;
    syncStatus?: SyncEntityStatus;

    constructor(data?: IAccountUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.login = _data["login"];
            (<any>this).id = _data["id"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.syncStatus = _data["syncStatus"];
        }
    }

    static fromJS(data: any): AccountUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["login"] = this.login;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["syncStatus"] = this.syncStatus;
        return data;
    }
}

export interface IAccountUserDto {
    name?: string;
    login?: string | undefined;
    id: string;
    accountId: number;
    clientId: string;
    syncStatus?: SyncEntityStatus;
}

export class AccountUserOptions implements IAccountUserOptions {
    code?: string | undefined;
    color?: string | undefined;
    iconUrl?: string | undefined;
    iconBase64?: string | undefined;

    constructor(data?: IAccountUserOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
            this.iconUrl = _data["iconUrl"];
            this.iconBase64 = _data["iconBase64"];
        }
    }

    static fromJS(data: any): AccountUserOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUserOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        data["iconUrl"] = this.iconUrl;
        data["iconBase64"] = this.iconBase64;
        return data;
    }
}

export interface IAccountUserOptions {
    code?: string | undefined;
    color?: string | undefined;
    iconUrl?: string | undefined;
    iconBase64?: string | undefined;
}

export class Activity implements IActivity {
    readonly fullId?: string;
    name!: string;
    projectId?: string | undefined;
    projectName?: string | undefined;
    readonly projectFullId?: string;
    parentId?: string | undefined;
    parentName?: string | undefined;
    readonly parentFullId?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    progress!: number;
    activityStatusId?: string | undefined;
    activityStatusName?: string | undefined;
    activityTrackerId?: string | undefined;
    activityTrackerName?: string | undefined;
    actualCompletionDate?: Date | undefined;
    isPrivate!: boolean;
    isMilestone!: boolean;
    iAmAssignee?: boolean | undefined;
    originalUrl?: string | undefined;
    description?: string;
    descriptionPreview?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    ownerId?: string | undefined;
    syncStatus?: SyncEntityStatus;
    accountId!: number;
    clientId?: string;
    userId!: number;
    isFavorite!: boolean;
    extensionData?: any | undefined;
    readonly displayId?: string;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fullId = _data["fullId"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            (<any>this).projectFullId = _data["projectFullId"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            (<any>this).parentFullId = _data["parentFullId"];
            this.priorityId = _data["priorityId"];
            this.priorityName = _data["priorityName"];
            this.progress = _data["progress"];
            this.activityStatusId = _data["activityStatusId"];
            this.activityStatusName = _data["activityStatusName"];
            this.activityTrackerId = _data["activityTrackerId"];
            this.activityTrackerName = _data["activityTrackerName"];
            this.actualCompletionDate = _data["actualCompletionDate"] ? new Date(_data["actualCompletionDate"].toString()) : <any>undefined;
            this.isPrivate = _data["isPrivate"];
            this.isMilestone = _data["isMilestone"];
            this.iAmAssignee = _data["iAmAssignee"];
            this.originalUrl = _data["originalUrl"];
            this.description = _data["description"];
            this.descriptionPreview = _data["descriptionPreview"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.ownerId = _data["ownerId"];
            this.syncStatus = _data["syncStatus"];
            this.accountId = _data["accountId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.isFavorite = _data["isFavorite"];
            this.extensionData = _data["extensionData"];
            (<any>this).displayId = _data["displayId"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullId"] = this.fullId;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectFullId"] = this.projectFullId;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["parentFullId"] = this.parentFullId;
        data["priorityId"] = this.priorityId;
        data["priorityName"] = this.priorityName;
        data["progress"] = this.progress;
        data["activityStatusId"] = this.activityStatusId;
        data["activityStatusName"] = this.activityStatusName;
        data["activityTrackerId"] = this.activityTrackerId;
        data["activityTrackerName"] = this.activityTrackerName;
        data["actualCompletionDate"] = this.actualCompletionDate ? this.actualCompletionDate.toISOString() : <any>undefined;
        data["isPrivate"] = this.isPrivate;
        data["isMilestone"] = this.isMilestone;
        data["iAmAssignee"] = this.iAmAssignee;
        data["originalUrl"] = this.originalUrl;
        data["description"] = this.description;
        data["descriptionPreview"] = this.descriptionPreview;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["ownerId"] = this.ownerId;
        data["syncStatus"] = this.syncStatus;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["isFavorite"] = this.isFavorite;
        data["extensionData"] = this.extensionData;
        data["displayId"] = this.displayId;
        return data;
    }
}

export interface IActivity {
    fullId?: string;
    name: string;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectFullId?: string;
    parentId?: string | undefined;
    parentName?: string | undefined;
    parentFullId?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    progress: number;
    activityStatusId?: string | undefined;
    activityStatusName?: string | undefined;
    activityTrackerId?: string | undefined;
    activityTrackerName?: string | undefined;
    actualCompletionDate?: Date | undefined;
    isPrivate: boolean;
    isMilestone: boolean;
    iAmAssignee?: boolean | undefined;
    originalUrl?: string | undefined;
    description?: string;
    descriptionPreview?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    ownerId?: string | undefined;
    syncStatus?: SyncEntityStatus;
    accountId: number;
    clientId?: string;
    userId: number;
    isFavorite: boolean;
    extensionData?: any | undefined;
    displayId?: string;
}

export class ActivityApprover implements IActivityApprover {
    userId?: string;
    email?: string | undefined;
    name?: string | undefined;
    roleId?: string | undefined;
    roleName?: string | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;

    constructor(data?: IActivityApprover) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.avatarHash = _data["avatarHash"];
            this.avatarUrl = _data["avatarUrl"];
        }
    }

    static fromJS(data: any): ActivityApprover {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityApprover();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["avatarHash"] = this.avatarHash;
        data["avatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IActivityApprover {
    userId?: string;
    email?: string | undefined;
    name?: string | undefined;
    roleId?: string | undefined;
    roleName?: string | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;
}

export class ActivityAssignee implements IActivityAssignee {
    userId?: string | undefined;
    groupId?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    workIsDone?: boolean | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;
    roleName?: string | undefined;
    isGroup!: boolean;

    constructor(data?: IActivityAssignee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.groupId = _data["groupId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.workIsDone = _data["workIsDone"];
            this.avatarHash = _data["avatarHash"];
            this.avatarUrl = _data["avatarUrl"];
            this.roleName = _data["roleName"];
            this.isGroup = _data["isGroup"];
        }
    }

    static fromJS(data: any): ActivityAssignee {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAssignee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["groupId"] = this.groupId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["workIsDone"] = this.workIsDone;
        data["avatarHash"] = this.avatarHash;
        data["avatarUrl"] = this.avatarUrl;
        data["roleName"] = this.roleName;
        data["isGroup"] = this.isGroup;
        return data;
    }
}

export interface IActivityAssignee {
    userId?: string | undefined;
    groupId?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    workIsDone?: boolean | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;
    roleName?: string | undefined;
    isGroup: boolean;
}

export class ActivityBilling implements IActivityBilling {
    budget?: number | undefined;
    billingType?: number | undefined;
    billingTypeName?: string | undefined;
    billed?: boolean | undefined;
    isBillable?: boolean | undefined;
    billingAmount?: number | undefined;

    constructor(data?: IActivityBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budget = _data["budget"];
            this.billingType = _data["billingType"];
            this.billingTypeName = _data["billingTypeName"];
            this.billed = _data["billed"];
            this.isBillable = _data["isBillable"];
            this.billingAmount = _data["billingAmount"];
        }
    }

    static fromJS(data: any): ActivityBilling {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budget"] = this.budget;
        data["billingType"] = this.billingType;
        data["billingTypeName"] = this.billingTypeName;
        data["billed"] = this.billed;
        data["isBillable"] = this.isBillable;
        data["billingAmount"] = this.billingAmount;
        return data;
    }
}

export interface IActivityBilling {
    budget?: number | undefined;
    billingType?: number | undefined;
    billingTypeName?: string | undefined;
    billed?: boolean | undefined;
    isBillable?: boolean | undefined;
    billingAmount?: number | undefined;
}

export class ActivityData implements IActivityData {
    attachments?: Attachment[] | undefined;
    messages?: Message[] | undefined;
    journals?: JournalItem[] | undefined;

    constructor(data?: IActivityData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            if (Array.isArray(_data["journals"])) {
                this.journals = [] as any;
                for (let item of _data["journals"])
                    this.journals!.push(JournalItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityData {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.journals)) {
            data["journals"] = [];
            for (let item of this.journals)
                data["journals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityData {
    attachments?: Attachment[] | undefined;
    messages?: Message[] | undefined;
    journals?: JournalItem[] | undefined;
}

export class ActivityDispatchActionInput implements IActivityDispatchActionInput {
    action!: string;
    extensionData?: any;

    constructor(data?: IActivityDispatchActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.extensionData = _data["extensionData"];
        }
    }

    static fromJS(data: any): ActivityDispatchActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDispatchActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["extensionData"] = this.extensionData;
        return data;
    }
}

export interface IActivityDispatchActionInput {
    action: string;
    extensionData?: any;
}

export class ActivityDispatchActionResult implements IActivityDispatchActionResult {
    success!: boolean;
    activity?: ActivityLookupItem;
    postTimeEntry?: PostTimeEntryResponse;
    uploadFile?: UploadFileResponse;
    datesAccess?: DatesAccessResponse;
    calculateDates?: CalculateDatesResponse;
    schedule?: ScheduleResponse;

    constructor(data?: IActivityDispatchActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.activity = _data["activity"] ? ActivityLookupItem.fromJS(_data["activity"]) : <any>undefined;
            this.postTimeEntry = _data["postTimeEntry"] ? PostTimeEntryResponse.fromJS(_data["postTimeEntry"]) : <any>undefined;
            this.uploadFile = _data["uploadFile"] ? UploadFileResponse.fromJS(_data["uploadFile"]) : <any>undefined;
            this.datesAccess = _data["datesAccess"] ? DatesAccessResponse.fromJS(_data["datesAccess"]) : <any>undefined;
            this.calculateDates = _data["calculateDates"] ? CalculateDatesResponse.fromJS(_data["calculateDates"]) : <any>undefined;
            this.schedule = _data["schedule"] ? ScheduleResponse.fromJS(_data["schedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityDispatchActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDispatchActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["postTimeEntry"] = this.postTimeEntry ? this.postTimeEntry.toJSON() : <any>undefined;
        data["uploadFile"] = this.uploadFile ? this.uploadFile.toJSON() : <any>undefined;
        data["datesAccess"] = this.datesAccess ? this.datesAccess.toJSON() : <any>undefined;
        data["calculateDates"] = this.calculateDates ? this.calculateDates.toJSON() : <any>undefined;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityDispatchActionResult {
    success: boolean;
    activity?: ActivityLookupItem;
    postTimeEntry?: PostTimeEntryResponse;
    uploadFile?: UploadFileResponse;
    datesAccess?: DatesAccessResponse;
    calculateDates?: CalculateDatesResponse;
    schedule?: ScheduleResponse;
}

export class ActivityDto implements IActivityDto {
    isPrivate!: boolean;
    duration?: number | undefined;
    actualCompletionDate?: Date | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    syncStatus?: SyncEntityStatus;
    description?: string | undefined;
    descriptionPreview?: string | undefined;
    projectId!: string;
    projectName?: string;
    readonly projectFullId?: string;
    priorityId!: string;
    priorityName?: string | undefined;
    progress!: number;
    statusId!: string;
    statusName?: string | undefined;
    trackerId!: string;
    trackerName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    readonly parentFullId?: string | undefined;
    iAmAssignee!: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isPrivate = false;
            this.progress = 0;
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrivate = _data["isPrivate"] !== undefined ? _data["isPrivate"] : false;
            this.duration = _data["duration"];
            this.actualCompletionDate = _data["actualCompletionDate"] ? new Date(_data["actualCompletionDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.syncStatus = _data["syncStatus"];
            this.description = _data["description"];
            this.descriptionPreview = _data["descriptionPreview"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            (<any>this).projectFullId = _data["projectFullId"];
            this.priorityId = _data["priorityId"];
            this.priorityName = _data["priorityName"];
            this.progress = _data["progress"] !== undefined ? _data["progress"] : 0;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.trackerId = _data["trackerId"];
            this.trackerName = _data["trackerName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            (<any>this).parentFullId = _data["parentFullId"];
            this.iAmAssignee = _data["iAmAssignee"];
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrivate"] = this.isPrivate;
        data["duration"] = this.duration;
        data["actualCompletionDate"] = this.actualCompletionDate ? this.actualCompletionDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["syncStatus"] = this.syncStatus;
        data["description"] = this.description;
        data["descriptionPreview"] = this.descriptionPreview;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectFullId"] = this.projectFullId;
        data["priorityId"] = this.priorityId;
        data["priorityName"] = this.priorityName;
        data["progress"] = this.progress;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["trackerId"] = this.trackerId;
        data["trackerName"] = this.trackerName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["parentFullId"] = this.parentFullId;
        data["iAmAssignee"] = this.iAmAssignee;
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface IActivityDto {
    isPrivate: boolean;
    duration?: number | undefined;
    actualCompletionDate?: Date | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    syncStatus?: SyncEntityStatus;
    description?: string | undefined;
    descriptionPreview?: string | undefined;
    projectId: string;
    projectName?: string;
    projectFullId?: string;
    priorityId: string;
    priorityName?: string | undefined;
    progress: number;
    statusId: string;
    statusName?: string | undefined;
    trackerId: string;
    trackerName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    parentFullId?: string | undefined;
    iAmAssignee: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export class ActivityEditDataDto implements IActivityEditDataDto {
    activity?: ActivityDto;
    syncItem?: IActivitySyncItem;
    priorities?: PriorityDto[] | undefined;
    categories?: Category[] | undefined;
    versions?: ItemVersion[] | undefined;
    trackers?: ActivityTrackerDto[];
    statuses?: ActivityStatusDto[];
    usersToAssign?: AccountUserDto[];
    assigneeUsers?: AccountUserDto[];
    projectMembers?: ProjectMember[];
    assignees?: ActivityAssignee[];
    customFields?: CustomField[] | undefined;
    watchers?: Watcher[];
    tracker?: ActivityTrackerDto;
    status?: ActivityStatusDto;
    project?: ProjectLookupItem;
    parent?: ActivityLookupItem;
    priority?: PriorityDto;
    originalUrl?: string;
    prepareUpload?: PrepareAttachmentResponse;
    features?: ActivityFeatures;

    constructor(data?: IActivityEditDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] ? ActivityDto.fromJS(_data["activity"]) : <any>undefined;
            this.syncItem = _data["syncItem"] ? IActivitySyncItem.fromJS(_data["syncItem"]) : <any>undefined;
            if (Array.isArray(_data["priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["priorities"])
                    this.priorities!.push(PriorityDto.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(ItemVersion.fromJS(item));
            }
            if (Array.isArray(_data["trackers"])) {
                this.trackers = [] as any;
                for (let item of _data["trackers"])
                    this.trackers!.push(ActivityTrackerDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(ActivityStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["usersToAssign"])) {
                this.usersToAssign = [] as any;
                for (let item of _data["usersToAssign"])
                    this.usersToAssign!.push(AccountUserDto.fromJS(item));
            }
            if (Array.isArray(_data["assigneeUsers"])) {
                this.assigneeUsers = [] as any;
                for (let item of _data["assigneeUsers"])
                    this.assigneeUsers!.push(AccountUserDto.fromJS(item));
            }
            if (Array.isArray(_data["projectMembers"])) {
                this.projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    this.projectMembers!.push(ProjectMember.fromJS(item));
            }
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(ActivityAssignee.fromJS(item));
            }
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["watchers"])) {
                this.watchers = [] as any;
                for (let item of _data["watchers"])
                    this.watchers!.push(Watcher.fromJS(item));
            }
            this.tracker = _data["tracker"] ? ActivityTrackerDto.fromJS(_data["tracker"]) : <any>undefined;
            this.status = _data["status"] ? ActivityStatusDto.fromJS(_data["status"]) : <any>undefined;
            this.project = _data["project"] ? ProjectLookupItem.fromJS(_data["project"]) : <any>undefined;
            this.parent = _data["parent"] ? ActivityLookupItem.fromJS(_data["parent"]) : <any>undefined;
            this.priority = _data["priority"] ? PriorityDto.fromJS(_data["priority"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
            this.prepareUpload = _data["prepareUpload"] ? PrepareAttachmentResponse.fromJS(_data["prepareUpload"]) : <any>undefined;
            this.features = _data["features"] ? ActivityFeatures.fromJS(_data["features"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityEditDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityEditDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["syncItem"] = this.syncItem ? this.syncItem.toJSON() : <any>undefined;
        if (Array.isArray(this.priorities)) {
            data["priorities"] = [];
            for (let item of this.priorities)
                data["priorities"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        if (Array.isArray(this.trackers)) {
            data["trackers"] = [];
            for (let item of this.trackers)
                data["trackers"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.usersToAssign)) {
            data["usersToAssign"] = [];
            for (let item of this.usersToAssign)
                data["usersToAssign"].push(item.toJSON());
        }
        if (Array.isArray(this.assigneeUsers)) {
            data["assigneeUsers"] = [];
            for (let item of this.assigneeUsers)
                data["assigneeUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item.toJSON());
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.watchers)) {
            data["watchers"] = [];
            for (let item of this.watchers)
                data["watchers"].push(item.toJSON());
        }
        data["tracker"] = this.tracker ? this.tracker.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["priority"] = this.priority ? this.priority.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        data["prepareUpload"] = this.prepareUpload ? this.prepareUpload.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityEditDataDto {
    activity?: ActivityDto;
    syncItem?: IActivitySyncItem;
    priorities?: PriorityDto[] | undefined;
    categories?: Category[] | undefined;
    versions?: ItemVersion[] | undefined;
    trackers?: ActivityTrackerDto[];
    statuses?: ActivityStatusDto[];
    usersToAssign?: AccountUserDto[];
    assigneeUsers?: AccountUserDto[];
    projectMembers?: ProjectMember[];
    assignees?: ActivityAssignee[];
    customFields?: CustomField[] | undefined;
    watchers?: Watcher[];
    tracker?: ActivityTrackerDto;
    status?: ActivityStatusDto;
    project?: ProjectLookupItem;
    parent?: ActivityLookupItem;
    priority?: PriorityDto;
    originalUrl?: string;
    prepareUpload?: PrepareAttachmentResponse;
    features?: ActivityFeatures;
}

export class ActivityExtensionData implements IActivityExtensionData {
    activityBilling?: ActivityBilling;
    activityHours?: ActivityHoursData;
    assignees?: ActivityAssignee[] | undefined;
    approvers?: ActivityApprover[] | undefined;
    counts?: ActivityItemsCounts;
    category?: Category;

    [key: string]: any;

    constructor(data?: IActivityExtensionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.activityBilling = _data["activityBilling"] ? ActivityBilling.fromJS(_data["activityBilling"]) : <any>undefined;
            this.activityHours = _data["activityHours"] ? ActivityHoursData.fromJS(_data["activityHours"]) : <any>undefined;
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(ActivityAssignee.fromJS(item));
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ActivityApprover.fromJS(item));
            }
            this.counts = _data["counts"] ? ActivityItemsCounts.fromJS(_data["counts"]) : <any>undefined;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityExtensionData {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityExtensionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["activityBilling"] = this.activityBilling ? this.activityBilling.toJSON() : <any>undefined;
        data["activityHours"] = this.activityHours ? this.activityHours.toJSON() : <any>undefined;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item.toJSON());
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["counts"] = this.counts ? this.counts.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityExtensionData {
    activityBilling?: ActivityBilling;
    activityHours?: ActivityHoursData;
    assignees?: ActivityAssignee[] | undefined;
    approvers?: ActivityApprover[] | undefined;
    counts?: ActivityItemsCounts;
    category?: Category;

    [key: string]: any;
}

export class ActivityFeatures implements IActivityFeatures {
    hasTimeTracking!: boolean;
    hasMessages!: boolean;
    hasAttachments!: boolean;
    isReadOnly!: boolean;
    customFields?: ActivityField[];
    project?: ActivityField;
    assignee?: ActivityField;
    assignees?: ActivityField;
    timeTrackingActivity?: ActivityField;
    parent?: ActivityField;
    tracker?: ActivityField;
    status?: ActivityField;
    progress?: ActivityField;
    duration?: ActivityField;
    startDate?: ActivityField;
    endDate?: ActivityField;
    priority?: ActivityField;
    description?: ActivityField;
    estimatedHours?: ActivityField;
    budget?: ActivityField;
    hoursLeft?: ActivityField;
    category?: ActivityField;

    constructor(data?: IActivityFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTimeTracking = _data["hasTimeTracking"];
            this.hasMessages = _data["hasMessages"];
            this.hasAttachments = _data["hasAttachments"];
            this.isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(ActivityField.fromJS(item));
            }
            this.project = _data["project"] ? ActivityField.fromJS(_data["project"]) : <any>undefined;
            this.assignee = _data["assignee"] ? ActivityField.fromJS(_data["assignee"]) : <any>undefined;
            this.assignees = _data["assignees"] ? ActivityField.fromJS(_data["assignees"]) : <any>undefined;
            this.timeTrackingActivity = _data["timeTrackingActivity"] ? ActivityField.fromJS(_data["timeTrackingActivity"]) : <any>undefined;
            this.parent = _data["parent"] ? ActivityField.fromJS(_data["parent"]) : <any>undefined;
            this.tracker = _data["tracker"] ? ActivityField.fromJS(_data["tracker"]) : <any>undefined;
            this.status = _data["status"] ? ActivityField.fromJS(_data["status"]) : <any>undefined;
            this.progress = _data["progress"] ? ActivityField.fromJS(_data["progress"]) : <any>undefined;
            this.duration = _data["duration"] ? ActivityField.fromJS(_data["duration"]) : <any>undefined;
            this.startDate = _data["startDate"] ? ActivityField.fromJS(_data["startDate"]) : <any>undefined;
            this.endDate = _data["endDate"] ? ActivityField.fromJS(_data["endDate"]) : <any>undefined;
            this.priority = _data["priority"] ? ActivityField.fromJS(_data["priority"]) : <any>undefined;
            this.description = _data["description"] ? ActivityField.fromJS(_data["description"]) : <any>undefined;
            this.estimatedHours = _data["estimatedHours"] ? ActivityField.fromJS(_data["estimatedHours"]) : <any>undefined;
            this.budget = _data["budget"] ? ActivityField.fromJS(_data["budget"]) : <any>undefined;
            this.hoursLeft = _data["hoursLeft"] ? ActivityField.fromJS(_data["hoursLeft"]) : <any>undefined;
            this.category = _data["category"] ? ActivityField.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTimeTracking"] = this.hasTimeTracking;
        data["hasMessages"] = this.hasMessages;
        data["hasAttachments"] = this.hasAttachments;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["assignees"] = this.assignees ? this.assignees.toJSON() : <any>undefined;
        data["timeTrackingActivity"] = this.timeTrackingActivity ? this.timeTrackingActivity.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["tracker"] = this.tracker ? this.tracker.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["progress"] = this.progress ? this.progress.toJSON() : <any>undefined;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : <any>undefined;
        data["priority"] = this.priority ? this.priority.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["estimatedHours"] = this.estimatedHours ? this.estimatedHours.toJSON() : <any>undefined;
        data["budget"] = this.budget ? this.budget.toJSON() : <any>undefined;
        data["hoursLeft"] = this.hoursLeft ? this.hoursLeft.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityFeatures {
    hasTimeTracking: boolean;
    hasMessages: boolean;
    hasAttachments: boolean;
    isReadOnly: boolean;
    customFields?: ActivityField[];
    project?: ActivityField;
    assignee?: ActivityField;
    assignees?: ActivityField;
    timeTrackingActivity?: ActivityField;
    parent?: ActivityField;
    tracker?: ActivityField;
    status?: ActivityField;
    progress?: ActivityField;
    duration?: ActivityField;
    startDate?: ActivityField;
    endDate?: ActivityField;
    priority?: ActivityField;
    description?: ActivityField;
    estimatedHours?: ActivityField;
    budget?: ActivityField;
    hoursLeft?: ActivityField;
    category?: ActivityField;
}

export class ActivityField implements IActivityField {
    id?: string;
    name?: string;
    isReadOnly!: boolean;
    isRequired!: boolean;

    constructor(data?: IActivityField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isReadOnly = _data["isReadOnly"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ActivityField {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isReadOnly"] = this.isReadOnly;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IActivityField {
    id?: string;
    name?: string;
    isReadOnly: boolean;
    isRequired: boolean;
}

export class ActivityFindByInput implements IActivityFindByInput {
    findBy!: ActivityFindByType;
    value!: string;
    account?: AccountInfo;

    constructor(data?: IActivityFindByInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.findBy = _data["findBy"];
            this.value = _data["value"];
            this.account = _data["account"] ? AccountInfo.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityFindByInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFindByInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["findBy"] = this.findBy;
        data["value"] = this.value;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityFindByInput {
    findBy: ActivityFindByType;
    value: string;
    account?: AccountInfo;
}

export enum ActivityFindByType {
    Id = "Id",
    Name = "Name",
    ClientId = "ClientId",
    ClientUrl = "ClientUrl",
    OriginalUrl = "OriginalUrl",
}

export class ActivityHoursData implements IActivityHoursData {
    estimatedHours?: number | undefined;
    childsEstimatedHours?: number | undefined;
    actualHours?: number | undefined;
    hoursLeft?: number | undefined;

    constructor(data?: IActivityHoursData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedHours = _data["estimatedHours"];
            this.childsEstimatedHours = _data["childsEstimatedHours"];
            this.actualHours = _data["actualHours"];
            this.hoursLeft = _data["hoursLeft"];
        }
    }

    static fromJS(data: any): ActivityHoursData {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityHoursData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedHours"] = this.estimatedHours;
        data["childsEstimatedHours"] = this.childsEstimatedHours;
        data["actualHours"] = this.actualHours;
        data["hoursLeft"] = this.hoursLeft;
        return data;
    }
}

export interface IActivityHoursData {
    estimatedHours?: number | undefined;
    childsEstimatedHours?: number | undefined;
    actualHours?: number | undefined;
    hoursLeft?: number | undefined;
}

export class ActivityItemIdentity implements IActivityItemIdentity {
    activityId!: string;

    constructor(data?: IActivityItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
        }
    }

    static fromJS(data: any): ActivityItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        return data;
    }
}

export interface IActivityItemIdentity {
    activityId: string;
}

export class ActivityItemsCounts implements IActivityItemsCounts {
    messages!: number;
    attachments!: number;
    journals!: number;
    watchers!: number;

    constructor(data?: IActivityItemsCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"];
            this.attachments = _data["attachments"];
            this.journals = _data["journals"];
            this.watchers = _data["watchers"];
        }
    }

    static fromJS(data: any): ActivityItemsCounts {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityItemsCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages;
        data["attachments"] = this.attachments;
        data["journals"] = this.journals;
        data["watchers"] = this.watchers;
        return data;
    }
}

export interface IActivityItemsCounts {
    messages: number;
    attachments: number;
    journals: number;
    watchers: number;
}

export class ActivityLookupItem implements IActivityLookupItem {
    syncStatus?: SyncEntityStatus;
    description?: string | undefined;
    descriptionPreview?: string | undefined;
    projectId!: string;
    projectName?: string;
    readonly projectFullId?: string;
    priorityId!: string;
    priorityName?: string | undefined;
    progress!: number;
    statusId!: string;
    statusName?: string | undefined;
    trackerId!: string;
    trackerName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    readonly parentFullId?: string | undefined;
    iAmAssignee!: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: IActivityLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.progress = 0;
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncStatus = _data["syncStatus"];
            this.description = _data["description"];
            this.descriptionPreview = _data["descriptionPreview"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            (<any>this).projectFullId = _data["projectFullId"];
            this.priorityId = _data["priorityId"];
            this.priorityName = _data["priorityName"];
            this.progress = _data["progress"] !== undefined ? _data["progress"] : 0;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.trackerId = _data["trackerId"];
            this.trackerName = _data["trackerName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            (<any>this).parentFullId = _data["parentFullId"];
            this.iAmAssignee = _data["iAmAssignee"];
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): ActivityLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncStatus"] = this.syncStatus;
        data["description"] = this.description;
        data["descriptionPreview"] = this.descriptionPreview;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectFullId"] = this.projectFullId;
        data["priorityId"] = this.priorityId;
        data["priorityName"] = this.priorityName;
        data["progress"] = this.progress;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["trackerId"] = this.trackerId;
        data["trackerName"] = this.trackerName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["parentFullId"] = this.parentFullId;
        data["iAmAssignee"] = this.iAmAssignee;
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface IActivityLookupItem {
    syncStatus?: SyncEntityStatus;
    description?: string | undefined;
    descriptionPreview?: string | undefined;
    projectId: string;
    projectName?: string;
    projectFullId?: string;
    priorityId: string;
    priorityName?: string | undefined;
    progress: number;
    statusId: string;
    statusName?: string | undefined;
    trackerId: string;
    trackerName?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    parentFullId?: string | undefined;
    iAmAssignee: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export class ActivityStatusDto implements IActivityStatusDto {
    treatAsCompleted!: boolean;
    treatAsHold!: boolean;
    requiresApproval!: boolean;
    isDefault!: boolean;
    name!: string;
    readonly id!: string;
    accountId!: number;
    readonly clientId!: string;
    syncStatus?: SyncEntityStatus;

    constructor(data?: IActivityStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatAsCompleted = _data["treatAsCompleted"];
            this.treatAsHold = _data["treatAsHold"];
            this.requiresApproval = _data["requiresApproval"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            (<any>this).id = _data["id"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.syncStatus = _data["syncStatus"];
        }
    }

    static fromJS(data: any): ActivityStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatAsCompleted"] = this.treatAsCompleted;
        data["treatAsHold"] = this.treatAsHold;
        data["requiresApproval"] = this.requiresApproval;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["syncStatus"] = this.syncStatus;
        return data;
    }
}

export interface IActivityStatusDto {
    treatAsCompleted: boolean;
    treatAsHold: boolean;
    requiresApproval: boolean;
    isDefault: boolean;
    name: string;
    id: string;
    accountId: number;
    clientId: string;
    syncStatus?: SyncEntityStatus;
}

export class ActivityTrackerDto implements IActivityTrackerDto {
    defaultStatusId?: string | undefined;
    isSubTask!: boolean;
    canBeParent!: boolean;
    name!: string;
    readonly id!: string;
    accountId!: number;
    readonly clientId!: string;
    syncStatus?: SyncEntityStatus;

    constructor(data?: IActivityTrackerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultStatusId = _data["defaultStatusId"];
            this.isSubTask = _data["isSubTask"];
            this.canBeParent = _data["canBeParent"];
            this.name = _data["name"];
            (<any>this).id = _data["id"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.syncStatus = _data["syncStatus"];
        }
    }

    static fromJS(data: any): ActivityTrackerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTrackerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultStatusId"] = this.defaultStatusId;
        data["isSubTask"] = this.isSubTask;
        data["canBeParent"] = this.canBeParent;
        data["name"] = this.name;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["syncStatus"] = this.syncStatus;
        return data;
    }
}

export interface IActivityTrackerDto {
    defaultStatusId?: string | undefined;
    isSubTask: boolean;
    canBeParent: boolean;
    name: string;
    id: string;
    accountId: number;
    clientId: string;
    syncStatus?: SyncEntityStatus;
}

export class AddNoteDto implements IAddNoteDto {
    newNote?: string;
    isPrivate!: boolean;

    constructor(data?: IAddNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newNote = _data["newNote"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): AddNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newNote"] = this.newNote;
        data["isPrivate"] = this.isPrivate;
        return data;
    }
}

export interface IAddNoteDto {
    newNote?: string;
    isPrivate: boolean;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version?: string;
    informationalVersion?: string;
    releaseDate!: Date;
    features?: { [key: string]: boolean; };

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.informationalVersion = _data["informationalVersion"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["informationalVersion"] = this.informationalVersion;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version?: string;
    informationalVersion?: string;
    releaseDate: Date;
    features?: { [key: string]: boolean; };
}

export class Attachment implements IAttachment {
    id?: string;
    fileName?: string;
    mimeType?: string;
    fileSize!: number;
    fileContentUrl?: string;
    description?: string;
    thumbnailUrl?: string;
    hasThumbnail?: boolean | undefined;
    postDate!: Date;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.fileSize = _data["fileSize"];
            this.fileContentUrl = _data["fileContentUrl"];
            this.description = _data["description"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.hasThumbnail = _data["hasThumbnail"];
            this.postDate = _data["postDate"] ? new Date(_data["postDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.updatedById = _data["updatedById"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["fileSize"] = this.fileSize;
        data["fileContentUrl"] = this.fileContentUrl;
        data["description"] = this.description;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["hasThumbnail"] = this.hasThumbnail;
        data["postDate"] = this.postDate ? this.postDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["updatedById"] = this.updatedById;
        data["updatedByName"] = this.updatedByName;
        return data;
    }
}

export interface IAttachment {
    id?: string;
    fileName?: string;
    mimeType?: string;
    fileSize: number;
    fileContentUrl?: string;
    description?: string;
    thumbnailUrl?: string;
    hasThumbnail?: boolean | undefined;
    postDate: Date;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;
}

export class AttachmentDto implements IAttachmentDto {
    id?: string;
    originalUrl?: string;
    name?: string;
    fileSize?: number | undefined;
    contentType?: string;
    isInline!: boolean;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalUrl = _data["originalUrl"];
            this.name = _data["name"];
            this.fileSize = _data["fileSize"];
            this.contentType = _data["contentType"];
            this.isInline = _data["isInline"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalUrl"] = this.originalUrl;
        data["name"] = this.name;
        data["fileSize"] = this.fileSize;
        data["contentType"] = this.contentType;
        data["isInline"] = this.isInline;
        return data;
    }
}

export interface IAttachmentDto {
    id?: string;
    originalUrl?: string;
    name?: string;
    fileSize?: number | undefined;
    contentType?: string;
    isInline: boolean;
}

export class Auth0UserInfo implements IAuth0UserInfo {
    userId?: string;
    nickName?: string;
    firstName?: string;
    fullName?: string;
    lastName?: string;
    picture?: string;
    email?: string;
    emailVerified?: boolean | undefined;
    blocked!: boolean;

    constructor(data?: IAuth0UserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.nickName = _data["nickName"];
            this.firstName = _data["firstName"];
            this.fullName = _data["fullName"];
            this.lastName = _data["lastName"];
            this.picture = _data["picture"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.blocked = _data["blocked"];
        }
    }

    static fromJS(data: any): Auth0UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["nickName"] = this.nickName;
        data["firstName"] = this.firstName;
        data["fullName"] = this.fullName;
        data["lastName"] = this.lastName;
        data["picture"] = this.picture;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["blocked"] = this.blocked;
        return data;
    }
}

export interface IAuth0UserInfo {
    userId?: string;
    nickName?: string;
    firstName?: string;
    fullName?: string;
    lastName?: string;
    picture?: string;
    email?: string;
    emailVerified?: boolean | undefined;
    blocked: boolean;
}

export enum AuthMethods {
    Password = "Password",
    ApiKey = "ApiKey",
    WindowsCredential = "WindowsCredential",
    OAuthToken = "OAuthToken",
    None = "None",
}

export class AuthTokensInput implements IAuthTokensInput {
    exchangeToken?: string | undefined;

    constructor(data?: IAuthTokensInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exchangeToken = _data["exchangeToken"];
        }
    }

    static fromJS(data: any): AuthTokensInput {
        data = typeof data === 'object' ? data : {};
        let result = new AuthTokensInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exchangeToken"] = this.exchangeToken;
        return data;
    }
}

export interface IAuthTokensInput {
    exchangeToken?: string | undefined;
}

export class Bookmark implements IBookmark {
    url!: string;
    title!: string;
    iconUrl?: string | undefined;
    description?: string | undefined;
    id!: string;

    constructor(data?: IBookmark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.title = _data["title"];
            this.iconUrl = _data["iconUrl"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Bookmark {
        data = typeof data === 'object' ? data : {};
        let result = new Bookmark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["title"] = this.title;
        data["iconUrl"] = this.iconUrl;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IBookmark {
    url: string;
    title: string;
    iconUrl?: string | undefined;
    description?: string | undefined;
    id: string;
}

export class CalculateActivityDatesRequest implements ICalculateActivityDatesRequest {
    currentEditedField?: EditedField;
    days?: number | undefined;
    endDate?: Date | undefined;
    hours?: number | undefined;
    startDates?: Date | undefined;

    constructor(data?: ICalculateActivityDatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentEditedField = _data["currentEditedField"];
            this.days = _data["days"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.startDates = _data["startDates"] ? new Date(_data["startDates"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CalculateActivityDatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateActivityDatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentEditedField"] = this.currentEditedField;
        data["days"] = this.days;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["startDates"] = this.startDates ? this.startDates.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICalculateActivityDatesRequest {
    currentEditedField?: EditedField;
    days?: number | undefined;
    endDate?: Date | undefined;
    hours?: number | undefined;
    startDates?: Date | undefined;
}

export class CalculateDatesResponse implements ICalculateDatesResponse {
    days?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hours?: number | undefined;

    constructor(data?: ICalculateDatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): CalculateDatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateDatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        return data;
    }
}

export interface ICalculateDatesResponse {
    days?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    hours?: number | undefined;
}

export class Category implements ICategory {
    description?: string | undefined;
    clientId?: string;
    name?: string;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategory {
    description?: string | undefined;
    clientId?: string;
    name?: string;
}

export class Channel implements IChannel {
    channelUid!: string;
    name?: string | undefined;
    id!: string;

    constructor(data?: IChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelUid = _data["channelUid"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Channel {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelUid"] = this.channelUid;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IChannel {
    channelUid: string;
    name?: string | undefined;
    id: string;
}

export class ChannelItemIdentity implements IChannelItemIdentity {
    channelId!: string;
    title!: string;
    serviceProvider?: ServiceProvider;

    constructor(data?: IChannelItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.title = _data["title"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): ChannelItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["title"] = this.title;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IChannelItemIdentity {
    channelId: string;
    title: string;
    serviceProvider?: ServiceProvider;
}

export class Checklist implements IChecklist {
    id!: string;
    name!: string;
    orderKey?: number | undefined;
    isCompleted!: boolean;
    isCollapsed!: boolean;
    readonly createdAt!: Date | undefined;
    items!: ChecklistItem[];
    refId?: string | undefined;
    workspaceId?: string | undefined;

    constructor(data?: IChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderKey = _data["orderKey"];
            this.isCompleted = _data["isCompleted"];
            this.isCollapsed = _data["isCollapsed"];
            (<any>this).createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChecklistItem.fromJS(item));
            }
            this.refId = _data["refId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): Checklist {
        data = typeof data === 'object' ? data : {};
        let result = new Checklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderKey"] = this.orderKey;
        data["isCompleted"] = this.isCompleted;
        data["isCollapsed"] = this.isCollapsed;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["refId"] = this.refId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface IChecklist {
    id: string;
    name: string;
    orderKey?: number | undefined;
    isCompleted: boolean;
    isCollapsed: boolean;
    createdAt: Date | undefined;
    items: ChecklistItem[];
    refId?: string | undefined;
    workspaceId?: string | undefined;
}

export class ChecklistItem implements IChecklistItem {
    name!: string;
    isChecked!: boolean;

    constructor(data?: IChecklistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): ChecklistItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isChecked"] = this.isChecked;
        return data;
    }
}

export interface IChecklistItem {
    name: string;
    isChecked: boolean;
}

export class ChecklistTemplate implements IChecklistTemplate {
    readonly id!: string;
    name!: string;
    orderKey?: number | undefined;
    items!: ChecklistTemplateItem[];

    constructor(data?: IChecklistTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.name = _data["name"];
            this.orderKey = _data["orderKey"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChecklistTemplateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderKey"] = this.orderKey;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistTemplate {
    id: string;
    name: string;
    orderKey?: number | undefined;
    items: ChecklistTemplateItem[];
}

export class ChecklistTemplateItem implements IChecklistTemplateItem {
    name!: string;
    isCompleted!: boolean;

    constructor(data?: IChecklistTemplateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): ChecklistTemplateItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistTemplateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface IChecklistTemplateItem {
    name: string;
    isCompleted: boolean;
}

export class ConnectionFeatures implements IConnectionFeatures {
    isInitialized!: boolean;
    isUnitTestAccount!: boolean;
    descriptionFormat?: DescriptionFormats;
    taskHoursLeft!: boolean;
    subTasksEstimatedHours!: boolean;
    taskDuration!: boolean;
    taskStartDate!: boolean;
    taskEndDate!: boolean;
    taskActualCompleted!: boolean;
    messageApproval!: boolean;
    taskCategories!: boolean;
    taskProgress!: boolean;
    taskMarkCompleted!: boolean;
    taskPriority!: boolean;
    taskActualHours!: boolean;
    activityHasSingleAssignee!: boolean;
    taskAssigneeRole!: boolean;
    autoAssigneedCurrentToProject!: boolean;
    ignoreCurrentUserToProject!: boolean;
    useProjectGeneratedIdentifier!: boolean;
    timeLogsIsSupported!: boolean;
    timeLogsUserMustBeAssigneed!: boolean;
    projectAttachmentsIsSupported!: boolean;
    projectDatesIsSupported!: boolean;
    projectParentIsSupported!: boolean;
    projectStatusIsSupported!: boolean;
    projectPublicIsSupported!: boolean;
    projectInheritMembersIsSupported!: boolean;
    projectTrackerAndModulesIsSupported!: boolean;
    taskDetailsAsPdfIsSupported!: boolean;
    projectCanChangeOnTaskDetails!: boolean;
    taskVersionsIsSupported!: boolean;
    trackersPerProjectIsSupported!: boolean;
    categoriesPerProjectIsSupported!: boolean;
    taskStatusesPerProjectIsSupported!: boolean;
    easyCRMSupported!: boolean;
    timeEntryActivityIsSupported!: boolean;
    isBillableSupported!: boolean;
    sharedApiIsSupported!: boolean;
    messageCanIncludeAttachments!: boolean;
    defaultStartDateIsToday!: boolean;

    constructor(data?: IConnectionFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInitialized = _data["isInitialized"];
            this.isUnitTestAccount = _data["isUnitTestAccount"];
            this.descriptionFormat = _data["descriptionFormat"];
            this.taskHoursLeft = _data["taskHoursLeft"];
            this.subTasksEstimatedHours = _data["subTasksEstimatedHours"];
            this.taskDuration = _data["taskDuration"];
            this.taskStartDate = _data["taskStartDate"];
            this.taskEndDate = _data["taskEndDate"];
            this.taskActualCompleted = _data["taskActualCompleted"];
            this.messageApproval = _data["messageApproval"];
            this.taskCategories = _data["taskCategories"];
            this.taskProgress = _data["taskProgress"];
            this.taskMarkCompleted = _data["taskMarkCompleted"];
            this.taskPriority = _data["taskPriority"];
            this.taskActualHours = _data["taskActualHours"];
            this.activityHasSingleAssignee = _data["activityHasSingleAssignee"];
            this.taskAssigneeRole = _data["taskAssigneeRole"];
            this.autoAssigneedCurrentToProject = _data["autoAssigneedCurrentToProject"];
            this.ignoreCurrentUserToProject = _data["ignoreCurrentUserToProject"];
            this.useProjectGeneratedIdentifier = _data["useProjectGeneratedIdentifier"];
            this.timeLogsIsSupported = _data["timeLogsIsSupported"];
            this.timeLogsUserMustBeAssigneed = _data["timeLogsUserMustBeAssigneed"];
            this.projectAttachmentsIsSupported = _data["projectAttachmentsIsSupported"];
            this.projectDatesIsSupported = _data["projectDatesIsSupported"];
            this.projectParentIsSupported = _data["projectParentIsSupported"];
            this.projectStatusIsSupported = _data["projectStatusIsSupported"];
            this.projectPublicIsSupported = _data["projectPublicIsSupported"];
            this.projectInheritMembersIsSupported = _data["projectInheritMembersIsSupported"];
            this.projectTrackerAndModulesIsSupported = _data["projectTrackerAndModulesIsSupported"];
            this.taskDetailsAsPdfIsSupported = _data["taskDetailsAsPdfIsSupported"];
            this.projectCanChangeOnTaskDetails = _data["projectCanChangeOnTaskDetails"];
            this.taskVersionsIsSupported = _data["taskVersionsIsSupported"];
            this.trackersPerProjectIsSupported = _data["trackersPerProjectIsSupported"];
            this.categoriesPerProjectIsSupported = _data["categoriesPerProjectIsSupported"];
            this.taskStatusesPerProjectIsSupported = _data["taskStatusesPerProjectIsSupported"];
            this.easyCRMSupported = _data["easyCRMSupported"];
            this.timeEntryActivityIsSupported = _data["timeEntryActivityIsSupported"];
            this.isBillableSupported = _data["isBillableSupported"];
            this.sharedApiIsSupported = _data["sharedApiIsSupported"];
            this.messageCanIncludeAttachments = _data["messageCanIncludeAttachments"];
            this.defaultStartDateIsToday = _data["defaultStartDateIsToday"];
        }
    }

    static fromJS(data: any): ConnectionFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInitialized"] = this.isInitialized;
        data["isUnitTestAccount"] = this.isUnitTestAccount;
        data["descriptionFormat"] = this.descriptionFormat;
        data["taskHoursLeft"] = this.taskHoursLeft;
        data["subTasksEstimatedHours"] = this.subTasksEstimatedHours;
        data["taskDuration"] = this.taskDuration;
        data["taskStartDate"] = this.taskStartDate;
        data["taskEndDate"] = this.taskEndDate;
        data["taskActualCompleted"] = this.taskActualCompleted;
        data["messageApproval"] = this.messageApproval;
        data["taskCategories"] = this.taskCategories;
        data["taskProgress"] = this.taskProgress;
        data["taskMarkCompleted"] = this.taskMarkCompleted;
        data["taskPriority"] = this.taskPriority;
        data["taskActualHours"] = this.taskActualHours;
        data["activityHasSingleAssignee"] = this.activityHasSingleAssignee;
        data["taskAssigneeRole"] = this.taskAssigneeRole;
        data["autoAssigneedCurrentToProject"] = this.autoAssigneedCurrentToProject;
        data["ignoreCurrentUserToProject"] = this.ignoreCurrentUserToProject;
        data["useProjectGeneratedIdentifier"] = this.useProjectGeneratedIdentifier;
        data["timeLogsIsSupported"] = this.timeLogsIsSupported;
        data["timeLogsUserMustBeAssigneed"] = this.timeLogsUserMustBeAssigneed;
        data["projectAttachmentsIsSupported"] = this.projectAttachmentsIsSupported;
        data["projectDatesIsSupported"] = this.projectDatesIsSupported;
        data["projectParentIsSupported"] = this.projectParentIsSupported;
        data["projectStatusIsSupported"] = this.projectStatusIsSupported;
        data["projectPublicIsSupported"] = this.projectPublicIsSupported;
        data["projectInheritMembersIsSupported"] = this.projectInheritMembersIsSupported;
        data["projectTrackerAndModulesIsSupported"] = this.projectTrackerAndModulesIsSupported;
        data["taskDetailsAsPdfIsSupported"] = this.taskDetailsAsPdfIsSupported;
        data["projectCanChangeOnTaskDetails"] = this.projectCanChangeOnTaskDetails;
        data["taskVersionsIsSupported"] = this.taskVersionsIsSupported;
        data["trackersPerProjectIsSupported"] = this.trackersPerProjectIsSupported;
        data["categoriesPerProjectIsSupported"] = this.categoriesPerProjectIsSupported;
        data["taskStatusesPerProjectIsSupported"] = this.taskStatusesPerProjectIsSupported;
        data["easyCRMSupported"] = this.easyCRMSupported;
        data["timeEntryActivityIsSupported"] = this.timeEntryActivityIsSupported;
        data["isBillableSupported"] = this.isBillableSupported;
        data["sharedApiIsSupported"] = this.sharedApiIsSupported;
        data["messageCanIncludeAttachments"] = this.messageCanIncludeAttachments;
        data["defaultStartDateIsToday"] = this.defaultStartDateIsToday;
        return data;
    }
}

export interface IConnectionFeatures {
    isInitialized: boolean;
    isUnitTestAccount: boolean;
    descriptionFormat?: DescriptionFormats;
    taskHoursLeft: boolean;
    subTasksEstimatedHours: boolean;
    taskDuration: boolean;
    taskStartDate: boolean;
    taskEndDate: boolean;
    taskActualCompleted: boolean;
    messageApproval: boolean;
    taskCategories: boolean;
    taskProgress: boolean;
    taskMarkCompleted: boolean;
    taskPriority: boolean;
    taskActualHours: boolean;
    activityHasSingleAssignee: boolean;
    taskAssigneeRole: boolean;
    autoAssigneedCurrentToProject: boolean;
    ignoreCurrentUserToProject: boolean;
    useProjectGeneratedIdentifier: boolean;
    timeLogsIsSupported: boolean;
    timeLogsUserMustBeAssigneed: boolean;
    projectAttachmentsIsSupported: boolean;
    projectDatesIsSupported: boolean;
    projectParentIsSupported: boolean;
    projectStatusIsSupported: boolean;
    projectPublicIsSupported: boolean;
    projectInheritMembersIsSupported: boolean;
    projectTrackerAndModulesIsSupported: boolean;
    taskDetailsAsPdfIsSupported: boolean;
    projectCanChangeOnTaskDetails: boolean;
    taskVersionsIsSupported: boolean;
    trackersPerProjectIsSupported: boolean;
    categoriesPerProjectIsSupported: boolean;
    taskStatusesPerProjectIsSupported: boolean;
    easyCRMSupported: boolean;
    timeEntryActivityIsSupported: boolean;
    isBillableSupported: boolean;
    sharedApiIsSupported: boolean;
    messageCanIncludeAttachments: boolean;
    defaultStartDateIsToday: boolean;
}

export enum ConnectionResultType {
    Success = "Success",
    InvalidUserNameOrEmailAddress = "InvalidUserNameOrEmailAddress",
    Unauthorized = "Unauthorized",
    UserIsNotActive = "UserIsNotActive",
    InvalidWebRoot = "InvalidWebRoot",
    AccountIsNotActive = "AccountIsNotActive",
    ConnectionError = "ConnectionError",
}

export class ConnectionSettings implements IConnectionSettings {
    ignoreSslErrors!: boolean;
    userName?: string;
    authMethod?: AuthMethods;
    apiKeyLength?: number | undefined;
    passwordLength?: number | undefined;
    name?: string;

    constructor(data?: IConnectionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ignoreSslErrors = _data["ignoreSslErrors"];
            this.userName = _data["userName"];
            this.authMethod = _data["authMethod"];
            this.apiKeyLength = _data["apiKeyLength"];
            this.passwordLength = _data["passwordLength"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ConnectionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ignoreSslErrors"] = this.ignoreSslErrors;
        data["userName"] = this.userName;
        data["authMethod"] = this.authMethod;
        data["apiKeyLength"] = this.apiKeyLength;
        data["passwordLength"] = this.passwordLength;
        data["name"] = this.name;
        return data;
    }
}

export interface IConnectionSettings {
    ignoreSslErrors: boolean;
    userName?: string;
    authMethod?: AuthMethods;
    apiKeyLength?: number | undefined;
    passwordLength?: number | undefined;
    name?: string;
}

export class ConnectionSettingsInputDto implements IConnectionSettingsInputDto {
    ignoreSslErrors!: boolean;
    password?: string | undefined;
    userName?: string | undefined;
    apiKey?: string | undefined;
    accessToken?: string | undefined;
    authMethod!: AuthMethods;

    constructor(data?: IConnectionSettingsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ignoreSslErrors = _data["ignoreSslErrors"];
            this.password = _data["password"];
            this.userName = _data["userName"];
            this.apiKey = _data["apiKey"];
            this.accessToken = _data["accessToken"];
            this.authMethod = _data["authMethod"];
        }
    }

    static fromJS(data: any): ConnectionSettingsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionSettingsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ignoreSslErrors"] = this.ignoreSslErrors;
        data["password"] = this.password;
        data["userName"] = this.userName;
        data["apiKey"] = this.apiKey;
        data["accessToken"] = this.accessToken;
        data["authMethod"] = this.authMethod;
        return data;
    }
}

export interface IConnectionSettingsInputDto {
    ignoreSslErrors: boolean;
    password?: string | undefined;
    userName?: string | undefined;
    apiKey?: string | undefined;
    accessToken?: string | undefined;
    authMethod: AuthMethods;
}

export class ConnectionSettingsOutputDto implements IConnectionSettingsOutputDto {
    account?: AccountInfoDto;
    webRoot!: string;
    userName?: string;
    ignoreSslErrors!: boolean;
    passwordLength!: number;
    apiKeyLength!: number;
    authMethod?: AuthMethods;

    constructor(data?: IConnectionSettingsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"] ? AccountInfoDto.fromJS(_data["account"]) : <any>undefined;
            this.webRoot = _data["webRoot"];
            this.userName = _data["userName"];
            this.ignoreSslErrors = _data["ignoreSslErrors"];
            this.passwordLength = _data["passwordLength"];
            this.apiKeyLength = _data["apiKeyLength"];
            this.authMethod = _data["authMethod"];
        }
    }

    static fromJS(data: any): ConnectionSettingsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionSettingsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["webRoot"] = this.webRoot;
        data["userName"] = this.userName;
        data["ignoreSslErrors"] = this.ignoreSslErrors;
        data["passwordLength"] = this.passwordLength;
        data["apiKeyLength"] = this.apiKeyLength;
        data["authMethod"] = this.authMethod;
        return data;
    }
}

export interface IConnectionSettingsOutputDto {
    account?: AccountInfoDto;
    webRoot: string;
    userName?: string;
    ignoreSslErrors: boolean;
    passwordLength: number;
    apiKeyLength: number;
    authMethod?: AuthMethods;
}

export class ConnectionVerifyResult implements IConnectionVerifyResult {
    resultType?: ConnectionResultType;
    errorMessage?: string | undefined;
    applicationRoot?: string;
    serviceProvider?: ServiceProvider;
    email?: string;
    maxUsersCount?: number | undefined;
    company?: string | undefined;
    buildVersion?: string | undefined;
    userName?: string;
    userId?: string | undefined;
    serviceAccountId?: string | undefined;

    constructor(data?: IConnectionVerifyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultType = _data["resultType"];
            this.errorMessage = _data["errorMessage"];
            this.applicationRoot = _data["applicationRoot"];
            this.serviceProvider = _data["serviceProvider"];
            this.email = _data["email"];
            this.maxUsersCount = _data["maxUsersCount"];
            this.company = _data["company"];
            this.buildVersion = _data["buildVersion"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.serviceAccountId = _data["serviceAccountId"];
        }
    }

    static fromJS(data: any): ConnectionVerifyResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionVerifyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultType"] = this.resultType;
        data["errorMessage"] = this.errorMessage;
        data["applicationRoot"] = this.applicationRoot;
        data["serviceProvider"] = this.serviceProvider;
        data["email"] = this.email;
        data["maxUsersCount"] = this.maxUsersCount;
        data["company"] = this.company;
        data["buildVersion"] = this.buildVersion;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["serviceAccountId"] = this.serviceAccountId;
        return data;
    }
}

export interface IConnectionVerifyResult {
    resultType?: ConnectionResultType;
    errorMessage?: string | undefined;
    applicationRoot?: string;
    serviceProvider?: ServiceProvider;
    email?: string;
    maxUsersCount?: number | undefined;
    company?: string | undefined;
    buildVersion?: string | undefined;
    userName?: string;
    userId?: string | undefined;
    serviceAccountId?: string | undefined;
}

export class ConnectorEditDataDto implements IConnectorEditDataDto {
    serviceProvider?: ServiceProvider;
    serviceProviderName?: string;
    isPasswordSupported!: boolean;
    isTokenSupported!: boolean;
    defaultWebRoot?: string;
    defaultCode?: string;
    defaultColor?: string;
    defaultIconUrl?: string;
    defaultIconBase64?: string;
    isCrm!: boolean;
    isTaskManagement!: boolean;
    isDocumentManagement!: boolean;
    isServiceDesk!: boolean;
    defaultSettings?: ConnectionSettingsOutputDto;

    constructor(data?: IConnectorEditDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceProvider = _data["serviceProvider"];
            this.serviceProviderName = _data["serviceProviderName"];
            this.isPasswordSupported = _data["isPasswordSupported"];
            this.isTokenSupported = _data["isTokenSupported"];
            this.defaultWebRoot = _data["defaultWebRoot"];
            this.defaultCode = _data["defaultCode"];
            this.defaultColor = _data["defaultColor"];
            this.defaultIconUrl = _data["defaultIconUrl"];
            this.defaultIconBase64 = _data["defaultIconBase64"];
            this.isCrm = _data["isCrm"];
            this.isTaskManagement = _data["isTaskManagement"];
            this.isDocumentManagement = _data["isDocumentManagement"];
            this.isServiceDesk = _data["isServiceDesk"];
            this.defaultSettings = _data["defaultSettings"] ? ConnectionSettingsOutputDto.fromJS(_data["defaultSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConnectorEditDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorEditDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceProvider"] = this.serviceProvider;
        data["serviceProviderName"] = this.serviceProviderName;
        data["isPasswordSupported"] = this.isPasswordSupported;
        data["isTokenSupported"] = this.isTokenSupported;
        data["defaultWebRoot"] = this.defaultWebRoot;
        data["defaultCode"] = this.defaultCode;
        data["defaultColor"] = this.defaultColor;
        data["defaultIconUrl"] = this.defaultIconUrl;
        data["defaultIconBase64"] = this.defaultIconBase64;
        data["isCrm"] = this.isCrm;
        data["isTaskManagement"] = this.isTaskManagement;
        data["isDocumentManagement"] = this.isDocumentManagement;
        data["isServiceDesk"] = this.isServiceDesk;
        data["defaultSettings"] = this.defaultSettings ? this.defaultSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConnectorEditDataDto {
    serviceProvider?: ServiceProvider;
    serviceProviderName?: string;
    isPasswordSupported: boolean;
    isTokenSupported: boolean;
    defaultWebRoot?: string;
    defaultCode?: string;
    defaultColor?: string;
    defaultIconUrl?: string;
    defaultIconBase64?: string;
    isCrm: boolean;
    isTaskManagement: boolean;
    isDocumentManagement: boolean;
    isServiceDesk: boolean;
    defaultSettings?: ConnectionSettingsOutputDto;
}

export class Contact implements IContact {
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string;
    id!: string;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.avatarUrl = _data["avatarUrl"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["avatarUrl"] = this.avatarUrl;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface IContact {
    name?: string | undefined;
    avatarUrl?: string | undefined;
    email?: string;
    id: string;
}

export class ContactDto implements IContactDto {
    email?: string | undefined;
    name?: string | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        return data;
    }
}

export interface IContactDto {
    email?: string | undefined;
    name?: string | undefined;
}

export class ContactItemIdentity implements IContactItemIdentity {
    contactEmail!: string;
    contactName?: string | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IContactItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactEmail = _data["contactEmail"];
            this.contactName = _data["contactName"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): ContactItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ContactItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactEmail"] = this.contactEmail;
        data["contactName"] = this.contactName;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IContactItemIdentity {
    contactEmail: string;
    contactName?: string | undefined;
    serviceProvider?: ServiceProvider;
}

export class ContactLookupItem implements IContactLookupItem {
    email?: string;
    phone?: string;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: IContactLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): ContactLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface IContactLookupItem {
    email?: string;
    phone?: string;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export class CreateAccountInputDto implements ICreateAccountInputDto {
    name?: string | undefined;
    webRoot!: string;
    isDefault!: boolean;
    serviceProvider!: ServiceProvider;

    constructor(data?: ICreateAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.webRoot = _data["webRoot"];
            this.isDefault = _data["isDefault"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): CreateAccountInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["webRoot"] = this.webRoot;
        data["isDefault"] = this.isDefault;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface ICreateAccountInputDto {
    name?: string | undefined;
    webRoot: string;
    isDefault: boolean;
    serviceProvider: ServiceProvider;
}

export class CreateSupportTicketInput implements ICreateSupportTicketInput {
    userName?: string | undefined;
    userEmail?: string | undefined;
    stepsToReproduce?: string | undefined;
    traceId?: string | undefined;
    lastError?: LastErrorInput;

    constructor(data?: ICreateSupportTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.stepsToReproduce = _data["stepsToReproduce"];
            this.traceId = _data["traceId"];
            this.lastError = _data["lastError"] ? LastErrorInput.fromJS(_data["lastError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSupportTicketInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportTicketInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["stepsToReproduce"] = this.stepsToReproduce;
        data["traceId"] = this.traceId;
        data["lastError"] = this.lastError ? this.lastError.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateSupportTicketInput {
    userName?: string | undefined;
    userEmail?: string | undefined;
    stepsToReproduce?: string | undefined;
    traceId?: string | undefined;
    lastError?: LastErrorInput;
}

export class CreateUpdateActivityInputDto implements ICreateUpdateActivityInputDto {
    name!: string;
    accountId!: number;
    projectFullId!: string;
    projectId!: string;
    parentFullId?: string | undefined;
    parentId?: string | undefined;
    trackerId?: string | undefined;
    statusId?: string;
    priorityId?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progress!: number;
    addNote?: AddNoteDto;
    isFavorite!: boolean;
    attachmentToSubmit?: Attachment[] | undefined;
    changeStatusToCompleted?: boolean | undefined;
    assigneeIds?: string[] | undefined;
    extensionData?: ActivityExtensionData;

    constructor(data?: ICreateUpdateActivityInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.progress = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.projectFullId = _data["projectFullId"];
            this.projectId = _data["projectId"];
            this.parentFullId = _data["parentFullId"];
            this.parentId = _data["parentId"];
            this.trackerId = _data["trackerId"];
            this.statusId = _data["statusId"];
            this.priorityId = _data["priorityId"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.progress = _data["progress"] !== undefined ? _data["progress"] : 0;
            this.addNote = _data["addNote"] ? AddNoteDto.fromJS(_data["addNote"]) : <any>undefined;
            this.isFavorite = _data["isFavorite"];
            if (Array.isArray(_data["attachmentToSubmit"])) {
                this.attachmentToSubmit = [] as any;
                for (let item of _data["attachmentToSubmit"])
                    this.attachmentToSubmit!.push(Attachment.fromJS(item));
            }
            this.changeStatusToCompleted = _data["changeStatusToCompleted"];
            if (Array.isArray(_data["assigneeIds"])) {
                this.assigneeIds = [] as any;
                for (let item of _data["assigneeIds"])
                    this.assigneeIds!.push(item);
            }
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUpdateActivityInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateActivityInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["projectFullId"] = this.projectFullId;
        data["projectId"] = this.projectId;
        data["parentFullId"] = this.parentFullId;
        data["parentId"] = this.parentId;
        data["trackerId"] = this.trackerId;
        data["statusId"] = this.statusId;
        data["priorityId"] = this.priorityId;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["progress"] = this.progress;
        data["addNote"] = this.addNote ? this.addNote.toJSON() : <any>undefined;
        data["isFavorite"] = this.isFavorite;
        if (Array.isArray(this.attachmentToSubmit)) {
            data["attachmentToSubmit"] = [];
            for (let item of this.attachmentToSubmit)
                data["attachmentToSubmit"].push(item.toJSON());
        }
        data["changeStatusToCompleted"] = this.changeStatusToCompleted;
        if (Array.isArray(this.assigneeIds)) {
            data["assigneeIds"] = [];
            for (let item of this.assigneeIds)
                data["assigneeIds"].push(item);
        }
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateActivityInputDto {
    name: string;
    accountId: number;
    projectFullId: string;
    projectId: string;
    parentFullId?: string | undefined;
    parentId?: string | undefined;
    trackerId?: string | undefined;
    statusId?: string;
    priorityId?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progress: number;
    addNote?: AddNoteDto;
    isFavorite: boolean;
    attachmentToSubmit?: Attachment[] | undefined;
    changeStatusToCompleted?: boolean | undefined;
    assigneeIds?: string[] | undefined;
    extensionData?: ActivityExtensionData;
}

export enum CreatedReason {
    NotSet = "NotSet",
    AccountCreated = "AccountCreated",
    UserInitiated = "UserInitiated",
    UserAction = "UserAction",
    Periodic = "Periodic",
    AdminInitiated = "AdminInitiated",
    SessionStart = "SessionStart",
    MissedData = "MissedData",
}

export class CustomField implements ICustomField {
    fieldName!: string;
    displayName?: string;
    isRequired!: boolean;
    isRestricted!: boolean;
    isMultiple!: boolean;
    regexp?: string;
    order?: number | undefined;
    description?: string;
    entity?: string;
    fieldTypeEnum?: FieldType;
    defaultValue?: string;
    availableValues?: string;
    valuePairs?: string;
    isVisible!: boolean;
    name?: string;

    constructor(data?: ICustomField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.displayName = _data["displayName"];
            this.isRequired = _data["isRequired"];
            this.isRestricted = _data["isRestricted"];
            this.isMultiple = _data["isMultiple"];
            this.regexp = _data["regexp"];
            this.order = _data["order"];
            this.description = _data["description"];
            this.entity = _data["entity"];
            this.fieldTypeEnum = _data["fieldTypeEnum"];
            this.defaultValue = _data["defaultValue"];
            this.availableValues = _data["availableValues"];
            this.valuePairs = _data["valuePairs"];
            this.isVisible = _data["isVisible"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["displayName"] = this.displayName;
        data["isRequired"] = this.isRequired;
        data["isRestricted"] = this.isRestricted;
        data["isMultiple"] = this.isMultiple;
        data["regexp"] = this.regexp;
        data["order"] = this.order;
        data["description"] = this.description;
        data["entity"] = this.entity;
        data["fieldTypeEnum"] = this.fieldTypeEnum;
        data["defaultValue"] = this.defaultValue;
        data["availableValues"] = this.availableValues;
        data["valuePairs"] = this.valuePairs;
        data["isVisible"] = this.isVisible;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomField {
    fieldName: string;
    displayName?: string;
    isRequired: boolean;
    isRestricted: boolean;
    isMultiple: boolean;
    regexp?: string;
    order?: number | undefined;
    description?: string;
    entity?: string;
    fieldTypeEnum?: FieldType;
    defaultValue?: string;
    availableValues?: string;
    valuePairs?: string;
    isVisible: boolean;
    name?: string;
}

export class DatesAccessResponse implements IDatesAccessResponse {
    isEndDateWillShiftActivity?: boolean | undefined;
    isStartDateWillShiftActivity?: boolean | undefined;
    durationAccessType?: AccessType;
    startDateAccessType?: AccessType;
    endDateAccessType?: AccessType;

    constructor(data?: IDatesAccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEndDateWillShiftActivity = _data["isEndDateWillShiftActivity"];
            this.isStartDateWillShiftActivity = _data["isStartDateWillShiftActivity"];
            this.durationAccessType = _data["durationAccessType"];
            this.startDateAccessType = _data["startDateAccessType"];
            this.endDateAccessType = _data["endDateAccessType"];
        }
    }

    static fromJS(data: any): DatesAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatesAccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEndDateWillShiftActivity"] = this.isEndDateWillShiftActivity;
        data["isStartDateWillShiftActivity"] = this.isStartDateWillShiftActivity;
        data["durationAccessType"] = this.durationAccessType;
        data["startDateAccessType"] = this.startDateAccessType;
        data["endDateAccessType"] = this.endDateAccessType;
        return data;
    }
}

export interface IDatesAccessResponse {
    isEndDateWillShiftActivity?: boolean | undefined;
    isStartDateWillShiftActivity?: boolean | undefined;
    durationAccessType?: AccessType;
    startDateAccessType?: AccessType;
    endDateAccessType?: AccessType;
}

export class DeleteTimeEntryRequest implements IDeleteTimeEntryRequest {
    timeEntryId?: string;
    timerId!: string;

    constructor(data?: IDeleteTimeEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeEntryId = _data["timeEntryId"];
            this.timerId = _data["timerId"];
        }
    }

    static fromJS(data: any): DeleteTimeEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTimeEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeEntryId"] = this.timeEntryId;
        data["timerId"] = this.timerId;
        return data;
    }
}

export interface IDeleteTimeEntryRequest {
    timeEntryId?: string;
    timerId: string;
}

export enum DescriptionFormats {
    NotHtml = "NotHtml",
    DefaultHtml = "DefaultHtml",
    ForceHtml = "ForceHtml",
    ForceTextile = "ForceTextile",
    ForceMarkDown = "ForceMarkDown",
    ForceText = "ForceText",
    Any = "Any",
}

export class Document implements IDocument {
    documentUid?: string | undefined;
    fileName?: string | undefined;
    path?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;
    description?: string | undefined;
    isLocalFile!: boolean;
    id!: string;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentUid = _data["documentUid"];
            this.fileName = _data["fileName"];
            this.path = _data["path"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.description = _data["description"];
            this.isLocalFile = _data["isLocalFile"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentUid"] = this.documentUid;
        data["fileName"] = this.fileName;
        data["path"] = this.path;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["description"] = this.description;
        data["isLocalFile"] = this.isLocalFile;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocument {
    documentUid?: string | undefined;
    fileName?: string | undefined;
    path?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;
    description?: string | undefined;
    isLocalFile: boolean;
    id: string;
}

export class DocumentItemIdentity implements IDocumentItemIdentity {
    title!: string;
    documentId?: string;
    documentPath?: string | undefined;
    isLocalFile!: boolean;
    contentType?: string | undefined;
    fileSize?: number | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IDocumentItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.documentId = _data["documentId"];
            this.documentPath = _data["documentPath"];
            this.isLocalFile = _data["isLocalFile"];
            this.contentType = _data["contentType"];
            this.fileSize = _data["fileSize"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): DocumentItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["documentId"] = this.documentId;
        data["documentPath"] = this.documentPath;
        data["isLocalFile"] = this.isLocalFile;
        data["contentType"] = this.contentType;
        data["fileSize"] = this.fileSize;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IDocumentItemIdentity {
    title: string;
    documentId?: string;
    documentPath?: string | undefined;
    isLocalFile: boolean;
    contentType?: string | undefined;
    fileSize?: number | undefined;
    serviceProvider?: ServiceProvider;
}

export class DocumentLookupItem implements IDocumentLookupItem {
    fileSize!: number;
    folderPath?: string;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: IDocumentLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileSize = _data["fileSize"];
            this.folderPath = _data["folderPath"];
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): DocumentLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSize"] = this.fileSize;
        data["folderPath"] = this.folderPath;
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface IDocumentLookupItem {
    fileSize: number;
    folderPath?: string;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export enum EditedField {
    StartDate = "StartDate",
    EndDate = "EndDate",
    Duration = "Duration",
}

export class Email implements IEmail {
    subject?: string | undefined;
    messageId?: string | undefined;
    senderEmail?: string;
    senderName?: string | undefined;
    to?: string | undefined;
    id!: string;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.messageId = _data["messageId"];
            this.senderEmail = _data["senderEmail"];
            this.senderName = _data["senderName"];
            this.to = _data["to"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["messageId"] = this.messageId;
        data["senderEmail"] = this.senderEmail;
        data["senderName"] = this.senderName;
        data["to"] = this.to;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmail {
    subject?: string | undefined;
    messageId?: string | undefined;
    senderEmail?: string;
    senderName?: string | undefined;
    to?: string | undefined;
    id: string;
}

export enum FieldType {
    String = "String",
    Integer = "Integer",
    Numeric = "Numeric",
    Date = "Date",
    Boolean = "Boolean",
    List = "List",
    TextArea = "TextArea",
    TextAreaRich = "TextAreaRich",
    Hyperlink = "Hyperlink",
    Version = "Version",
    User = "User",
    File = "File",
}

export class GetAccountStateOutput implements IGetAccountStateOutput {
    accountId!: number;
    status?: AccountInfoStatus;
    shouldVerifyAccountSettings!: boolean;
    shouldContactSupport!: boolean;
    shouldContactSupportReason?: ShouldContactSupportReason;
    shouldContactSupportReasonObsolete?: string;

    constructor(data?: IGetAccountStateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.status = _data["status"];
            this.shouldVerifyAccountSettings = _data["shouldVerifyAccountSettings"];
            this.shouldContactSupport = _data["shouldContactSupport"];
            this.shouldContactSupportReason = _data["shouldContactSupportReason"] ? ShouldContactSupportReason.fromJS(_data["shouldContactSupportReason"]) : <any>undefined;
            this.shouldContactSupportReasonObsolete = _data["shouldContactSupportReasonObsolete"];
        }
    }

    static fromJS(data: any): GetAccountStateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountStateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["status"] = this.status;
        data["shouldVerifyAccountSettings"] = this.shouldVerifyAccountSettings;
        data["shouldContactSupport"] = this.shouldContactSupport;
        data["shouldContactSupportReason"] = this.shouldContactSupportReason ? this.shouldContactSupportReason.toJSON() : <any>undefined;
        data["shouldContactSupportReasonObsolete"] = this.shouldContactSupportReasonObsolete;
        return data;
    }
}

export interface IGetAccountStateOutput {
    accountId: number;
    status?: AccountInfoStatus;
    shouldVerifyAccountSettings: boolean;
    shouldContactSupport: boolean;
    shouldContactSupportReason?: ShouldContactSupportReason;
    shouldContactSupportReasonObsolete?: string;
}

export class GetActivityEditDataRequestDto implements IGetActivityEditDataRequestDto {
    name?: string | undefined;
    statusId?: string | undefined;
    projectFullId?: string | undefined;
    trackerId?: string | undefined;
    parentFullId?: string | undefined;

    constructor(data?: IGetActivityEditDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.statusId = _data["statusId"];
            this.projectFullId = _data["projectFullId"];
            this.trackerId = _data["trackerId"];
            this.parentFullId = _data["parentFullId"];
        }
    }

    static fromJS(data: any): GetActivityEditDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityEditDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["statusId"] = this.statusId;
        data["projectFullId"] = this.projectFullId;
        data["trackerId"] = this.trackerId;
        data["parentFullId"] = this.parentFullId;
        return data;
    }
}

export interface IGetActivityEditDataRequestDto {
    name?: string | undefined;
    statusId?: string | undefined;
    projectFullId?: string | undefined;
    trackerId?: string | undefined;
    parentFullId?: string | undefined;
}

export class GetAttachmentDto implements IGetAttachmentDto {
    token?: string;
    restUrl?: string;
    attachmentId?: string;
    messageId?: string;

    constructor(data?: IGetAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.restUrl = _data["restUrl"];
            this.attachmentId = _data["attachmentId"];
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): GetAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["restUrl"] = this.restUrl;
        data["attachmentId"] = this.attachmentId;
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IGetAttachmentDto {
    token?: string;
    restUrl?: string;
    attachmentId?: string;
    messageId?: string;
}

export class GetMessageDto implements IGetMessageDto {
    token?: string;
    restUrl?: string;
    messageId?: string;

    constructor(data?: IGetMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.restUrl = _data["restUrl"];
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): GetMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["restUrl"] = this.restUrl;
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IGetMessageDto {
    token?: string;
    restUrl?: string;
    messageId?: string;
}

export class GetNewActivityInputDto implements IGetNewActivityInputDto {
    name?: string | undefined;
    projectFullId?: string | undefined;
    projectName?: string | undefined;
    parentFullId?: string | undefined;
    parentName?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    statusId?: string | undefined;
    statusName?: string | undefined;
    trackerId?: string | undefined;
    assignees?: string[] | undefined;

    constructor(data?: IGetNewActivityInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectFullId = _data["projectFullId"];
            this.projectName = _data["projectName"];
            this.parentFullId = _data["parentFullId"];
            this.parentName = _data["parentName"];
            this.priorityId = _data["priorityId"];
            this.priorityName = _data["priorityName"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.trackerId = _data["trackerId"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(item);
            }
        }
    }

    static fromJS(data: any): GetNewActivityInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewActivityInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectFullId"] = this.projectFullId;
        data["projectName"] = this.projectName;
        data["parentFullId"] = this.parentFullId;
        data["parentName"] = this.parentName;
        data["priorityId"] = this.priorityId;
        data["priorityName"] = this.priorityName;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["trackerId"] = this.trackerId;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item);
        }
        return data;
    }
}

export interface IGetNewActivityInputDto {
    name?: string | undefined;
    projectFullId?: string | undefined;
    projectName?: string | undefined;
    parentFullId?: string | undefined;
    parentName?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    description?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    statusId?: string | undefined;
    statusName?: string | undefined;
    trackerId?: string | undefined;
    assignees?: string[] | undefined;
}

export class GetSessionOutput implements IGetSessionOutput {
    application?: ApplicationInfoDto;
    user?: Auth0UserInfo;
    isActive!: boolean;
    traceId?: string | undefined;

    constructor(data?: IGetSessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? Auth0UserInfo.fromJS(_data["user"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): GetSessionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSessionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["traceId"] = this.traceId;
        return data;
    }
}

export interface IGetSessionOutput {
    application?: ApplicationInfoDto;
    user?: Auth0UserInfo;
    isActive: boolean;
    traceId?: string | undefined;
}

export class Holiday implements IHoliday {
    name?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Holiday {
        data = typeof data === 'object' ? data : {};
        let result = new Holiday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHoliday {
    name?: string | undefined;
    date?: Date | undefined;
}

export class HostManifest implements IHostManifest {
    hostVersion?: string;
    hostInformationalVersion?: string;
    hostReleaseDate!: Date;
    aiInstrumentationKey?: string;
    serverRootAddress?: string;
    auth0Domain?: string;
    auth0ApiIdentifier?: string;
    environmentName?: string;
    isStaging!: boolean;

    constructor(data?: IHostManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostVersion = _data["hostVersion"];
            this.hostInformationalVersion = _data["hostInformationalVersion"];
            this.hostReleaseDate = _data["hostReleaseDate"] ? new Date(_data["hostReleaseDate"].toString()) : <any>undefined;
            this.aiInstrumentationKey = _data["aiInstrumentationKey"];
            this.serverRootAddress = _data["serverRootAddress"];
            this.auth0Domain = _data["auth0Domain"];
            this.auth0ApiIdentifier = _data["auth0ApiIdentifier"];
            this.environmentName = _data["environmentName"];
            this.isStaging = _data["isStaging"];
        }
    }

    static fromJS(data: any): HostManifest {
        data = typeof data === 'object' ? data : {};
        let result = new HostManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostVersion"] = this.hostVersion;
        data["hostInformationalVersion"] = this.hostInformationalVersion;
        data["hostReleaseDate"] = this.hostReleaseDate ? this.hostReleaseDate.toISOString() : <any>undefined;
        data["aiInstrumentationKey"] = this.aiInstrumentationKey;
        data["serverRootAddress"] = this.serverRootAddress;
        data["auth0Domain"] = this.auth0Domain;
        data["auth0ApiIdentifier"] = this.auth0ApiIdentifier;
        data["environmentName"] = this.environmentName;
        data["isStaging"] = this.isStaging;
        return data;
    }
}

export interface IHostManifest {
    hostVersion?: string;
    hostInformationalVersion?: string;
    hostReleaseDate: Date;
    aiInstrumentationKey?: string;
    serverRootAddress?: string;
    auth0Domain?: string;
    auth0ApiIdentifier?: string;
    environmentName?: string;
    isStaging: boolean;
}

export class IActivityItemData implements IIActivityItemData {
    activityId?: string | undefined;
    activity?: ActivityLookupItem;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIActivityItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? ActivityLookupItem.fromJS(_data["activity"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IActivityItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IActivityItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIActivityItemData {
    activityId?: string | undefined;
    activity?: ActivityLookupItem;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IActivitySyncItem implements IIActivitySyncItem {
    attachments?: Attachment[];
    features?: ActivityFeatures;
    itemCounts?: ActivityItemsCounts;
    journals?: JournalItem[];
    messages?: Message[];

    constructor(data?: IIActivitySyncItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.features = _data["features"] ? ActivityFeatures.fromJS(_data["features"]) : <any>undefined;
            this.itemCounts = _data["itemCounts"] ? ActivityItemsCounts.fromJS(_data["itemCounts"]) : <any>undefined;
            if (Array.isArray(_data["journals"])) {
                this.journals = [] as any;
                for (let item of _data["journals"])
                    this.journals!.push(JournalItem.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IActivitySyncItem {
        data = typeof data === 'object' ? data : {};
        let result = new IActivitySyncItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["itemCounts"] = this.itemCounts ? this.itemCounts.toJSON() : <any>undefined;
        if (Array.isArray(this.journals)) {
            data["journals"] = [];
            for (let item of this.journals)
                data["journals"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIActivitySyncItem {
    attachments?: Attachment[];
    features?: ActivityFeatures;
    itemCounts?: ActivityItemsCounts;
    journals?: JournalItem[];
    messages?: Message[];
}

export class IBookmarkItemData implements IIBookmarkItemData {
    bookmarkId?: string | undefined;
    bookmark?: Bookmark;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIBookmarkItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookmarkId = _data["bookmarkId"];
            this.bookmark = _data["bookmark"] ? Bookmark.fromJS(_data["bookmark"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IBookmarkItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IBookmarkItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmarkId"] = this.bookmarkId;
        data["bookmark"] = this.bookmark ? this.bookmark.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIBookmarkItemData {
    bookmarkId?: string | undefined;
    bookmark?: Bookmark;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IChannelItemData implements IIChannelItemData {
    channelId?: string | undefined;
    channel?: Channel;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIChannelItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IChannelItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IChannelItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIChannelItemData {
    channelId?: string | undefined;
    channel?: Channel;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IContactItemData implements IIContactItemData {
    contactId?: string | undefined;
    contact?: Contact;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIContactItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IContactItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IContactItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIContactItemData {
    contactId?: string | undefined;
    contact?: Contact;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IDocumentItemData implements IIDocumentItemData {
    documentId?: string | undefined;
    document?: Document;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIDocumentItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IDocumentItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIDocumentItemData {
    documentId?: string | undefined;
    document?: Document;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IEmailItemData implements IIEmailItemData {
    emailId?: string | undefined;
    email?: Email;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;

    constructor(data?: IIEmailItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.email = _data["email"] ? Email.fromJS(_data["email"]) : <any>undefined;
            this.externalKey = _data["externalKey"];
            this.id = _data["id"];
            this.itemClass = _data["itemClass"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
        }
    }

    static fromJS(data: any): IEmailItemData {
        data = typeof data === 'object' ? data : {};
        let result = new IEmailItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["externalKey"] = this.externalKey;
        data["id"] = this.id;
        data["itemClass"] = this.itemClass;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        return data;
    }
}

export interface IIEmailItemData {
    emailId?: string | undefined;
    email?: Email;
    externalKey?: string;
    id?: string | undefined;
    itemClass?: ItemClass;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
}

export class IdNameDto implements IIdNameDto {
    id?: string;
    name?: string;

    constructor(data?: IIdNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIdNameDto {
    id?: string;
    name?: string;
}

export class InviteInputDto implements IInviteInputDto {
    email!: string;
    teams?: TeamDto[];
    role?: MembershipsRoles;

    constructor(data?: IInviteInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamDto.fromJS(item));
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): InviteInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["role"] = this.role;
        return data;
    }
}

export interface IInviteInputDto {
    email: string;
    teams?: TeamDto[];
    role?: MembershipsRoles;
}

export enum ItemClass {
    Tasks = "Tasks",
    Pages = "Pages",
    Emails = "Emails",
    Bookmarks = "Bookmarks",
    Contacts = "Contacts",
    Channels = "Channels",
    Documents = "Documents",
    Apps = "Apps",
    TaskAttachments = "TaskAttachments",
    TaskAssignees = "TaskAssignees",
    EmailAttachments = "EmailAttachments",
    EmailSenders = "EmailSenders",
    Workspace = "Workspace",
}

export class ItemDataDto implements IItemDataDto {
    id?: string | undefined;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    itemClass?: ItemClass;
    externalKey?: string | undefined;
    itemId?: string | undefined;
    activityId?: string | undefined;
    activity?: ActivityLookupItem;
    contactId?: string | undefined;
    contact?: Contact;
    emailId?: string | undefined;
    email?: Email;
    bookmarkId?: string | undefined;
    bookmark?: Bookmark;
    channelId?: string | undefined;
    channel?: Channel;
    workspaceId?: string | undefined;
    workspace?: WorkspaceDto;
    documentId?: string | undefined;
    document?: Document;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
    readonly name?: string | undefined;

    constructor(data?: IItemDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalUrl = _data["originalUrl"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.type = _data["type"];
            this.itemClass = _data["itemClass"];
            this.externalKey = _data["externalKey"];
            this.itemId = _data["itemId"];
            this.activityId = _data["activityId"];
            this.activity = _data["activity"] ? ActivityLookupItem.fromJS(_data["activity"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.emailId = _data["emailId"];
            this.email = _data["email"] ? Email.fromJS(_data["email"]) : <any>undefined;
            this.bookmarkId = _data["bookmarkId"];
            this.bookmark = _data["bookmark"] ? Bookmark.fromJS(_data["bookmark"]) : <any>undefined;
            this.channelId = _data["channelId"];
            this.channel = _data["channel"] ? Channel.fromJS(_data["channel"]) : <any>undefined;
            this.workspaceId = _data["workspaceId"];
            this.workspace = _data["workspace"] ? WorkspaceDto.fromJS(_data["workspace"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.hasMoreData = _data["hasMoreData"];
            this.serviceProvider = _data["serviceProvider"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): ItemDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalUrl"] = this.originalUrl;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["type"] = this.type;
        data["itemClass"] = this.itemClass;
        data["externalKey"] = this.externalKey;
        data["itemId"] = this.itemId;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["emailId"] = this.emailId;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["bookmarkId"] = this.bookmarkId;
        data["bookmark"] = this.bookmark ? this.bookmark.toJSON() : <any>undefined;
        data["channelId"] = this.channelId;
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        data["workspaceId"] = this.workspaceId;
        data["workspace"] = this.workspace ? this.workspace.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["hasMoreData"] = this.hasMoreData;
        data["serviceProvider"] = this.serviceProvider;
        data["name"] = this.name;
        return data;
    }
}

export interface IItemDataDto {
    id?: string | undefined;
    originalUrl?: string;
    thumbnailUrl?: string | undefined;
    type?: string;
    itemClass?: ItemClass;
    externalKey?: string | undefined;
    itemId?: string | undefined;
    activityId?: string | undefined;
    activity?: ActivityLookupItem;
    contactId?: string | undefined;
    contact?: Contact;
    emailId?: string | undefined;
    email?: Email;
    bookmarkId?: string | undefined;
    bookmark?: Bookmark;
    channelId?: string | undefined;
    channel?: Channel;
    workspaceId?: string | undefined;
    workspace?: WorkspaceDto;
    documentId?: string | undefined;
    document?: Document;
    hasMoreData?: boolean | undefined;
    serviceProvider?: ServiceProvider;
    name?: string | undefined;
}

export enum ItemType {
    NotSet = "NotSet",
    Task = "Task",
    Project = "Project",
    Mail = "Mail",
    Bookmark = "Bookmark",
    Document = "Document",
    Channel = "Channel",
    Contact = "Contact",
}

export class ItemVersion implements IItemVersion {
    description?: string;
    dueDate?: Date | undefined;
    isOpen!: boolean;
    name?: string;

    constructor(data?: IItemVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isOpen = _data["isOpen"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ItemVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        data["name"] = this.name;
        return data;
    }
}

export interface IItemVersion {
    description?: string;
    dueDate?: Date | undefined;
    isOpen: boolean;
    name?: string;
}

export class JournalItem implements IJournalItem {
    journalItemId?: string;
    note?: string;
    changedDate!: Date;
    changes?: JournalPropertyChange[];
    isPrivate!: boolean;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;

    constructor(data?: IJournalItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalItemId = _data["journalItemId"];
            this.note = _data["note"];
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(JournalPropertyChange.fromJS(item));
            }
            this.isPrivate = _data["isPrivate"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.updatedById = _data["updatedById"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): JournalItem {
        data = typeof data === 'object' ? data : {};
        let result = new JournalItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalItemId"] = this.journalItemId;
        data["note"] = this.note;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        data["isPrivate"] = this.isPrivate;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["updatedById"] = this.updatedById;
        data["updatedByName"] = this.updatedByName;
        return data;
    }
}

export interface IJournalItem {
    journalItemId?: string;
    note?: string;
    changedDate: Date;
    changes?: JournalPropertyChange[];
    isPrivate: boolean;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;
}

export class JournalPropertyChange implements IJournalPropertyChange {
    type?: string;
    propertyName?: string;
    oldValue?: string;
    newValue?: string;

    constructor(data?: IJournalPropertyChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.propertyName = _data["propertyName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): JournalPropertyChange {
        data = typeof data === 'object' ? data : {};
        let result = new JournalPropertyChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["propertyName"] = this.propertyName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IJournalPropertyChange {
    type?: string;
    propertyName?: string;
    oldValue?: string;
    newValue?: string;
}

export class LastErrorInput implements ILastErrorInput {
    accountId?: number | undefined;
    details?: string | undefined;
    message?: string | undefined;
    stack?: string | undefined;
    traceId?: string | undefined;

    constructor(data?: ILastErrorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.details = _data["details"];
            this.message = _data["message"];
            this.stack = _data["stack"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): LastErrorInput {
        data = typeof data === 'object' ? data : {};
        let result = new LastErrorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["details"] = this.details;
        data["message"] = this.message;
        data["stack"] = this.stack;
        data["traceId"] = this.traceId;
        return data;
    }
}

export interface ILastErrorInput {
    accountId?: number | undefined;
    details?: string | undefined;
    message?: string | undefined;
    stack?: string | undefined;
    traceId?: string | undefined;
}

export class LicenseInfoDto implements ILicenseInfoDto {
    licensedFor?: string | undefined;
    serialNumber?: string | undefined;
    licenseInfo?: string | undefined;
    isActive!: boolean;
    isTrial!: boolean;
    isActivateRequired!: boolean;
    statusInfo?: string | undefined;
    expiredDate!: Date;
    serverProviderPath?: string | undefined;
    isPersonal!: boolean;
    isEnterpriseLicensed!: boolean;
    signatureValue?: string | undefined;
    recurringMonths!: number;

    constructor(data?: ILicenseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensedFor = _data["licensedFor"];
            this.serialNumber = _data["serialNumber"];
            this.licenseInfo = _data["licenseInfo"];
            this.isActive = _data["isActive"];
            this.isTrial = _data["isTrial"];
            this.isActivateRequired = _data["isActivateRequired"];
            this.statusInfo = _data["statusInfo"];
            this.expiredDate = _data["expiredDate"] ? new Date(_data["expiredDate"].toString()) : <any>undefined;
            this.serverProviderPath = _data["serverProviderPath"];
            this.isPersonal = _data["isPersonal"];
            this.isEnterpriseLicensed = _data["isEnterpriseLicensed"];
            this.signatureValue = _data["signatureValue"];
            this.recurringMonths = _data["recurringMonths"];
        }
    }

    static fromJS(data: any): LicenseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensedFor"] = this.licensedFor;
        data["serialNumber"] = this.serialNumber;
        data["licenseInfo"] = this.licenseInfo;
        data["isActive"] = this.isActive;
        data["isTrial"] = this.isTrial;
        data["isActivateRequired"] = this.isActivateRequired;
        data["statusInfo"] = this.statusInfo;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["serverProviderPath"] = this.serverProviderPath;
        data["isPersonal"] = this.isPersonal;
        data["isEnterpriseLicensed"] = this.isEnterpriseLicensed;
        data["signatureValue"] = this.signatureValue;
        data["recurringMonths"] = this.recurringMonths;
        return data;
    }
}

export interface ILicenseInfoDto {
    licensedFor?: string | undefined;
    serialNumber?: string | undefined;
    licenseInfo?: string | undefined;
    isActive: boolean;
    isTrial: boolean;
    isActivateRequired: boolean;
    statusInfo?: string | undefined;
    expiredDate: Date;
    serverProviderPath?: string | undefined;
    isPersonal: boolean;
    isEnterpriseLicensed: boolean;
    signatureValue?: string | undefined;
    recurringMonths: number;
}

export class ListsDto implements IListsDto {
    project?: ProjectLookupItem;
    trackers?: ActivityTrackerDto[];
    defaultTracker?: ActivityTrackerDto;
    tracker?: ActivityTrackerDto;
    statuses?: ActivityStatusDto[];
    defaultStatus?: ActivityStatusDto;
    priorites?: PriorityDto[];
    defaultPriority?: PriorityDto;
    categories?: Category[];
    defaultCategory?: Category;

    constructor(data?: IListsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectLookupItem.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["trackers"])) {
                this.trackers = [] as any;
                for (let item of _data["trackers"])
                    this.trackers!.push(ActivityTrackerDto.fromJS(item));
            }
            this.defaultTracker = _data["defaultTracker"] ? ActivityTrackerDto.fromJS(_data["defaultTracker"]) : <any>undefined;
            this.tracker = _data["tracker"] ? ActivityTrackerDto.fromJS(_data["tracker"]) : <any>undefined;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(ActivityStatusDto.fromJS(item));
            }
            this.defaultStatus = _data["defaultStatus"] ? ActivityStatusDto.fromJS(_data["defaultStatus"]) : <any>undefined;
            if (Array.isArray(_data["priorites"])) {
                this.priorites = [] as any;
                for (let item of _data["priorites"])
                    this.priorites!.push(PriorityDto.fromJS(item));
            }
            this.defaultPriority = _data["defaultPriority"] ? PriorityDto.fromJS(_data["defaultPriority"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            this.defaultCategory = _data["defaultCategory"] ? Category.fromJS(_data["defaultCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.trackers)) {
            data["trackers"] = [];
            for (let item of this.trackers)
                data["trackers"].push(item.toJSON());
        }
        data["defaultTracker"] = this.defaultTracker ? this.defaultTracker.toJSON() : <any>undefined;
        data["tracker"] = this.tracker ? this.tracker.toJSON() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["defaultStatus"] = this.defaultStatus ? this.defaultStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.priorites)) {
            data["priorites"] = [];
            for (let item of this.priorites)
                data["priorites"].push(item.toJSON());
        }
        data["defaultPriority"] = this.defaultPriority ? this.defaultPriority.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["defaultCategory"] = this.defaultCategory ? this.defaultCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListsDto {
    project?: ProjectLookupItem;
    trackers?: ActivityTrackerDto[];
    defaultTracker?: ActivityTrackerDto;
    tracker?: ActivityTrackerDto;
    statuses?: ActivityStatusDto[];
    defaultStatus?: ActivityStatusDto;
    priorites?: PriorityDto[];
    defaultPriority?: PriorityDto;
    categories?: Category[];
    defaultCategory?: Category;
}

export class LookupItem implements ILookupItem {
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: ILookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): LookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new LookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface ILookupItem {
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export class LookupRequestInput implements ILookupRequestInput {
    sorting?: string | undefined;
    parentClientId?: string | undefined;
    filterByAccountId?: number | undefined;
    skipCount?: number | undefined;
    maxResultCount?: number | undefined;
    filterBy?: string | undefined;
    filterByCompleted?: boolean | undefined;
    filterByAssignedToMe?: boolean | undefined;
    projectId?: string | undefined;
    types?: ItemType[];

    constructor(data?: ILookupRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.parentClientId = _data["parentClientId"];
            this.filterByAccountId = _data["filterByAccountId"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.filterBy = _data["filterBy"];
            this.filterByCompleted = _data["filterByCompleted"];
            this.filterByAssignedToMe = _data["filterByAssignedToMe"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): LookupRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new LookupRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["parentClientId"] = this.parentClientId;
        data["filterByAccountId"] = this.filterByAccountId;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["filterBy"] = this.filterBy;
        data["filterByCompleted"] = this.filterByCompleted;
        data["filterByAssignedToMe"] = this.filterByAssignedToMe;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface ILookupRequestInput {
    sorting?: string | undefined;
    parentClientId?: string | undefined;
    filterByAccountId?: number | undefined;
    skipCount?: number | undefined;
    maxResultCount?: number | undefined;
    filterBy?: string | undefined;
    filterByCompleted?: boolean | undefined;
    filterByAssignedToMe?: boolean | undefined;
    projectId?: string | undefined;
    types?: ItemType[];
}

export class MailItemAttachment implements IMailItemAttachment {
    attachmentId!: string;
    fileName!: string;
    attachUrl?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;

    constructor(data?: IMailItemAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.fileName = _data["fileName"];
            this.attachUrl = _data["attachUrl"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): MailItemAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MailItemAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["fileName"] = this.fileName;
        data["attachUrl"] = this.attachUrl;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IMailItemAttachment {
    attachmentId: string;
    fileName: string;
    attachUrl?: string | undefined;
    fileType?: string | undefined;
    fileSize?: number | undefined;
}

export class MailItemIdentity implements IMailItemIdentity {
    mailItemId!: string;
    mailSubject?: string | undefined;
    mailInternetMessageId!: string;
    mailConversationId?: string | undefined;
    mailSenderAddress!: string;
    mailSenderName?: string | undefined;
    attachments?: MailItemAttachment[] | undefined;

    constructor(data?: IMailItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailItemId = _data["mailItemId"];
            this.mailSubject = _data["mailSubject"];
            this.mailInternetMessageId = _data["mailInternetMessageId"];
            this.mailConversationId = _data["mailConversationId"];
            this.mailSenderAddress = _data["mailSenderAddress"];
            this.mailSenderName = _data["mailSenderName"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(MailItemAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new MailItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailItemId"] = this.mailItemId;
        data["mailSubject"] = this.mailSubject;
        data["mailInternetMessageId"] = this.mailInternetMessageId;
        data["mailConversationId"] = this.mailConversationId;
        data["mailSenderAddress"] = this.mailSenderAddress;
        data["mailSenderName"] = this.mailSenderName;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailItemIdentity {
    mailItemId: string;
    mailSubject?: string | undefined;
    mailInternetMessageId: string;
    mailConversationId?: string | undefined;
    mailSenderAddress: string;
    mailSenderName?: string | undefined;
    attachments?: MailItemAttachment[] | undefined;
}

export class MailLookupItem implements IMailLookupItem {
    senderEmail?: string;
    senderName?: string;
    hasAttachments!: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    readonly id!: string;
    readonly fullId!: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    isFavorite!: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;

    constructor(data?: IMailLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isFavorite = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderEmail = _data["senderEmail"];
            this.senderName = _data["senderName"];
            this.hasAttachments = _data["hasAttachments"];
            this.itemType = _data["itemType"];
            this.serviceItemType = _data["serviceItemType"];
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.isFavorite = _data["isFavorite"] !== undefined ? _data["isFavorite"] : false;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.extensionData = _data["extensionData"] ? ActivityExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
            this.originalUrl = _data["originalUrl"];
        }
    }

    static fromJS(data: any): MailLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new MailLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderEmail"] = this.senderEmail;
        data["senderName"] = this.senderName;
        data["hasAttachments"] = this.hasAttachments;
        data["itemType"] = this.itemType;
        data["serviceItemType"] = this.serviceItemType;
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["isFavorite"] = this.isFavorite;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        data["originalUrl"] = this.originalUrl;
        return data;
    }
}

export interface IMailLookupItem {
    senderEmail?: string;
    senderName?: string;
    hasAttachments: boolean;
    itemType?: ItemType;
    serviceItemType?: string | undefined;
    id: string;
    fullId: string;
    accountId: number;
    clientId: string;
    name: string;
    isFavorite: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    createdOn?: Date | undefined;
    accountIconUrl?: string | undefined;
    service?: ServiceProvider;
    displayId?: string | undefined;
    color?: string | undefined;
    extensionData?: ActivityExtensionData;
    originalUrl?: string;
}

export class MemberDto implements IMemberDto {
    readonly userId!: number;
    organizationId!: number;
    name?: string | undefined;
    email?: string;
    role?: MembershipsRoles;
    avatar?: string | undefined;
    teams?: TeamFlatDto[];

    constructor(data?: IMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.avatar = _data["avatar"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamFlatDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        data["avatar"] = this.avatar;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMemberDto {
    userId: number;
    organizationId: number;
    name?: string | undefined;
    email?: string;
    role?: MembershipsRoles;
    avatar?: string | undefined;
    teams?: TeamFlatDto[];
}

export enum MembershipsRoles {
    Manager = "Manager",
    Member = "Member",
    Viewer = "Viewer",
}

export class Message implements IMessage {
    messageId?: string;
    text?: string;
    postDate!: Date;
    isPrivate!: boolean;
    order?: number | undefined;
    attachments?: Attachment[];
    approval?: MessageAproval;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.text = _data["text"];
            this.postDate = _data["postDate"] ? new Date(_data["postDate"].toString()) : <any>undefined;
            this.isPrivate = _data["isPrivate"];
            this.order = _data["order"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.approval = _data["approval"] ? MessageAproval.fromJS(_data["approval"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.updatedById = _data["updatedById"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["text"] = this.text;
        data["postDate"] = this.postDate ? this.postDate.toISOString() : <any>undefined;
        data["isPrivate"] = this.isPrivate;
        data["order"] = this.order;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["approval"] = this.approval ? this.approval.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["updatedById"] = this.updatedById;
        data["updatedByName"] = this.updatedByName;
        return data;
    }
}

export interface IMessage {
    messageId?: string;
    text?: string;
    postDate: Date;
    isPrivate: boolean;
    order?: number | undefined;
    attachments?: Attachment[];
    approval?: MessageAproval;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdById?: string;
    createdByName?: string;
    updatedById?: string;
    updatedByName?: string;
}

export class MessageAproval implements IMessageAproval {
    approvers?: MessageAprover[];
    isActive?: boolean | undefined;

    constructor(data?: IMessageAproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(MessageAprover.fromJS(item));
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MessageAproval {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMessageAproval {
    approvers?: MessageAprover[];
    isActive?: boolean | undefined;
}

export class MessageAprover implements IMessageAprover {
    userId?: string;
    userName?: string;
    userAvatarHash?: string;
    userAvatarUrl?: string;
    status?: string;

    constructor(data?: IMessageAprover) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userAvatarHash = _data["userAvatarHash"];
            this.userAvatarUrl = _data["userAvatarUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MessageAprover {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAprover();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userAvatarHash"] = this.userAvatarHash;
        data["userAvatarUrl"] = this.userAvatarUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface IMessageAprover {
    userId?: string;
    userName?: string;
    userAvatarHash?: string;
    userAvatarUrl?: string;
    status?: string;
}

export class MessageDto implements IMessageDto {
    originalUrl?: string;
    subject?: string;
    bodyPreview?: string;
    body?: string;
    bodyHtml?: string;
    sender?: ContactDto;
    attachments?: AttachmentDto[];

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalUrl = _data["originalUrl"];
            this.subject = _data["subject"];
            this.bodyPreview = _data["bodyPreview"];
            this.body = _data["body"];
            this.bodyHtml = _data["bodyHtml"];
            this.sender = _data["sender"] ? ContactDto.fromJS(_data["sender"]) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalUrl"] = this.originalUrl;
        data["subject"] = this.subject;
        data["bodyPreview"] = this.bodyPreview;
        data["body"] = this.body;
        data["bodyHtml"] = this.bodyHtml;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageDto {
    originalUrl?: string;
    subject?: string;
    bodyPreview?: string;
    body?: string;
    bodyHtml?: string;
    sender?: ContactDto;
    attachments?: AttachmentDto[];
}

export class MicrosoftProjectItemIdentity implements IMicrosoftProjectItemIdentity {
    title!: string;
    projectId!: string;
    documentPath?: string | undefined;
    isCloud!: boolean;

    constructor(data?: IMicrosoftProjectItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.documentPath = _data["documentPath"];
            this.isCloud = _data["isCloud"];
        }
    }

    static fromJS(data: any): MicrosoftProjectItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftProjectItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["documentPath"] = this.documentPath;
        data["isCloud"] = this.isCloud;
        return data;
    }
}

export interface IMicrosoftProjectItemIdentity {
    title: string;
    projectId: string;
    documentPath?: string | undefined;
    isCloud: boolean;
}

export class MicrosoftProjectTaskItemIdentity implements IMicrosoftProjectTaskItemIdentity {
    title!: string;
    taskId!: string;
    projectId?: string;
    documentPath?: string | undefined;
    isCloud!: boolean;

    constructor(data?: IMicrosoftProjectTaskItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
            this.documentPath = _data["documentPath"];
            this.isCloud = _data["isCloud"];
        }
    }

    static fromJS(data: any): MicrosoftProjectTaskItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftProjectTaskItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        data["documentPath"] = this.documentPath;
        data["isCloud"] = this.isCloud;
        return data;
    }
}

export interface IMicrosoftProjectTaskItemIdentity {
    title: string;
    taskId: string;
    projectId?: string;
    documentPath?: string | undefined;
    isCloud: boolean;
}

export class MyWorkspaceInputDto implements IMyWorkspaceInputDto {
    name!: string;

    constructor(data?: IMyWorkspaceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MyWorkspaceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyWorkspaceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IMyWorkspaceInputDto {
    name: string;
}

export class OrganizationDetailsDto implements IOrganizationDetailsDto {
    organization!: OrganizationDto;
    members!: MemberDto[];
    teams!: TeamDto[];
    workspaces!: WorkspaceDto[];
    invites!: OrganizationInvite[];
    canManage!: boolean;

    constructor(data?: IOrganizationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organization = new OrganizationDto();
            this.members = [];
            this.teams = [];
            this.workspaces = [];
            this.invites = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : new OrganizationDto();
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MemberDto.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamDto.fromJS(item));
            }
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(WorkspaceDto.fromJS(item));
            }
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(OrganizationInvite.fromJS(item));
            }
            this.canManage = _data["canManage"];
        }
    }

    static fromJS(data: any): OrganizationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item.toJSON());
        }
        data["canManage"] = this.canManage;
        return data;
    }
}

export interface IOrganizationDetailsDto {
    organization: OrganizationDto;
    members: MemberDto[];
    teams: TeamDto[];
    workspaces: WorkspaceDto[];
    invites: OrganizationInvite[];
    canManage: boolean;
}

export class OrganizationDto implements IOrganizationDto {
    id!: number;
    name?: string;
    description?: string | undefined;
    ownerId!: number;
    teams?: TeamFlatDto[];
    userOptions?: OrganizationUserOptions;
    canManage!: boolean;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamFlatDto.fromJS(item));
            }
            this.userOptions = _data["userOptions"] ? OrganizationUserOptions.fromJS(_data["userOptions"]) : <any>undefined;
            this.canManage = _data["canManage"];
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["userOptions"] = this.userOptions ? this.userOptions.toJSON() : <any>undefined;
        data["canManage"] = this.canManage;
        return data;
    }
}

export interface IOrganizationDto {
    id: number;
    name?: string;
    description?: string | undefined;
    ownerId: number;
    teams?: TeamFlatDto[];
    userOptions?: OrganizationUserOptions;
    canManage: boolean;
}

export class OrganizationInputDto implements IOrganizationInputDto {
    name!: string;
    desciption?: string | undefined;

    constructor(data?: IOrganizationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.desciption = _data["desciption"];
        }
    }

    static fromJS(data: any): OrganizationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["desciption"] = this.desciption;
        return data;
    }
}

export interface IOrganizationInputDto {
    name: string;
    desciption?: string | undefined;
}

export class OrganizationInvite implements IOrganizationInvite {
    readonly id!: string;
    organizationId!: number;
    teams?: Team[];
    email!: string;
    expitedDate!: Date;
    role?: MembershipsRoles;

    constructor(data?: IOrganizationInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            this.email = _data["email"];
            this.expitedDate = _data["expitedDate"] ? new Date(_data["expitedDate"].toString()) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): OrganizationInvite {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["email"] = this.email;
        data["expitedDate"] = this.expitedDate ? this.expitedDate.toISOString() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IOrganizationInvite {
    id: string;
    organizationId: number;
    teams?: Team[];
    email: string;
    expitedDate: Date;
    role?: MembershipsRoles;
}

export class OrganizationUserOptions implements IOrganizationUserOptions {
    code?: string | undefined;
    color?: string | undefined;

    constructor(data?: IOrganizationUserOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): OrganizationUserOptions {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface IOrganizationUserOptions {
    code?: string | undefined;
    color?: string | undefined;
}

export class PageItemIdentity implements IPageItemIdentity {
    title!: string;
    pageUrl!: string;

    constructor(data?: IPageItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.pageUrl = _data["pageUrl"];
        }
    }

    static fromJS(data: any): PageItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new PageItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["pageUrl"] = this.pageUrl;
        return data;
    }
}

export interface IPageItemIdentity {
    title: string;
    pageUrl: string;
}

export class PaneData implements IPaneData {
    target?: ItemDataDto;
    workspace?: WorkspaceDto;
    tasks?: IActivityItemData[];
    emails?: IEmailItemData[];
    bookmarks?: IBookmarkItemData[];
    contacts?: IContactItemData[];
    channels?: IChannelItemData[];
    documents?: IDocumentItemData[];
    timers?: Timer[];
    checklists?: Checklist[];
    refId!: string;

    constructor(data?: IPaneData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"] ? ItemDataDto.fromJS(_data["target"]) : <any>undefined;
            this.workspace = _data["workspace"] ? WorkspaceDto.fromJS(_data["workspace"]) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(IActivityItemData.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(IEmailItemData.fromJS(item));
            }
            if (Array.isArray(_data["bookmarks"])) {
                this.bookmarks = [] as any;
                for (let item of _data["bookmarks"])
                    this.bookmarks!.push(IBookmarkItemData.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(IContactItemData.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(IChannelItemData.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(IDocumentItemData.fromJS(item));
            }
            if (Array.isArray(_data["timers"])) {
                this.timers = [] as any;
                for (let item of _data["timers"])
                    this.timers!.push(Timer.fromJS(item));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(Checklist.fromJS(item));
            }
            this.refId = _data["refId"];
        }
    }

    static fromJS(data: any): PaneData {
        data = typeof data === 'object' ? data : {};
        let result = new PaneData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["workspace"] = this.workspace ? this.workspace.toJSON() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.bookmarks)) {
            data["bookmarks"] = [];
            for (let item of this.bookmarks)
                data["bookmarks"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.timers)) {
            data["timers"] = [];
            for (let item of this.timers)
                data["timers"].push(item.toJSON());
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        data["refId"] = this.refId;
        return data;
    }
}

export interface IPaneData {
    target?: ItemDataDto;
    workspace?: WorkspaceDto;
    tasks?: IActivityItemData[];
    emails?: IEmailItemData[];
    bookmarks?: IBookmarkItemData[];
    contacts?: IContactItemData[];
    channels?: IChannelItemData[];
    documents?: IDocumentItemData[];
    timers?: Timer[];
    checklists?: Checklist[];
    refId: string;
}

export class PaneItemIdentity implements IPaneItemIdentity {
    paneType!: PaneType;
    keywords?: string[] | undefined;
    host?: string | undefined;
    originalUrl?: string | undefined;
    activity?: ActivityItemIdentity;
    page?: PageItemIdentity;
    mail?: MailItemIdentity;
    contact?: ContactItemIdentity;
    channel?: ChannelItemIdentity;
    document?: DocumentItemIdentity;
    microsoftProject?: MicrosoftProjectItemIdentity;
    microsoftProjectTask?: MicrosoftProjectTaskItemIdentity;

    constructor(data?: IPaneItemIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paneType = _data["paneType"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.host = _data["host"];
            this.originalUrl = _data["originalUrl"];
            this.activity = _data["activity"] ? ActivityItemIdentity.fromJS(_data["activity"]) : <any>undefined;
            this.page = _data["page"] ? PageItemIdentity.fromJS(_data["page"]) : <any>undefined;
            this.mail = _data["mail"] ? MailItemIdentity.fromJS(_data["mail"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactItemIdentity.fromJS(_data["contact"]) : <any>undefined;
            this.channel = _data["channel"] ? ChannelItemIdentity.fromJS(_data["channel"]) : <any>undefined;
            this.document = _data["document"] ? DocumentItemIdentity.fromJS(_data["document"]) : <any>undefined;
            this.microsoftProject = _data["microsoftProject"] ? MicrosoftProjectItemIdentity.fromJS(_data["microsoftProject"]) : <any>undefined;
            this.microsoftProjectTask = _data["microsoftProjectTask"] ? MicrosoftProjectTaskItemIdentity.fromJS(_data["microsoftProjectTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaneItemIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new PaneItemIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paneType"] = this.paneType;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["host"] = this.host;
        data["originalUrl"] = this.originalUrl;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["mail"] = this.mail ? this.mail.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["microsoftProject"] = this.microsoftProject ? this.microsoftProject.toJSON() : <any>undefined;
        data["microsoftProjectTask"] = this.microsoftProjectTask ? this.microsoftProjectTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaneItemIdentity {
    paneType: PaneType;
    keywords?: string[] | undefined;
    host?: string | undefined;
    originalUrl?: string | undefined;
    activity?: ActivityItemIdentity;
    page?: PageItemIdentity;
    mail?: MailItemIdentity;
    contact?: ContactItemIdentity;
    channel?: ChannelItemIdentity;
    document?: DocumentItemIdentity;
    microsoftProject?: MicrosoftProjectItemIdentity;
    microsoftProjectTask?: MicrosoftProjectTaskItemIdentity;
}

export enum PaneType {
    NotSet = "NotSet",
    TeamsChannel = "TeamsChannel",
    BrowserPage = "BrowserPage",
    WebMail = "WebMail",
    AdobeDocument = "AdobeDocument",
    OfficeDocument = "OfficeDocument",
    Document = "Document",
    Contact = "Contact",
    Activity = "Activity",
    MircosoftProjectProject = "MircosoftProjectProject",
    MircosoftProjectTask = "MircosoftProjectTask",
    App = "App",
}

export class PostMessageAttachment implements IPostMessageAttachment {
    id?: string;
    fileName?: string;
    contentType?: string;

    constructor(data?: IPostMessageAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): PostMessageAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new PostMessageAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IPostMessageAttachment {
    id?: string;
    fileName?: string;
    contentType?: string;
}

export class PostMessageRequest implements IPostMessageRequest {
    text?: string;
    approverIds?: string[];
    attachmentIds?: PostMessageAttachment[];
    isPrivate!: boolean;

    constructor(data?: IPostMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["approverIds"])) {
                this.approverIds = [] as any;
                for (let item of _data["approverIds"])
                    this.approverIds!.push(item);
            }
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(PostMessageAttachment.fromJS(item));
            }
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): PostMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.approverIds)) {
            data["approverIds"] = [];
            for (let item of this.approverIds)
                data["approverIds"].push(item);
        }
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item.toJSON());
        }
        data["isPrivate"] = this.isPrivate;
        return data;
    }
}

export interface IPostMessageRequest {
    text?: string;
    approverIds?: string[];
    attachmentIds?: PostMessageAttachment[];
    isPrivate: boolean;
}

export class PostTimeEntryRequest implements IPostTimeEntryRequest {
    text?: string;
    hours!: number;
    isBillable!: boolean;
    timeEntryActivityId?: string | undefined;
    timerId?: string | undefined;
    postedTime?: Date | undefined;

    constructor(data?: IPostTimeEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.hours = _data["hours"];
            this.isBillable = _data["isBillable"];
            this.timeEntryActivityId = _data["timeEntryActivityId"];
            this.timerId = _data["timerId"];
            this.postedTime = _data["postedTime"] ? new Date(_data["postedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PostTimeEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostTimeEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["hours"] = this.hours;
        data["isBillable"] = this.isBillable;
        data["timeEntryActivityId"] = this.timeEntryActivityId;
        data["timerId"] = this.timerId;
        data["postedTime"] = this.postedTime ? this.postedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPostTimeEntryRequest {
    text?: string;
    hours: number;
    isBillable: boolean;
    timeEntryActivityId?: string | undefined;
    timerId?: string | undefined;
    postedTime?: Date | undefined;
}

export class PostTimeEntryResponse implements IPostTimeEntryResponse {
    timeEntryId?: string | undefined;
    text?: string | undefined;
    hours!: number;
    spendOn!: Date;
    createdOn?: Date | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    updatedOn?: Date | undefined;
    activityClientId?: string | undefined;
    projectClientId?: string | undefined;
    timeEntryActivittyClientId?: string | undefined;
    isBillable!: boolean;

    constructor(data?: IPostTimeEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeEntryId = _data["timeEntryId"];
            this.text = _data["text"];
            this.hours = _data["hours"];
            this.spendOn = _data["spendOn"] ? new Date(_data["spendOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.activityClientId = _data["activityClientId"];
            this.projectClientId = _data["projectClientId"];
            this.timeEntryActivittyClientId = _data["timeEntryActivittyClientId"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): PostTimeEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostTimeEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeEntryId"] = this.timeEntryId;
        data["text"] = this.text;
        data["hours"] = this.hours;
        data["spendOn"] = this.spendOn ? this.spendOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["activityClientId"] = this.activityClientId;
        data["projectClientId"] = this.projectClientId;
        data["timeEntryActivittyClientId"] = this.timeEntryActivittyClientId;
        data["isBillable"] = this.isBillable;
        return data;
    }
}

export interface IPostTimeEntryResponse {
    timeEntryId?: string | undefined;
    text?: string | undefined;
    hours: number;
    spendOn: Date;
    createdOn?: Date | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    updatedOn?: Date | undefined;
    activityClientId?: string | undefined;
    projectClientId?: string | undefined;
    timeEntryActivittyClientId?: string | undefined;
    isBillable: boolean;
}

export class PrepareAttachmentResponse implements IPrepareAttachmentResponse {
    url?: string;
    token?: string;
    headers?: string[];

    constructor(data?: IPrepareAttachmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.token = _data["token"];
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
        }
    }

    static fromJS(data: any): PrepareAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrepareAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["token"] = this.token;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        return data;
    }
}

export interface IPrepareAttachmentResponse {
    url?: string;
    token?: string;
    headers?: string[];
}

export enum Priorities {
    Default = "Default",
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export class PriorityDto implements IPriorityDto {
    priorityOrder!: number;
    predefined?: Priorities;
    isDefault!: boolean;
    name!: string;
    readonly id!: string;
    accountId!: number;
    readonly clientId!: string;
    syncStatus?: SyncEntityStatus;

    constructor(data?: IPriorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priorityOrder = _data["priorityOrder"];
            this.predefined = _data["predefined"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            (<any>this).id = _data["id"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.syncStatus = _data["syncStatus"];
        }
    }

    static fromJS(data: any): PriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorityOrder"] = this.priorityOrder;
        data["predefined"] = this.predefined;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["syncStatus"] = this.syncStatus;
        return data;
    }
}

export interface IPriorityDto {
    priorityOrder: number;
    predefined?: Priorities;
    isDefault: boolean;
    name: string;
    id: string;
    accountId: number;
    clientId: string;
    syncStatus?: SyncEntityStatus;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProjectFindByInput implements IProjectFindByInput {
    findBy!: ProjectFindByType;
    value!: string;

    constructor(data?: IProjectFindByInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.findBy = _data["findBy"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectFindByInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFindByInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["findBy"] = this.findBy;
        data["value"] = this.value;
        return data;
    }
}

export interface IProjectFindByInput {
    findBy: ProjectFindByType;
    value: string;
}

export enum ProjectFindByType {
    Id = "Id",
    Name = "Name",
    ClientId = "ClientId",
}

export class ProjectLookupItem implements IProjectLookupItem {
    readonly id!: string;
    readonly fullId?: string;
    accountId!: number;
    readonly clientId!: string;
    name!: string;
    progress!: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectStatusId!: string;
    projectStatusName?: string | undefined;
    projectStatusTreatAsCompleted?: boolean | undefined;
    description?: string;
    accountIconUrl?: string;
    service?: ServiceProvider;
    displayId?: string;
    color?: string;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    trackerId?: string | undefined;
    trackerName?: string | undefined;
    portfolioId?: string | undefined;
    portfolioName?: string | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    members?: ProjectMember[] | undefined;
    categories?: Category[] | undefined;

    constructor(data?: IProjectLookupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).fullId = _data["fullId"];
            this.accountId = _data["accountId"];
            (<any>this).clientId = _data["clientId"];
            this.name = _data["name"];
            this.progress = _data["progress"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.projectStatusId = _data["projectStatusId"];
            this.projectStatusName = _data["projectStatusName"];
            this.projectStatusTreatAsCompleted = _data["projectStatusTreatAsCompleted"];
            this.description = _data["description"];
            this.accountIconUrl = _data["accountIconUrl"];
            this.service = _data["service"];
            this.displayId = _data["displayId"];
            this.color = _data["color"];
            this.priorityId = _data["priorityId"];
            this.priorityName = _data["priorityName"];
            this.trackerId = _data["trackerId"];
            this.trackerName = _data["trackerName"];
            this.portfolioId = _data["portfolioId"];
            this.portfolioName = _data["portfolioName"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(ProjectMember.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectLookupItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLookupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullId"] = this.fullId;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["progress"] = this.progress;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["projectStatusId"] = this.projectStatusId;
        data["projectStatusName"] = this.projectStatusName;
        data["projectStatusTreatAsCompleted"] = this.projectStatusTreatAsCompleted;
        data["description"] = this.description;
        data["accountIconUrl"] = this.accountIconUrl;
        data["service"] = this.service;
        data["displayId"] = this.displayId;
        data["color"] = this.color;
        data["priorityId"] = this.priorityId;
        data["priorityName"] = this.priorityName;
        data["trackerId"] = this.trackerId;
        data["trackerName"] = this.trackerName;
        data["portfolioId"] = this.portfolioId;
        data["portfolioName"] = this.portfolioName;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectLookupItem {
    id: string;
    fullId?: string;
    accountId: number;
    clientId: string;
    name: string;
    progress: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    projectStatusId: string;
    projectStatusName?: string | undefined;
    projectStatusTreatAsCompleted?: boolean | undefined;
    description?: string;
    accountIconUrl?: string;
    service?: ServiceProvider;
    displayId?: string;
    color?: string;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    trackerId?: string | undefined;
    trackerName?: string | undefined;
    portfolioId?: string | undefined;
    portfolioName?: string | undefined;
    parentId?: string | undefined;
    parentName?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    members?: ProjectMember[] | undefined;
    categories?: Category[] | undefined;
}

export class ProjectLookupItemPagedResultDto implements IProjectLookupItemPagedResultDto {
    totalCount!: number;
    items?: ProjectLookupItem[];

    constructor(data?: IProjectLookupItemPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectLookupItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectLookupItemPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLookupItemPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectLookupItemPagedResultDto {
    totalCount: number;
    items?: ProjectLookupItem[];
}

export class ProjectMember implements IProjectMember {
    userId?: string | undefined;
    groupId?: string | undefined;
    email?: string;
    roleName?: string | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;
    isGroup!: boolean;
    name?: string;

    constructor(data?: IProjectMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.groupId = _data["groupId"];
            this.email = _data["email"];
            this.roleName = _data["roleName"];
            this.avatarHash = _data["avatarHash"];
            this.avatarUrl = _data["avatarUrl"];
            this.isGroup = _data["isGroup"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectMember {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["groupId"] = this.groupId;
        data["email"] = this.email;
        data["roleName"] = this.roleName;
        data["avatarHash"] = this.avatarHash;
        data["avatarUrl"] = this.avatarUrl;
        data["isGroup"] = this.isGroup;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectMember {
    userId?: string | undefined;
    groupId?: string | undefined;
    email?: string;
    roleName?: string | undefined;
    avatarHash?: string | undefined;
    avatarUrl?: string | undefined;
    isGroup: boolean;
    name?: string;
}

export class ScheduleResponse implements IScheduleResponse {
    numberOfHoursPerDay?: number | undefined;
    weekendsAsWorkdays?: boolean | undefined;
    publicHolidays?: Holiday[] | undefined;

    constructor(data?: IScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfHoursPerDay = _data["numberOfHoursPerDay"];
            this.weekendsAsWorkdays = _data["weekendsAsWorkdays"];
            if (Array.isArray(_data["publicHolidays"])) {
                this.publicHolidays = [] as any;
                for (let item of _data["publicHolidays"])
                    this.publicHolidays!.push(Holiday.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfHoursPerDay"] = this.numberOfHoursPerDay;
        data["weekendsAsWorkdays"] = this.weekendsAsWorkdays;
        if (Array.isArray(this.publicHolidays)) {
            data["publicHolidays"] = [];
            for (let item of this.publicHolidays)
                data["publicHolidays"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduleResponse {
    numberOfHoursPerDay?: number | undefined;
    weekendsAsWorkdays?: boolean | undefined;
    publicHolidays?: Holiday[] | undefined;
}

export enum ServiceProvider {
    Unknown = "Unknown",
    Redmine = "Redmine",
    EasyRedmine = "EasyRedmine",
    Plano = "Plano",
    EasyProjects = "EasyProjects",
    Jira = "Jira",
    Asana = "Asana",
    Fake = "Fake",
    TestData = "TestData",
    HubSpot = "HubSpot",
    Office365 = "Office365",
    Google = "Google",
}

export class SetDatesRequest implements ISetDatesRequest {
    start?: Date | undefined;
    end?: Date | undefined;
    days?: number | undefined;
    hours?: number | undefined;

    constructor(data?: ISetDatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.days = _data["days"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): SetDatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["days"] = this.days;
        data["hours"] = this.hours;
        return data;
    }
}

export interface ISetDatesRequest {
    start?: Date | undefined;
    end?: Date | undefined;
    days?: number | undefined;
    hours?: number | undefined;
}

export class ShouldContactSupportReason implements IShouldContactSupportReason {

    constructor(data?: IShouldContactSupportReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ShouldContactSupportReason {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldContactSupportReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IShouldContactSupportReason {
}

export class SignInInfoResult implements ISignInInfoResult {
    isRegistered!: boolean;
    isRegistrationRequired!: boolean;
    auth0Uid?: string | undefined;

    constructor(data?: ISignInInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRegistered = _data["isRegistered"];
            this.isRegistrationRequired = _data["isRegistrationRequired"];
            this.auth0Uid = _data["auth0Uid"];
        }
    }

    static fromJS(data: any): SignInInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignInInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRegistered"] = this.isRegistered;
        data["isRegistrationRequired"] = this.isRegistrationRequired;
        data["auth0Uid"] = this.auth0Uid;
        return data;
    }
}

export interface ISignInInfoResult {
    isRegistered: boolean;
    isRegistrationRequired: boolean;
    auth0Uid?: string | undefined;
}

export enum SyncEntityStatus {
    Unknown = "Unknown",
    NotLoaded = "NotLoaded",
    NotAvailable = "NotAvailable",
    PreLoaded = "PreLoaded",
    Synced = "Synced",
    New = "New",
    Updated = "Updated",
    Deleted = "Deleted",
}

export enum SyncOperationStatus {
    Unknown = "Unknown",
    Waiting = "Waiting",
    InProgress = "InProgress",
    Failed = "Failed",
    Canceled = "Canceled",
    Success = "Success",
    Unathorized = "Unathorized",
}

export enum SyncOperationType {
    NotSet = "NotSet",
    InitialSync = "InitialSync",
    SystemLists = "SystemLists",
    IncrementalSync = "IncrementalSync",
    FullSync = "FullSync",
    PrivacyData = "PrivacyData",
}

export class SyncStateInfo implements ISyncStateInfo {
    operationType?: SyncOperationType;
    accountId!: number;
    createdAt?: Date | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    status?: SyncOperationStatus;
    readonly isCompleted!: boolean;
    readonly isSuccess!: boolean;
    readonly isFailed!: boolean;
    errorMessage?: string | undefined;
    errorDetails?: string | undefined;
    createdReason?: CreatedReason;

    constructor(data?: ISyncStateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.accountId = _data["accountId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            (<any>this).isCompleted = _data["isCompleted"];
            (<any>this).isSuccess = _data["isSuccess"];
            (<any>this).isFailed = _data["isFailed"];
            this.errorMessage = _data["errorMessage"];
            this.errorDetails = _data["errorDetails"];
            this.createdReason = _data["createdReason"];
        }
    }

    static fromJS(data: any): SyncStateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SyncStateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["accountId"] = this.accountId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["isCompleted"] = this.isCompleted;
        data["isSuccess"] = this.isSuccess;
        data["isFailed"] = this.isFailed;
        data["errorMessage"] = this.errorMessage;
        data["errorDetails"] = this.errorDetails;
        data["createdReason"] = this.createdReason;
        return data;
    }
}

export interface ISyncStateInfo {
    operationType?: SyncOperationType;
    accountId: number;
    createdAt?: Date | undefined;
    startedAt?: Date | undefined;
    finishedAt?: Date | undefined;
    status?: SyncOperationStatus;
    isCompleted: boolean;
    isSuccess: boolean;
    isFailed: boolean;
    errorMessage?: string | undefined;
    errorDetails?: string | undefined;
    createdReason?: CreatedReason;
}

export class Team implements ITeam {
    name!: string;
    organizationId!: number;
    workspaces?: Workspace[];
    userOptions?: TeamUserOptions;
    id!: number;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["workspaces"])) {
                this.workspaces = [] as any;
                for (let item of _data["workspaces"])
                    this.workspaces!.push(Workspace.fromJS(item));
            }
            this.userOptions = _data["userOptions"] ? TeamUserOptions.fromJS(_data["userOptions"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.workspaces)) {
            data["workspaces"] = [];
            for (let item of this.workspaces)
                data["workspaces"].push(item.toJSON());
        }
        data["userOptions"] = this.userOptions ? this.userOptions.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITeam {
    name: string;
    organizationId: number;
    workspaces?: Workspace[];
    userOptions?: TeamUserOptions;
    id: number;
}

export class TeamDto implements ITeamDto {
    id!: number;
    organizationId!: number;
    name?: string;
    userOptions?: TeamUserOptions;
    canManage!: boolean;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.userOptions = _data["userOptions"] ? TeamUserOptions.fromJS(_data["userOptions"]) : <any>undefined;
            this.canManage = _data["canManage"];
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["userOptions"] = this.userOptions ? this.userOptions.toJSON() : <any>undefined;
        data["canManage"] = this.canManage;
        return data;
    }
}

export interface ITeamDto {
    id: number;
    organizationId: number;
    name?: string;
    userOptions?: TeamUserOptions;
    canManage: boolean;
}

export class TeamFlatDto implements ITeamFlatDto {
    id!: number;
    name?: string;

    constructor(data?: ITeamFlatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TeamFlatDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamFlatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITeamFlatDto {
    id: number;
    name?: string;
}

export class TeamInputDto implements ITeamInputDto {
    name!: string;
    color?: string;

    constructor(data?: ITeamInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): TeamInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}

export interface ITeamInputDto {
    name: string;
    color?: string;
}

export class TeamUserOptions implements ITeamUserOptions {
    color?: string | undefined;
    icon?: string | undefined;

    constructor(data?: ITeamUserOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): TeamUserOptions {
        data = typeof data === 'object' ? data : {};
        let result = new TeamUserOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["icon"] = this.icon;
        return data;
    }
}

export interface ITeamUserOptions {
    color?: string | undefined;
    icon?: string | undefined;
}

export class TimeEntryActivityDto implements ITimeEntryActivityDto {
    name!: string;
    isDefault!: boolean;
    clientId!: string;

    constructor(data?: ITimeEntryActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): TimeEntryActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ITimeEntryActivityDto {
    name: string;
    isDefault: boolean;
    clientId: string;
}

export class Timer implements ITimer {
    readonly id!: string;
    description?: string | undefined;
    readonly startTime!: Date;
    readonly stopTime?: Date | undefined;
    readonly duration!: number;
    defaultActivityId?: number | undefined;
    defaultActivityAccountId?: number | undefined;
    defaultActivityClientId?: string | undefined;
    defaultActivity?: Activity;
    runs?: TimerRun[];
    posts?: TimerPostEntry[];
    readonly refId?: string | undefined;
    readonly workspaceId?: string | undefined;
    readonly isPosted!: boolean;
    readonly isActive!: boolean;
    activeRun?: TimerRun;

    constructor(data?: ITimer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.description = _data["description"];
            (<any>this).startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            (<any>this).stopTime = _data["stopTime"] ? new Date(_data["stopTime"].toString()) : <any>undefined;
            (<any>this).duration = _data["duration"];
            this.defaultActivityId = _data["defaultActivityId"];
            this.defaultActivityAccountId = _data["defaultActivityAccountId"];
            this.defaultActivityClientId = _data["defaultActivityClientId"];
            this.defaultActivity = _data["defaultActivity"] ? Activity.fromJS(_data["defaultActivity"]) : <any>undefined;
            if (Array.isArray(_data["runs"])) {
                this.runs = [] as any;
                for (let item of _data["runs"])
                    this.runs!.push(TimerRun.fromJS(item));
            }
            if (Array.isArray(_data["posts"])) {
                this.posts = [] as any;
                for (let item of _data["posts"])
                    this.posts!.push(TimerPostEntry.fromJS(item));
            }
            (<any>this).refId = _data["refId"];
            (<any>this).workspaceId = _data["workspaceId"];
            (<any>this).isPosted = _data["isPosted"];
            (<any>this).isActive = _data["isActive"];
            this.activeRun = _data["activeRun"] ? TimerRun.fromJS(_data["activeRun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Timer {
        data = typeof data === 'object' ? data : {};
        let result = new Timer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["stopTime"] = this.stopTime ? this.stopTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["defaultActivityId"] = this.defaultActivityId;
        data["defaultActivityAccountId"] = this.defaultActivityAccountId;
        data["defaultActivityClientId"] = this.defaultActivityClientId;
        data["defaultActivity"] = this.defaultActivity ? this.defaultActivity.toJSON() : <any>undefined;
        if (Array.isArray(this.runs)) {
            data["runs"] = [];
            for (let item of this.runs)
                data["runs"].push(item.toJSON());
        }
        if (Array.isArray(this.posts)) {
            data["posts"] = [];
            for (let item of this.posts)
                data["posts"].push(item.toJSON());
        }
        data["refId"] = this.refId;
        data["workspaceId"] = this.workspaceId;
        data["isPosted"] = this.isPosted;
        data["isActive"] = this.isActive;
        data["activeRun"] = this.activeRun ? this.activeRun.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimer {
    id: string;
    description?: string | undefined;
    startTime: Date;
    stopTime?: Date | undefined;
    duration: number;
    defaultActivityId?: number | undefined;
    defaultActivityAccountId?: number | undefined;
    defaultActivityClientId?: string | undefined;
    defaultActivity?: Activity;
    runs?: TimerRun[];
    posts?: TimerPostEntry[];
    refId?: string | undefined;
    workspaceId?: string | undefined;
    isPosted: boolean;
    isActive: boolean;
    activeRun?: TimerRun;
}

export class TimerPostEntry implements ITimerPostEntry {
    readonly id!: string;
    clientId?: string | undefined;
    description?: string | undefined;
    billable!: boolean;
    duration!: number;
    entryTime?: Date | undefined;
    readonly postedTime!: Date;
    readonly isPosted!: boolean;
    activity?: Activity;
    activityId?: number | undefined;
    activityClientId?: string | undefined;
    activityAccountId?: number | undefined;
    readonly postedToOriginalUrl?: string | undefined;
    readonly timerId!: string;

    constructor(data?: ITimerPostEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.clientId = _data["clientId"];
            this.description = _data["description"];
            this.billable = _data["billable"];
            this.duration = _data["duration"];
            this.entryTime = _data["entryTime"] ? new Date(_data["entryTime"].toString()) : <any>undefined;
            (<any>this).postedTime = _data["postedTime"] ? new Date(_data["postedTime"].toString()) : <any>undefined;
            (<any>this).isPosted = _data["isPosted"];
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
            this.activityId = _data["activityId"];
            this.activityClientId = _data["activityClientId"];
            this.activityAccountId = _data["activityAccountId"];
            (<any>this).postedToOriginalUrl = _data["postedToOriginalUrl"];
            (<any>this).timerId = _data["timerId"];
        }
    }

    static fromJS(data: any): TimerPostEntry {
        data = typeof data === 'object' ? data : {};
        let result = new TimerPostEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["description"] = this.description;
        data["billable"] = this.billable;
        data["duration"] = this.duration;
        data["entryTime"] = this.entryTime ? this.entryTime.toISOString() : <any>undefined;
        data["postedTime"] = this.postedTime ? this.postedTime.toISOString() : <any>undefined;
        data["isPosted"] = this.isPosted;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["activityId"] = this.activityId;
        data["activityClientId"] = this.activityClientId;
        data["activityAccountId"] = this.activityAccountId;
        data["postedToOriginalUrl"] = this.postedToOriginalUrl;
        data["timerId"] = this.timerId;
        return data;
    }
}

export interface ITimerPostEntry {
    id: string;
    clientId?: string | undefined;
    description?: string | undefined;
    billable: boolean;
    duration: number;
    entryTime?: Date | undefined;
    postedTime: Date;
    isPosted: boolean;
    activity?: Activity;
    activityId?: number | undefined;
    activityClientId?: string | undefined;
    activityAccountId?: number | undefined;
    postedToOriginalUrl?: string | undefined;
    timerId: string;
}

export class TimerRun implements ITimerRun {
    readonly id!: string;
    startTime!: Date;
    endTime?: Date | undefined;
    isManual!: boolean;
    duration?: number | undefined;
    readonly timerId!: string;
    readonly isActive!: boolean;

    constructor(data?: ITimerRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.isManual = _data["isManual"];
            this.duration = _data["duration"];
            (<any>this).timerId = _data["timerId"];
            (<any>this).isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TimerRun {
        data = typeof data === 'object' ? data : {};
        let result = new TimerRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isManual"] = this.isManual;
        data["duration"] = this.duration;
        data["timerId"] = this.timerId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITimerRun {
    id: string;
    startTime: Date;
    endTime?: Date | undefined;
    isManual: boolean;
    duration?: number | undefined;
    timerId: string;
    isActive: boolean;
}

export class TimerRunRequestDto implements ITimerRunRequestDto {
    startTime!: Date;
    endTime?: Date | undefined;
    isManual!: boolean;
    duration?: number | undefined;

    constructor(data?: ITimerRunRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.isManual = _data["isManual"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): TimerRunRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimerRunRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isManual"] = this.isManual;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ITimerRunRequestDto {
    startTime: Date;
    endTime?: Date | undefined;
    isManual: boolean;
    duration?: number | undefined;
}

export class TypeaheadInput implements ITypeaheadInput {
    skipCount?: number | undefined;
    maxResultCount?: number | undefined;
    filterBy?: string | undefined;
    filterByCompleted?: boolean | undefined;
    filterByAssignedToMe?: boolean | undefined;
    projectId?: string | undefined;
    types?: ItemType[];

    constructor(data?: ITypeaheadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.filterBy = _data["filterBy"];
            this.filterByCompleted = _data["filterByCompleted"];
            this.filterByAssignedToMe = _data["filterByAssignedToMe"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): TypeaheadInput {
        data = typeof data === 'object' ? data : {};
        let result = new TypeaheadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["filterBy"] = this.filterBy;
        data["filterByCompleted"] = this.filterByCompleted;
        data["filterByAssignedToMe"] = this.filterByAssignedToMe;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface ITypeaheadInput {
    skipCount?: number | undefined;
    maxResultCount?: number | undefined;
    filterBy?: string | undefined;
    filterByCompleted?: boolean | undefined;
    filterByAssignedToMe?: boolean | undefined;
    projectId?: string | undefined;
    types?: ItemType[];
}

export class TypeaheadResponse implements ITypeaheadResponse {
    tasks?: ActivityLookupItem[];
    projects?: LookupItem[];
    mails?: MailLookupItem[];
    bookmarks?: LookupItem[];
    contacts?: ContactLookupItem[];
    channels?: LookupItem[];
    documents?: DocumentLookupItem[];

    constructor(data?: ITypeaheadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ActivityLookupItem.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(LookupItem.fromJS(item));
            }
            if (Array.isArray(_data["mails"])) {
                this.mails = [] as any;
                for (let item of _data["mails"])
                    this.mails!.push(MailLookupItem.fromJS(item));
            }
            if (Array.isArray(_data["bookmarks"])) {
                this.bookmarks = [] as any;
                for (let item of _data["bookmarks"])
                    this.bookmarks!.push(LookupItem.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactLookupItem.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(LookupItem.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentLookupItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeaheadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TypeaheadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.mails)) {
            data["mails"] = [];
            for (let item of this.mails)
                data["mails"].push(item.toJSON());
        }
        if (Array.isArray(this.bookmarks)) {
            data["bookmarks"] = [];
            for (let item of this.bookmarks)
                data["bookmarks"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeaheadResponse {
    tasks?: ActivityLookupItem[];
    projects?: LookupItem[];
    mails?: MailLookupItem[];
    bookmarks?: LookupItem[];
    contacts?: ContactLookupItem[];
    channels?: LookupItem[];
    documents?: DocumentLookupItem[];
}

export class UpdateAccountInputDto implements IUpdateAccountInputDto {
    name!: string;
    accountUserOptions?: AccountUserOptions;
    extensionData?: AccountInfoExtensionData;

    constructor(data?: IUpdateAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountUserOptions = _data["accountUserOptions"] ? AccountUserOptions.fromJS(_data["accountUserOptions"]) : <any>undefined;
            this.extensionData = _data["extensionData"] ? AccountInfoExtensionData.fromJS(_data["extensionData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAccountInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountUserOptions"] = this.accountUserOptions ? this.accountUserOptions.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData ? this.extensionData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateAccountInputDto {
    name: string;
    accountUserOptions?: AccountUserOptions;
    extensionData?: AccountInfoExtensionData;
}

export class UpdateDescriptionRequest implements IUpdateDescriptionRequest {
    description?: string;

    constructor(data?: IUpdateDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateDescriptionRequest {
    description?: string;
}

export class UpdateUrlInputDto implements IUpdateUrlInputDto {
    webRoot!: string;

    constructor(data?: IUpdateUrlInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webRoot = _data["webRoot"];
        }
    }

    static fromJS(data: any): UpdateUrlInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUrlInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webRoot"] = this.webRoot;
        return data;
    }
}

export interface IUpdateUrlInputDto {
    webRoot: string;
}

export class UploadFileResponse implements IUploadFileResponse {
    id?: string;
    fileName?: string;
    contentType?: string;

    constructor(data?: IUploadFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): UploadFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IUploadFileResponse {
    id?: string;
    fileName?: string;
    contentType?: string;
}

export class UserSettings implements IUserSettings {
    defaultAccountId?: number | undefined;
    defaultTab?: string | undefined;
    defaultLinkedPaneTabs?: string[] | undefined;
    syncCalendar!: boolean;
    syncChecklists!: boolean;
    navigationMenuIsOpened!: boolean;
    currentOrganizationId?: number | undefined;

    constructor(data?: IUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.syncCalendar = true;
            this.syncChecklists = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultAccountId = _data["defaultAccountId"];
            this.defaultTab = _data["defaultTab"];
            if (Array.isArray(_data["defaultLinkedPaneTabs"])) {
                this.defaultLinkedPaneTabs = [] as any;
                for (let item of _data["defaultLinkedPaneTabs"])
                    this.defaultLinkedPaneTabs!.push(item);
            }
            this.syncCalendar = _data["syncCalendar"] !== undefined ? _data["syncCalendar"] : true;
            this.syncChecklists = _data["syncChecklists"] !== undefined ? _data["syncChecklists"] : true;
            this.navigationMenuIsOpened = _data["navigationMenuIsOpened"];
            this.currentOrganizationId = _data["currentOrganizationId"];
        }
    }

    static fromJS(data: any): UserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultAccountId"] = this.defaultAccountId;
        data["defaultTab"] = this.defaultTab;
        if (Array.isArray(this.defaultLinkedPaneTabs)) {
            data["defaultLinkedPaneTabs"] = [];
            for (let item of this.defaultLinkedPaneTabs)
                data["defaultLinkedPaneTabs"].push(item);
        }
        data["syncCalendar"] = this.syncCalendar;
        data["syncChecklists"] = this.syncChecklists;
        data["navigationMenuIsOpened"] = this.navigationMenuIsOpened;
        data["currentOrganizationId"] = this.currentOrganizationId;
        return data;
    }
}

export interface IUserSettings {
    defaultAccountId?: number | undefined;
    defaultTab?: string | undefined;
    defaultLinkedPaneTabs?: string[] | undefined;
    syncCalendar: boolean;
    syncChecklists: boolean;
    navigationMenuIsOpened: boolean;
    currentOrganizationId?: number | undefined;
}

export class VerifyAccountConnectionOutputDto implements IVerifyAccountConnectionOutputDto {
    accountId!: number;
    readonly isSuccessful!: boolean;
    result?: ConnectionVerifyResult;
    message?: string;

    constructor(data?: IVerifyAccountConnectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            (<any>this).isSuccessful = _data["isSuccessful"];
            this.result = _data["result"] ? ConnectionVerifyResult.fromJS(_data["result"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VerifyAccountConnectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyAccountConnectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["isSuccessful"] = this.isSuccessful;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IVerifyAccountConnectionOutputDto {
    accountId: number;
    isSuccessful: boolean;
    result?: ConnectionVerifyResult;
    message?: string;
}

export class VerifyUrlInputDto implements IVerifyUrlInputDto {
    serviceProvider!: ServiceProvider;
    webRoot!: string;

    constructor(data?: IVerifyUrlInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceProvider = _data["serviceProvider"];
            this.webRoot = _data["webRoot"];
        }
    }

    static fromJS(data: any): VerifyUrlInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyUrlInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceProvider"] = this.serviceProvider;
        data["webRoot"] = this.webRoot;
        return data;
    }
}

export interface IVerifyUrlInputDto {
    serviceProvider: ServiceProvider;
    webRoot: string;
}

export class VerifyUrlOutputDto implements IVerifyUrlOutputDto {
    serviceProvider?: ServiceProvider;
    webRoot?: string;
    resultType?: VerifyUrlResultType;
    readonly isSuccessful!: boolean;
    exception?: string;
    isPerSessionSignInRequired?: boolean | undefined;
    isSingleSignOnEnabled?: boolean | undefined;
    isSingleSignOnForced?: boolean | undefined;
    logoutUrl?: string;
    oAuthAuthorizeUrl?: string;
    oAuthSingleSignOnAuthorizeUrl?: string;
    oAuthTokenUrl?: string;
    singleSignOnButtonText?: string;

    constructor(data?: IVerifyUrlOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceProvider = _data["serviceProvider"];
            this.webRoot = _data["webRoot"];
            this.resultType = _data["resultType"];
            (<any>this).isSuccessful = _data["isSuccessful"];
            this.exception = _data["exception"];
            this.isPerSessionSignInRequired = _data["isPerSessionSignInRequired"];
            this.isSingleSignOnEnabled = _data["isSingleSignOnEnabled"];
            this.isSingleSignOnForced = _data["isSingleSignOnForced"];
            this.logoutUrl = _data["logoutUrl"];
            this.oAuthAuthorizeUrl = _data["oAuthAuthorizeUrl"];
            this.oAuthSingleSignOnAuthorizeUrl = _data["oAuthSingleSignOnAuthorizeUrl"];
            this.oAuthTokenUrl = _data["oAuthTokenUrl"];
            this.singleSignOnButtonText = _data["singleSignOnButtonText"];
        }
    }

    static fromJS(data: any): VerifyUrlOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyUrlOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceProvider"] = this.serviceProvider;
        data["webRoot"] = this.webRoot;
        data["resultType"] = this.resultType;
        data["isSuccessful"] = this.isSuccessful;
        data["exception"] = this.exception;
        data["isPerSessionSignInRequired"] = this.isPerSessionSignInRequired;
        data["isSingleSignOnEnabled"] = this.isSingleSignOnEnabled;
        data["isSingleSignOnForced"] = this.isSingleSignOnForced;
        data["logoutUrl"] = this.logoutUrl;
        data["oAuthAuthorizeUrl"] = this.oAuthAuthorizeUrl;
        data["oAuthSingleSignOnAuthorizeUrl"] = this.oAuthSingleSignOnAuthorizeUrl;
        data["oAuthTokenUrl"] = this.oAuthTokenUrl;
        data["singleSignOnButtonText"] = this.singleSignOnButtonText;
        return data;
    }
}

export interface IVerifyUrlOutputDto {
    serviceProvider?: ServiceProvider;
    webRoot?: string;
    resultType?: VerifyUrlResultType;
    isSuccessful: boolean;
    exception?: string;
    isPerSessionSignInRequired?: boolean | undefined;
    isSingleSignOnEnabled?: boolean | undefined;
    isSingleSignOnForced?: boolean | undefined;
    logoutUrl?: string;
    oAuthAuthorizeUrl?: string;
    oAuthSingleSignOnAuthorizeUrl?: string;
    oAuthTokenUrl?: string;
    singleSignOnButtonText?: string;
}

export enum VerifyUrlResultType {
    Valid = "Valid",
    Verified = "Verified",
    AddressNotFound = "AddressNotFound",
    ConnectionFailed = "ConnectionFailed",
    VersionNotSupport = "VersionNotSupport",
}

export class Watcher implements IWatcher {
    userId?: number | undefined;
    email?: string;

    constructor(data?: IWatcher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Watcher {
        data = typeof data === 'object' ? data : {};
        let result = new Watcher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data;
    }
}

export interface IWatcher {
    userId?: number | undefined;
    email?: string;
}

export class Workspace implements IWorkspace {
    readonly id!: string;
    name!: string;
    ownerId?: number | undefined;
    teamId?: number | undefined;
    readonly refId?: string | undefined;
    checklists?: Checklist[];
    timers?: Timer[];

    constructor(data?: IWorkspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.teamId = _data["teamId"];
            (<any>this).refId = _data["refId"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(Checklist.fromJS(item));
            }
            if (Array.isArray(_data["timers"])) {
                this.timers = [] as any;
                for (let item of _data["timers"])
                    this.timers!.push(Timer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Workspace {
        data = typeof data === 'object' ? data : {};
        let result = new Workspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["teamId"] = this.teamId;
        data["refId"] = this.refId;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        if (Array.isArray(this.timers)) {
            data["timers"] = [];
            for (let item of this.timers)
                data["timers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkspace {
    id: string;
    name: string;
    ownerId?: number | undefined;
    teamId?: number | undefined;
    refId?: string | undefined;
    checklists?: Checklist[];
    timers?: Timer[];
}

export class WorkspaceDto implements IWorkspaceDto {
    id!: string;
    name?: string | undefined;
    teamId?: number | undefined;
    team?: TeamFlatDto;
    ownerId?: number | undefined;
    refId?: string | undefined;
    members?: MemberDto[];
    items?: ItemDataDto[];
    canManage!: boolean;

    constructor(data?: IWorkspaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamFlatDto.fromJS(_data["team"]) : <any>undefined;
            this.ownerId = _data["ownerId"];
            this.refId = _data["refId"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MemberDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemDataDto.fromJS(item));
            }
            this.canManage = _data["canManage"];
        }
    }

    static fromJS(data: any): WorkspaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["ownerId"] = this.ownerId;
        data["refId"] = this.refId;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["canManage"] = this.canManage;
        return data;
    }
}

export interface IWorkspaceDto {
    id: string;
    name?: string | undefined;
    teamId?: number | undefined;
    team?: TeamFlatDto;
    ownerId?: number | undefined;
    refId?: string | undefined;
    members?: MemberDto[];
    items?: ItemDataDto[];
    canManage: boolean;
}

export class WorkspaceInputDto implements IWorkspaceInputDto {
    name!: string;
    teamId?: number | undefined;

    constructor(data?: IWorkspaceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): WorkspaceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface IWorkspaceInputDto {
    name: string;
    teamId?: number | undefined;
}

export class Keys implements IKeys {
    notSet?: string;
    mailByItemId?: string;
    mailByInternetMessageId?: string;
    mailBySubject?: string;
    mailByHeader?: string;
    mailByConversationId?: string;
    mailSenderAddress?: string;
    email?: string;
    relatedEmail?: string;
    originalUrl?: string;
    domain?: string;
    documentById?: string;
    documentByPath?: string;
    channelById?: string;

    constructor(data?: IKeys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notSet = _data["NotSet"];
            this.mailByItemId = _data["MailByItemId"];
            this.mailByInternetMessageId = _data["MailByInternetMessageId"];
            this.mailBySubject = _data["MailBySubject"];
            this.mailByHeader = _data["MailByHeader"];
            this.mailByConversationId = _data["MailByConversationId"];
            this.mailSenderAddress = _data["MailSenderAddress"];
            this.email = _data["Email"];
            this.relatedEmail = _data["RelatedEmail"];
            this.originalUrl = _data["OriginalUrl"];
            this.domain = _data["Domain"];
            this.documentById = _data["DocumentById"];
            this.documentByPath = _data["DocumentByPath"];
            this.channelById = _data["ChannelById"];
        }
    }

    static fromJS(data: any): Keys {
        data = typeof data === 'object' ? data : {};
        let result = new Keys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotSet"] = this.notSet;
        data["MailByItemId"] = this.mailByItemId;
        data["MailByInternetMessageId"] = this.mailByInternetMessageId;
        data["MailBySubject"] = this.mailBySubject;
        data["MailByHeader"] = this.mailByHeader;
        data["MailByConversationId"] = this.mailByConversationId;
        data["MailSenderAddress"] = this.mailSenderAddress;
        data["Email"] = this.email;
        data["RelatedEmail"] = this.relatedEmail;
        data["OriginalUrl"] = this.originalUrl;
        data["Domain"] = this.domain;
        data["DocumentById"] = this.documentById;
        data["DocumentByPath"] = this.documentByPath;
        data["ChannelById"] = this.channelById;
        return data;
    }
}

export interface IKeys {
    notSet?: string;
    mailByItemId?: string;
    mailByInternetMessageId?: string;
    mailBySubject?: string;
    mailByHeader?: string;
    mailByConversationId?: string;
    mailSenderAddress?: string;
    email?: string;
    relatedEmail?: string;
    originalUrl?: string;
    domain?: string;
    documentById?: string;
    documentByPath?: string;
    channelById?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}